import React, {useState,useEffect} from 'react'
import { Link as RouterLink} from 'react-router-dom'
import {AuthProvider,Display,useAuth} from '../../index'
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import { IoIosArrowBack } from 'react-icons/io'
import { MdModeEdit,MdKeyboardArrowDown,MdKeyboardArrowUp, MdKeyboardArrowRight } from 'react-icons/md'
import {BsSortAlphaDown, BsSortNumericDown, BsSortNumericUp} from 'react-icons/bs'
import { AiOutlineSortDescending} from 'react-icons/ai'
import { RiFileUploadLine } from 'react-icons/ri'
import { RxReload } from 'react-icons/rx'
import { PiSortAscendingLight } from 'react-icons/pi'
import { IoMdClose } from 'react-icons/io'
import { MdAutorenew } from 'react-icons/md'
import { ImBin2 } from 'react-icons/im'
import axios from 'axios'
import * as pdfjs from 'pdfjs-dist'
import PngImg from '../../images/sample.png'
import PngImg1 from './sample_expense.png'
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString()
pdfjs.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.mjs'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function AssetManagementPage(){
  //general
  const [demo,setDemo] = useState(false)
  const [loadMAssetData, setLoadMAssetData]=useState(false)
  const [shoppingCart3, setShoppingCart3] = useState([])
  const {login, shoppingCart1, shoppingCart2, auth2FA1, auth2FA2, user2, autoLogin, logout}=useAuth()
  const [userInfo, setUserInfo] = useState({membership:''})
  const [userFinanceDigest, setUserFinanceDigest] = useState('')
  const [userFinanceDigest2, setUserFinanceDigest2] = useState([{'expense': [{'date':'2020-05-31','timestamp': 1590908400,'total':'131752'},{'date':'2020-06-30','timestamp':'1593500400','total':'51942'}]}])
  const [userFinance, setUserFinance] = useState('')
  const [msg, setMsg] = useState('')
  const [page,setPage]=useState('asset')
  const [uploadMenu1,setUploadMenu1]=useState(false)
  const [uploadFile1, setUploadFile1] = useState([])
  const [uploadFile2, setUploadFile2] = useState(false)
  const [uploadFile3, setUploadFile3] = useState(PngImg)
  //asset
  const [assetPdfType,setAssetPdfType]=useState('asset_ddmmyyyy.pdf')
  const [assetEditMenu1,setAssetEditMenu1]=useState(false)
  const [assetEditMenu2,setAssetEditMenu2]=useState(false)
  const [assetDeleteMenu1,setAssetDeleteMenu1]=useState(false)
  const [assetDeleteMenu2,setAssetDeleteMenu2]=useState(false)
  const [assetAddOption,setAssetAddOption]=useState('')
  const [assetAdd,setAssetAdd]=useState({'date':''})
  const [assetEdit,setAssetEdit] = useState('')
  const [assetPrintLoading,setAssetPrintLoading]=useState(false)
  //income
  const [incomePdfType,setIncomePdfType]=useState('income_yyyy.pdf')
  const [incomeSelectedItem,setIncomeSelectedItem]=useState(0)
  const [incomeAddMenu1,setIncomeAddMenu1]=useState(false)
  const [incomeAddMenu2,setIncomeAddMenu2]=useState(false)
  const [incomeViewMenu1,setIncomeViewMenu1]=useState(true)
  const [incomeViewMenu2,setIncomeViewMenu2]=useState(true)
  const [incomeViewMenu3,setIncomeViewMenu3]=useState(true)
  const [incomeEditMenu1,setIncomeEditMenu1]=useState(false)
  const [incomeEditMenu2,setIncomeEditMenu2]=useState(false)
  const [incomeDeleteMenu1,setIncomeDeleteMenu1]=useState(false)
  const [incomeDeleteMenu2,setIncomeDeleteMenu2]=useState(false)
  const [incomeAddOption,setIncomeAddOption]=useState('')
  const [incomeAdd,setIncomeAdd]=useState({'date':''})
  const [incomeEdit,setIncomeEdit] = useState('')
  const [incomePrintLoading,setIncomePrintLoading]=useState(false)
  //expense
  const [expensePdfType,setExpensePdfType]=useState('expense_mmyyyy.pdf')
  const [expenseSelectedItem,setExpenseSelectedItem]=useState(0)
  const [expenseAddMenu1,setExpenseAddMenu1]=useState(false)
  const [expenseAddMenu2,setExpenseAddMenu2]=useState(false)
  const [expenseViewMenu1,setExpenseViewMenu1]=useState(false)
  const [expenseViewMenu2,setExpenseViewMenu2]=useState(false)
  const [expenseViewMenu3,setExpenseViewMenu3]=useState(false)
  const [expenseEditMenu1,setExpenseEditMenu1]=useState(false)
  const [expenseEditMenu2,setExpenseEditMenu2]=useState(false)
  const [expenseDeleteMenu1,setExpenseDeleteMenu1]=useState(false)
  const [expenseDeleteMenu2,setExpenseDeleteMenu2]=useState(false)
  const [expenseAddOption,setExpenseAddOption]=useState('')
  const [expenseEdit,setExpenseEdit] = useState('')
  const [expensePrintLoading,setExpensePrintLoading]=useState(false)
  const [expensePrintLoading2,setExpensePrintLoading2]=useState(false)
  const [expenseAdd,setExpenseAdd]=useState({
        'date':'2020-05-31','timestamp':1593500400,"total":0,
        'currency':'USD',
        "detail":[
            {
                "section":"food","section_total": 7290,"section_budget_min": 10000,"section_budget_max": 510000,"section_res": -20752,
                "detail":[
                    {
                        "category":"Must","category_total":0,
                        "items":[
                            {"name":"bread","amount":1,"price":0},
                            {"name":"butter","amount":1,"price":0},
                            {"name":"water","amount":1,"price":0},
                            {"name":"coffee","amount":1,"price":0}
                        ]
                    },
                    {
                        "category":"For Pantry","category_total":0,
                        "items":[
                            {"name":"noodle","amount":1,"price":0},
                            {"name":"noodle souce","amount":1,"price":0},
                            {"name":"dressing","amount":1,"price":0},
                            {"name":"instant soup","amount":1,"price":0},
                            {"name":"spicy oil","amount":1,"price":0}
                        ]
                    },
                    {
                        "category":"Sweets&Snacks","category_total":0,
                        "items":[
                            {"name":"ice cream","amount":5,"price":0},
                            {"name":"chocolate","amount":9,"price":0},
                            {"name":"refleshment","amount":1,"price":0},
                            {"name":"fish can","amount":4,"price":0},
                            {"name":"p\u00e2tisserie","amount":1,"price":0}
                        ]
                    },
                    {
                        "category":"Veggies","category_total":0,
                        "items":[
                            {"name":"spinatch","amount":1,"price":0},
                            {"name":"tomato","amount":3,"price":0},
                            {"name":"cabbage","amount":1,"price":0},
                            {"name":"green bell","amount":1,"price":0},
                            {"name":"chive","amount":1,"price":0}
                        ]
                    }
                ]
            },
            {
                "section":"other(cash)","section_total":0,
                "detail":[
                    {
                        "category":"Work","category_total":0,
                        "items":[
                            {"name":"book(work)","amount": 1,"price":0},
                            {"name":"book","amount": 2,"price":0},
                            {"name":"Kaspersky(work)","amount":1,"price":0},
                            {"name":"tranportation","amount":1,"price":0}
                        ]
                    },
                    {
                        "category":"Hangout","category_total":0,
                        "items": [
                            {"name":"pancake","amount":1,"price":0},
                            {"name":"burger","amount":1,"price":0}
                        ]
                    },
                    {
                        "category":"Better me","category_total":0,
                        "items": [
                            {"name":"body wash and cream","amount":1,"price":0},
                            {"name":"washing soap","amount":1,"price":0},
                            {"name": "hair cut & treatment","amount":1,"price":0},
                            {"name": "clothing","amount":1,"price":0}
                        ]
                    },
                    {
                        "category":"Emergency","category_total":0,
                        "items": [
                            {"name":"globe","amount":1,"price":0},
                            {"name":"skin clinic","amount":1,"price":0},
                            {"name":"tote bag","amount":1,"price":0},
                            {"name":"District Tax","amount":1,"price":0}
                    ]
                }
            ]
        },
        {
            "section":"credit,rent","section_total":0,
            "detail": [
                {
                    "category":"Credit","category_total":0,
                    "items":[
                        {"name":"phone","amount":1,"price":0}
                    ]
                },
                {
                    "category":"Rent","category_total":0,
                    "items":[
                        {"name": "Rent fee for next month","amount":1,"price":0}
                    ]
                }
            ]
        }
    ],
    "memo": "Your comment goes gere."
  })
  useEffect(() => {
  //if user is already logged in
  if(userInfo.membership==''&&user2){
    const handleSubmit = async (e) => {
    const { data: res } = await axios.post(`${APIURL}/account-info/finance`, {token:window.localStorage.getItem('token')})
    //   const { data: res } = await axios.post(`${APIURL}/account-info/finance3`, {token:window.localStorage.getItem('token')})
    if(res.msg==='user info ok'){    
        //premium or dev premium member
        setUserInfo(res.user)
        setUserFinance([res.finance])
        setUserFinanceDigest([res.finance])
        setExpenseAddOption(res.expense_new)
        setIncomeAddOption(res.income_new)
    //     setTimeout(() => {
    //         onClick2ExpenseLoadPdf()
    //   },90)
    }else{
        setMsg(res.msg)
        setUserFinance([res.finance])
        setUserFinanceDigest([res.finance])
    //     setTimeout(() => {
    //     localStorage.removeItem('user')
    //     localStorage.removeItem('token')
    //     logout()
    //   }, 3000)
      }
    }
  setTimeout(handleSubmit, 1)
  }else if(userInfo.membership==''){
    const handleSubmit = async (e) => {
    const { data: res } = await axios.get(`${APIURL}/account-info/finance/guest`)
    setMsg(res.msg)
    setUserFinance([res.finance])
    setUserFinanceDigest([res.finance])
    setIncomeAddOption(res.income_new)
    setExpenseAddOption(res.expense_new)
    console.log('guest',res)
    }
    setTimeout(handleSubmit, 2)
  }
  // const getMAssetData = async() =>{
      // if(user2){
        //  console.log('user2:,user2')
        // }
        // if(!loadMAssetData){
          //   setTimeout(getMAssetData, 2)
          //   setLoadMAssetData(true)
  // }
  },[])
  const onDrop2Upload=(e)=>{
    e.preventDefault()
    const x1=e.dataTransfer.files[0].name
    const x2=new FileReader()
    x2.readAsText(e.dataTransfer.files[0],'UTF-8')
    x2.onload=e=>{
        let x4=[]
        const x3=e.target.result
        x4.push({'id':Math.random().toString(36).substring(2),'filename':x1,'json':JSON.parse(x3)})
        setUploadFile1(uploadFile1.concat(x4))
        setUploadFile2(!uploadFile2)
    }
  }
  const onChange2Upload=(e)=>{
    e.preventDefault()
    const x1=e.target.files[0].name
    const x2=new FileReader()
    x2.readAsText(e.target.files[0],'UTF-8')
    x2.onload=e=>{
        let x4=[]
        const x3=e.target.result
        x4.push({'id':Math.random().toString(36).substring(2),'filename':x1,'json':JSON.parse(x3)})
        setUploadFile1(uploadFile1.concat(x4))
        setUploadFile2(!uploadFile2)
    }
  }
  const onClick2Upload=async(e)=>{
    e.preventDefault()
    if(userInfo.membership!=''){
        const {data:res}=await axios.post(`${APIURL}/asset/json/apply`,{token:window.localStorage.getItem('token'),'finance':uploadFile1[0].json})  
        setUserFinance([res.finance])
        setUserFinanceDigest([res.finance])
        setExpenseAddOption(res.expense_new)
    }else{
         const {data:res}=await axios.post(`${APIURL}/asset/json/apply/guest`,{'finance':uploadFile1[0].json})  
        setUserFinance([res.finance])
        setUserFinanceDigest([res.finance])
        setExpenseAddOption(res.expense_new)
    }
    setExpenseSelectedItem(0)
    setUploadMenu1(!uploadMenu1)
  }
  const onClick2UploadDel1 = (y) => { 
    setUploadFile1((x) => {return x.filter((x) => x.id !== y)})
  }
  const onClick2EncryptFile2=async()=>{
    const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync3`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'expense'})  
  }
  function add1M1KSprt(x1){
    if(page=='asset'){
        if(userFinance[0].asset.length!=0){
            //yen
            if(userFinance[0].asset[0].currency=='JPY'){
                if(x1.toString().length>6){
                    let x2=x1.toString().split('')
                    x2.splice(-6,0,',')
                    x2.splice(-3,0,',')
                    return x2.join('')
                }else if(x1.toString().length>3){
                    let x2=x1.toString().split('')
                    x2.splice(-3,0,',')
                    return x2.join('')
                }else{
                    return x1
                }
            }else{
                if(x1==null){
                    const a ='a'
                }else{
                    if(x1.toString().includes('.')){
                        if(x1.toString().length>12){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            x2.splice(-10,0,',')
                            x2.splice(-14,0,',')
                            return x2.join('')
                        }else if(x1.toString().length>9){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            x2.splice(-10,0,',')
                            return x2.join('')
                        }else if(x1.toString().length>6){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            return x2.join('')
                        }else{
                            return x1
                        }
                    }else{
                        if(x1.toString().length>9){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(-7,0,',')
                            x2.splice(-11,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else if(x1.toString().length>6){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(-7,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else if(x1.toString().length>3){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else{
                            let x2=x1.toString().split('')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }
                    }
                }
            }
    }
    }else if(page=='income'){
        if(userFinance[0].income.length!=0){
            //yen
            if(userFinance[0].income[incomeSelectedItem].currency=='JPY'){
                if(x1.toString().length>6){
                    let x2=x1.toString().split('')
                    x2.splice(-6,0,',')
                    x2.splice(-3,0,',')
                    return x2.join('')
                }else if(x1.toString().length>3){
                    let x2=x1.toString().split('')
                    x2.splice(-3,0,',')
                    return x2.join('')
                }else{
                    return x1
                }
            }else{
            //usd pnd
                if(x1==null){
                    const a='a'
                }else{
                    if(x1.toString().includes('.')){
                        if(x1.toString().length>12){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            x2.splice(-10,0,',')
                            x2.splice(-14,0,',')
                            return x2.join('')
                        }else if(x1.toString().length>9){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            x2.splice(-10,0,',')
                            return x2.join('')
                        }else if(x1.toString().length>6){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            return x2.join('')
                        }else{
                            return x1
                        }
                    }else{
                        if(x1.toString().length>9){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(-7,0,',')
                            x2.splice(-11,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else if(x1.toString().length>6){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(-7,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else if(x1.toString().length>3){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else{
                            let x2=x1.toString().split('')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }
                    }
                }
            }
        }
    }else if(page=='expense'){
        if(userFinance[0].expense.length!=0){
            //yen
            if(userFinance[0].expense[expenseSelectedItem].currency=='JPY'){
                if(x1.toString().length>6){
                    let x2=x1.toString().split('')
                    x2.splice(-6,0,',')
                    x2.splice(-3,0,',')
                    return x2.join('')
                }else if(x1.toString().length>3){
                    let x2=x1.toString().split('')
                    x2.splice(-3,0,',')
                    return x2.join('')
                }else{
                    return x1
                }
            }else{
            //usd pnd
                if(x1==null){
                    const a='a'
                }else{
                    if(x1.toString().includes('.')){
                        if(x1.toString().length>12){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            x2.splice(-10,0,',')
                            x2.splice(-14,0,',')
                            return x2.join('')
                        }else if(x1.toString().length>9){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            x2.splice(-10,0,',')
                            return x2.join('')
                        }else if(x1.toString().length>6){
                            let x2=x1.toString().split('')
                            x2.splice(-6,0,',')
                            return x2.join('')
                        }else{
                            return x1
                        }
                    }else{
                        if(x1.toString().length>9){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(-7,0,',')
                            x2.splice(-11,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else if(x1.toString().length>6){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(-7,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else if(x1.toString().length>3){
                            let x2=x1.toString().split('')
                            x2.splice(-3,0,',')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }else{
                            let x2=x1.toString().split('')
                            x2.splice(x2.length,0,'.00')
                            return x2.join('')
                        }
                    }
                }
            }
        }

    }
  }
  function calcAssetTtl(x1){
    // monthly salary
        //yearly   
        if(userFinance[0].asset[0].currency=='JPY'){
        //yen
            let x3=0
            for (let x2 of x1){
                x3+=Number(x2)
            }
            return x3
        }else{
        //usd
            let x3=0
            for (let x2 of x1){
                x3+=Number(x2)
            }
            return x3
        }
  }
  function calcIncomeTtl(x1){
    // monthly salary 0 base 1 overwork 2 transportation fee 3 tax deduct 4 other deduct
    if(x1.length==5){
        return Number(x1[0])+Number(x1[1])+Number(x1[2])-Number(x1[3])-Number(x1[4])
    }else if(x1.length==3){
    // bonus 0 base 1 tax deduct 2 other deduct
    return Number(x1[0])-Number(x1[1])-Number(x1[2])
    }else{
        let x3=0
        for (let x2 of x1){
            x3+=Number(x2)
        }
        return x3
    }
  }
  function calcExpenseTtl(x1){
        let x3=0
        for (let x2 of x1){
            x3+=Number(x2)
        }
        return x3
  }
  function stringDate(x1) {
    const x2=new Date(x1)
    const x3={year:'numeric',month:'long',day:'numeric'}
    return x2.toLocaleDateString('en-US',x3)
  }
  let pie_item1 = []
  let pie_ttl1 = 0
  let pie_others1 = 0
  let pie_item2 = []
  let pie_ttl2= 0
  let pie_others2 = 0
  let pie_item3 = []
  let pie_ttl3 = 0
  let pie_others3 = 0
  function asset_pie_calc(){
      pie_item1.push({'category':userFinance[0].asset[0].detail[0].category, 'ttl':userFinance[0].asset[0].detail[0].total_return})
      pie_item1.push({'category':userFinance[0].asset[0].detail[1].category, 'ttl':userFinance[0].asset[0].detail[1].total_return})
      pie_item1.push({'category':userFinance[0].asset[0].detail[2].category, 'ttl':userFinance[0].asset[0].detail[2].total_return})
      pie_item1.push({'category':userFinance[0].asset[0].detail[3].category, 'ttl':userFinance[0].asset[0].detail[3].total_return})
    for(let x1 of pie_item1){
        pie_ttl1+=x1.ttl
    }
    for(let x3 of pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl).slice(3,pie_item1.length)){
        pie_others1+=x3.ttl
    }
    return 
  }
  function income_pie_calc(){
      pie_item2.push({'category':userFinance[0].income[incomeSelectedItem].detail[0].salary[0].items[0].category, 'ttl':userFinance[0].income[incomeSelectedItem].detail[0].salary.map(x1=>Number(x1.items[0].value)).reduce((x1,x2)=>x1+x2,0)+userFinance[0].income[incomeSelectedItem].detail[0].bonus.map(x1=>Number(x1.items[0].value)).reduce((x1,x2)=>x1+x2,0)})
      pie_item2.push({'category':userFinance[0].income[incomeSelectedItem].detail[0].salary[0].items[1].category, 'ttl':userFinance[0].income[incomeSelectedItem].detail[0].salary.map(x1=>Number(x1.items[1].value)).reduce((x1,x2)=>x1+x2,0)})
      pie_item2.push({'category':userFinance[0].income[incomeSelectedItem].detail[0].salary[0].items[2].category, 'ttl':userFinance[0].income[incomeSelectedItem].detail[0].salary.map(x1=>Number(x1.items[2].value)).reduce((x1,x2)=>x1+x2,0)})
      pie_item2.push({'category':userFinance[0].income[incomeSelectedItem].detail[0].salary[0].items[3].category, 'ttl':userFinance[0].income[incomeSelectedItem].detail[0].salary.map(x1=>Number(x1.items[3].value)).reduce((x1,x2)=>x1+x2,0)+userFinance[0].income[incomeSelectedItem].detail[0].bonus.map(x1=>Number(x1.items[1].value)).reduce((x1,x2)=>x1+x2,0)})
      pie_item2.push({'category':userFinance[0].income[incomeSelectedItem].detail[0].salary[0].items[4].category, 'ttl':userFinance[0].income[incomeSelectedItem].detail[0].salary.map(x1=>Number(x1.items[4].value)).reduce((x1,x2)=>x1+x2,0)+userFinance[0].income[incomeSelectedItem].detail[0].bonus.map(x1=>Number(x1.items[2].value)).reduce((x1,x2)=>x1+x2,0)})
    for(let x1 of pie_item2){
        pie_ttl2+=x1.ttl
    }
    for(let x3 of pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl).slice(3,pie_item2.length)){
        pie_others2+=x3.ttl
    }
    return 
  }
  function expense_pie_calc(){
      pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].category, 'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items.map(x1=>x1.price))})
    pie_item3.push({'category':userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].category,'ttl':calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items.map(x1=>x1.price))})
    for(let x1 of pie_item3){
        pie_ttl3+=x1.ttl
    }
    for(let x3 of pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl).slice(3,pie_item3.length)){
        pie_others3+=x3.ttl
    }
    return 
  }
  const onClick2IncomeSelect=(x1,x2)=>{  
    if(x1=='date'){
        setIncomeAdd(x2)   
        setIncomeAddMenu2(!incomeAddMenu2)
    }
  } 
  const onClick2ExpenseSelect=(x1,x2)=>{  
    if(x1=='date'){
        setExpenseAdd({...expenseAdd, [x1]:x2.date,['timestamp']:x2.timestamp})   
        setExpenseAddMenu2(!expenseAddMenu2)
    }
  } 
  const onClick2IncomeCreate=async()=>{
    if (userFinance[0].income.length==0){
        userFinance[0].income[0]=incomeAdd
        setIncomeAddOption(incomeAddOption.filter((x)=>x.date!=incomeAdd.date))
        setIncomeAdd({'date':''}) 
        console.log(userFinance)
        if(userInfo.membership!=''){
            const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'income'})  
        }
    }else{
        const x1=userFinance[0].income.length
        for(let i1=0;i1<x1;i1++){
          if (userFinance[0].income[i1]['timestamp']>incomeAdd.timestamp){
            userFinance[0].income.splice(i1,0,incomeAdd)
            i1=x1
          }else if(i1==x1-1){
            userFinance[0].income.splice(x1,0,incomeAdd)
          }
        }
        setIncomeAddOption(incomeAddOption.filter((x)=>x.date!=incomeAdd.date))
        setIncomeAdd({...incomeAdd, ['date']:'',['timestamp']:''}) 
        if(userInfo.membership!=''){
            const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'income'})  
        }
    }
    setIncomeAddMenu1(!incomeAddMenu1)
  }
  const onClick2ExpenseCreate=async()=>{
    if (userFinance[0].expense.length==0){
        userFinance[0].expense[0]=expenseAdd
        setExpenseAddOption(expenseAddOption.filter((x)=>x.date!=expenseAdd.date))
        setExpenseAdd({...expenseAdd, ['date']:'',['timestamp']:''}) 
        if(userInfo.membership!=''){
            const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'expense'})  
        }
    }else{
        const x1=userFinance[0].expense.length
        for(let i1=0;i1<x1;i1++){
          if (userFinance[0].expense[i1]['timestamp']>expenseAdd.timestamp){
            userFinance[0].expense.splice(i1,0,expenseAdd)
            i1=x1
          }else if(i1==x1-1){
            userFinance[0].expense.splice(x1,0,expenseAdd)
          }
        }
        setExpenseAddOption(expenseAddOption.filter((x)=>x.date!=expenseAdd.date))
        setExpenseAdd({...expenseAdd, ['date']:'',['timestamp']:''}) 
        if(userInfo.membership!=''){
            const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'expense'})  
        }
    }
    setExpenseAddMenu1(!expenseAddMenu1)
  }
 const onClick2AssetReset=async()=>{
   let b1=[...userFinance]
   let b2=
        {
            "currency":"USD",
            "date":`${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,'0')}-${String(new Date().getDate()).padStart(2,'0')}`,
            "detail":[
                {
                    "category":"Equity",
                    "purchased_price":0,
                    "return_rate":0,
                    "sold_price":0,
                    "total_return":0
                },
                {
                    "category":"Hedge Fund",
                    "purchased_price":0,
                    "return_rate":0,
                    "sold_price":0,
                    "total_return":0
                },
                {
                    "category":"Private Equity",
                    "purchased_price":0,
                    "return_rate":0,
                    "sold_price":0,
                    "total_return":0
                },
                {
                    "category":"Fixed Income",
                    "purchased_price":0,
                    "return_rate":0,
                    "sold_price":0,
                    "total":0,
                    "total_return":0
                }
            ],
            "total": 7749620
        }
   b1[0].asset[0]=b2
   setUserFinance(b1)
   setUserFinanceDigest(b1)
   if(userInfo.membership!=''){
       const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':b1,'subject':'asset'})  
   }
   setAssetDeleteMenu1(!assetDeleteMenu1)
 }
 const onClick2IncomeDelete=async()=>{
    //apply to incomeAddOption
    const itemTtl=incomeAddOption.length
    let x1=[]
    let x2=[]
    for(let i2=0;i2<12;i2++){
        x1.push({
            'date':userFinance[0].income[incomeSelectedItem].detail[0].salary[i2].date,
            'timestamp':userFinance[0].income[incomeSelectedItem].detail[0].salary[i2].timestamp,
            'items':[
                {'category':'Monthly Income','value':0},
                {'category':'Overwork','hours':'0.00','rate':0,'value':0},
                {'category':'Transportation Fee','value':0},
                {'category':'Tax Deduction','value':0},
                {'category':'Other Deduction','value':0}
            ],
            'total':0
        })
        if(i2==5||i2==11){
            x2.push({
            'date':userFinance[0].income[incomeSelectedItem].detail[0].salary[i2].date,
            'timestamp':userFinance[0].income[incomeSelectedItem].detail[0].salary[i2].timestamp,
            'items':[
                {'category':'Base','value':0},
                {'category':'Tax Deduction','value':0},
                {'category':'Other Deduction','value':0}
            ],
            'total':0
            })
        }
    }
    let x3={
        'date':userFinance[0].income[incomeSelectedItem].date,
        'timestamp':userFinance[0].income[incomeSelectedItem].timestamp,
        'currency':'USD',
        'date':x1[11].date,
        'timestamp':x1[11].timestamp,
        'total':'0',
        'detail':[{
            'salary':x1,
            'bonus':x2
        }]
    }
    for(let i1=0;i1<itemTtl;i1++){
     if (incomeAddOption[i1]['timestamp']>userFinance[0].income[incomeSelectedItem].timestamp){
       incomeAddOption.splice(i1,0,x3)
       i1=itemTtl
     }else if(i1==itemTtl-1){
       incomeAddOption.splice(itemTtl,0,x3)
     }
   }
   let b1=[...userFinance]
   let b2=userFinance[0].income.filter((x)=>x.date!=userFinance[0].income[incomeSelectedItem].date)
   b1[0].income=b2
   setUserFinance(b1)
   setUserFinanceDigest(b1)
   setIncomeSelectedItem(0)
   if(userInfo.membership!=''){
       const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':b1,'subject':'income'})  
   }
   setIncomeDeleteMenu1(!incomeDeleteMenu1)
 }
 const onClick2ExpenseDelete=async()=>{
   const itemTtl=expenseAddOption.length
   for(let i1=0;i1<itemTtl;i1++){
     if (expenseAddOption[i1]['timestamp']>userFinance[0].expense[expenseSelectedItem].timestamp){
       expenseAddOption.splice(i1,0,{'date':userFinance[0].expense[expenseSelectedItem].date,'timestamp':userFinance[0].expense[expenseSelectedItem].timestamp})
       i1=itemTtl
     }else if(i1==itemTtl-1){
       expenseAddOption.splice(itemTtl,0,{'date':userFinance[0].expense[expenseSelectedItem].date,'timestamp':userFinance[0].expense[expenseSelectedItem].timestamp})
     }
   }
   let b1=[...userFinance]
   let b2=userFinance[0].expense.filter((x)=>x.date!=userFinance[0].expense[expenseSelectedItem].date)
   b1[0].expense=b2
   setUserFinance(b1)
   setUserFinanceDigest(b1)
   setExpenseSelectedItem(0)
   if(userInfo.membership!=''){
       const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':b1,'subject':'expense'})  
   }
   setExpenseDeleteMenu1(!expenseDeleteMenu1)
 }
 const onClick2IncomeDeleteAll=async()=>{
    //apply to incomeAddOption
    const itemTtl=incomeAddOption.length
    for(let i1=0;i1<userFinance[0].income.length;i1++){
        let x1=[]
        let x2=[]
        for(let i2=0;i2<12;i2++){
            x1.push({
            'date':userFinance[0].income[i1].detail[0].salary[i2].date,
            'timestamp':userFinance[0].income[i1].detail[0].salary[i2].timestamp,
            'items':[
                {'category':'Monthly Income','value':0},
                {'category':'Overwork','hours':'0.00','rate':0,'value':0},
                {'category':'Transportation Fee','value':0},
                {'category':'Tax Deduction','value':0},
                {'category':'Other Deduction','value':0}
            ],
            'total':0
            })
            if(i2==5||i2==11){
                x2.push({
                'date':userFinance[0].income[i1].detail[0].salary[i2].date,
                'timestamp':userFinance[0].income[i1].detail[0].salary[i2].timestamp,
                'items':[
                    {'category':'Monthly Income','value':0},
                    {'category':'Overwork','hours':'0.00','rate':0,'value':0},
                    {'category':'Transportation Fee','value':0},
                    {'category':'Tax Deduction','value':0},
                    {'category':'Other Deduction','value':0}
                ],
                'total':0
                })
            }
        }
        console.log('salary:',x1[11].date,x1[11].timestamp)
        console.log('bonus:',x2)
        let x3={
        'date':userFinance[0].income[i1].date,
        'timestamp':userFinance[0].income[i1].timestamp,
        'currency':'USD',
        'date':x1[11].date,
        'timestamp':x1[11].timestamp,
        'total':'0',
        'detail':[{
            'salary':x1,
            'bonus':x2
        }]
        }
        if(itemTtl==0){
            incomeAddOption[i1]=x3
        }else{
            for(let i2=0;i2<itemTtl.length;i2++){
                console.log('it should not be runnning if you are guest.')
                if (incomeAddOption[i2].timestamp>userFinance[0].income[i1].timestamp){
                    incomeAddOption.splice(i2,0,x3)
                    i2=incomeAddOption.length
                }
                if(i2==incomeAddOption.length-1){
                    incomeAddOption.splice(incomeAddOption.length,0,x3)
                    i2=incomeAddOption.length
                }
            }
        }
    }
    let b1=[...userFinance]
    userFinance[0].income=[]
    setUserFinance(b1)
    setUserFinanceDigest(b1)
    setIncomeSelectedItem(0)
    if(userInfo.membership!=''){
       const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':b1,'subject':'income'})
    }
    setIncomeDeleteMenu2(!incomeDeleteMenu2)
 }
 const onClick2ExpenseDeleteAll=async()=>{
    //apply to expenseAddOption
    const itemTtl=expenseAddOption.length
    for(let i1=0;i1<userFinance[0].expense.length;i1++){
        for(let i2=0;i2<itemTtl+1;i2++){
         if (expenseAddOption[i2]['timestamp']>userFinance[0].expense[i1].timestamp){
           expenseAddOption.splice(i2,0,{'date':userFinance[0].expense[i1].date,'timestamp':userFinance[0].expense[i1].timestamp})
           i2=itemTtl
         }else if(i2==itemTtl-1){
           expenseAddOption.splice(itemTtl,0,{'date':userFinance[0].expense[i1].date,'timestamp':userFinance[0].expense[i1].timestamp})
         }
        }
    }
   let b1=[...userFinance]
   userFinance[0].expense=[]
   setUserFinance(b1)
   setUserFinanceDigest(b1)
   setExpenseSelectedItem(0)
   if(userInfo.membership!=''){
       const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':b1,'subject':'expense'})
   }
   setExpenseDeleteMenu2(!expenseDeleteMenu2)
 }
  const onClick2AssetEdit=()=>{
    setAssetEdit([userFinance[0].asset[0]])
    setAssetEditMenu1(!assetEditMenu1)
  }
  const onClick2IncomeEdit=()=>{
    setIncomeEdit([userFinance[0].income[incomeSelectedItem]])
    setIncomeEditMenu1(!incomeEditMenu1)
  }
  const onClick2ExpenseEdit=()=>{
    setExpenseEdit([userFinance[0].expense[expenseSelectedItem]])
    setExpenseViewMenu1(true)
    setExpenseViewMenu2(true)
    setExpenseViewMenu3(true)
    setExpenseEditMenu1(!expenseEditMenu1)
  }
  const onClick2AssetCancel=()=>{
    setAssetEditMenu1(!assetEditMenu1)
  }
  const onClick2IncomeCancel=()=>{
    setIncomeEditMenu1(!incomeEditMenu1)
  }
  const onClick2ExpenseCancel=()=>{
    setExpenseEditMenu1(!expenseEditMenu1)
  }
  let exp_yrs_list=[]
  function exp_yrs_list_calc(){
    if(userFinance[0].expense.length>0){
        for(let i1=0;i1<userFinance[0].expense.length;i1++){
          if(!exp_yrs_list.includes(userFinance[0].expense[i1].date.slice(0,4))){
              exp_yrs_list.push(userFinance[0].expense[i1].date.slice(0,4))
          }
        }
    }
  }
  function yr_exp(x1){
    let x2=0
    for(let i1=0;i1<userFinance[0].expense.length;i1++){
        if(userFinance[0].expense[i1].date.slice(0,4)===x1){x2+=Number(userFinance[0].expense[i1].total)}
    }
    return x2 
  }
  const onClick2AssetSave=async()=>{
      //update monthly salary & bonus & yearly total
      let b1=[...userFinance]
      let b2=[...assetEdit]
      let b3=0
      b2[0].date=`${new Date().getFullYear()}-${String(new Date().getMonth()+1).padStart(2,'0')}-${String(new Date().getDate()).padStart(2,'0')}`
      //1 update date, return rate, totalreturn
      for(let i1=0;i1<b2[0].detail.length;i1++){
        if(b2[0].detail[i1].category!='Fixed Income'){
            if(b2[0].detail[i1].sold_price!=0){
                b2[0].detail[i1].return_rate=Math.floor((((Number(b2[0].detail[i1].sold_price)-Number(b2[0].detail[i1].purchased_price))/Number(b2[0].detail[i1].purchased_price))*10000))/10000
                b2[0].detail[i1].total_return=Number(b2[0].detail[i1].sold_price)-Number(b2[0].detail[i1].purchased_price)
                b3+=Number(b2[0].detail[i1].sold_price)-Number(b2[0].detail[i1].purchased_price)
            }
        }
    }
    //2 total return, fixed income item
    if(userFinance[0].income.length>0){
        let ttl_svg=0
        for(let i1=0;i1<userFinance[0].income.length;i1++){   
            if(exp_yrs_list.length>0&&exp_yrs_list.includes(userFinance[0].income[i1].date.slice(0,4))){   
                ttl_svg+=Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))
            }else{
                ttl_svg+=Number(userFinance[0].income[i1].total)
            }
        }
        b2[0].detail[3].total_return=ttl_svg
        b3+=ttl_svg
    }
    b2[0].total=b3
    b1[0].asset[0]=b2[0]
    setUserFinance(b1)
    setAssetEditMenu1(!assetEditMenu1)
    if(userInfo.membership!=''){
        const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'asset'})
    }
  }
  const onClick2IncomeSave=async()=>{
    //update monthly salary & bonus & yearly total
    let b1=[...userFinance]
    let b2=[...incomeEdit]
    //monthly total
    for (let i1=0;i1<12;i1++){
        b2[0].detail[0].salary[i1].total=calcIncomeTtl(incomeEdit[0].detail[0].salary[i1].items.map(x2=>x2.value))
        if(i1==5){
            b2[0].detail[0].bonus[0].total=calcIncomeTtl(incomeEdit[0].detail[0].bonus[0].items.map(x2=>x2.value))
        }else if(i1==11){
            b2[0].detail[0].bonus[1].total=calcIncomeTtl(incomeEdit[0].detail[0].bonus[1].items.map(x2=>x2.value))
        }
    }
    //yearly total
    b2[0].total=calcIncomeTtl(incomeEdit[0].detail[0].salary.map(x1=>x1.items.map(x2=>x2.value)).flat())+calcIncomeTtl(incomeEdit[0].detail[0].bonus.map(x1=>x1.items.map(x2=>x2.value)).flat())
    b1[0].income[incomeSelectedItem]=b2[0]
    setUserFinance(b1)
    setUserFinanceDigest(b1)
    setIncomeEditMenu1(!incomeEditMenu1)
    if(userInfo.membership!=''){
        const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'income'})
    }
  }
  const onClick2ExpenseSave=async()=>{
    //update category_total
    let b1=[...userFinance]
    let b2=[...expenseEdit]
    //monthly total
    b2[0].total=calcExpenseTtl(expenseEdit[0].detail.map(x1=>x1.detail.map(x2=>x2.items.map(x3=>x3.price))).flat().flat())
    //section total
    b2[0].detail[0].section_total=calcExpenseTtl(expenseEdit[0].detail[0].detail.map(x1=>x1.items.map(x2=>x2.price).flat()).flat())
    b2[0].detail[1].section_total=calcExpenseTtl(expenseEdit[0].detail[1].detail.map(x1=>x1.items.map(x2=>x2.price).flat()).flat())
    b2[0].detail[2].section_total=calcExpenseTtl(expenseEdit[0].detail[2].detail.map(x1=>x1.items.map(x2=>x2.price).flat()).flat())
    //category total
    b2[0].detail[0].detail[0].category_total=calcExpenseTtl(expenseEdit[0].detail[0].detail[0].items.map(x1=>x1.price))
    b2[0].detail[0].detail[1].category_total=calcExpenseTtl(expenseEdit[0].detail[0].detail[1].items.map(x1=>x1.price))
    b2[0].detail[0].detail[2].category_total=calcExpenseTtl(expenseEdit[0].detail[0].detail[2].items.map(x1=>x1.price))
    b2[0].detail[0].detail[3].category_total=calcExpenseTtl(expenseEdit[0].detail[0].detail[3].items.map(x1=>x1.price))
    b2[0].detail[1].detail[0].category_total=calcExpenseTtl(expenseEdit[0].detail[1].detail[0].items.map(x1=>x1.price))
    b2[0].detail[1].detail[1].category_total=calcExpenseTtl(expenseEdit[0].detail[1].detail[1].items.map(x1=>x1.price))
    b2[0].detail[1].detail[2].category_total=calcExpenseTtl(expenseEdit[0].detail[1].detail[2].items.map(x1=>x1.price))
    b2[0].detail[1].detail[3].category_total=calcExpenseTtl(expenseEdit[0].detail[1].detail[3].items.map(x1=>x1.price))
    b2[0].detail[2].detail[0].category_total=calcExpenseTtl(expenseEdit[0].detail[2].detail[0].items.map(x1=>x1.price))
    b2[0].detail[2].detail[1].category_total=calcExpenseTtl(expenseEdit[0].detail[2].detail[1].items.map(x1=>x1.price))
    b1[0].expense[expenseSelectedItem]=b2[0]
    setUserFinance(b1)
    setUserFinanceDigest(b1)
    setExpenseEditMenu1(!expenseEditMenu1)
    if(userInfo.membership!=''){
        const {data:res}=await axios.post(`${APIURL}/account-info/finance/sync`,{token:window.localStorage.getItem('token'),'finance':userFinance,'subject':'expense'})
    }
  }
  const onClick2View=(x)=>{
        if(x==1){
            setExpenseViewMenu1(!expenseViewMenu1)
        }else if(x==2){
            setExpenseViewMenu2(!expenseViewMenu2)
        }else{
            setExpenseViewMenu3(!expenseViewMenu3)
        }
  }
  const onChange2AssetInput=({currentTarget:x1},i2)=>{
      let b1=[...assetEdit]
      let b2=assetEdit[0].detail[i2]
      b1[0].detail[i2]={...b2, [x1.name]:x1.value}
      assetList3(b1)
  }
  const onChange2IncomeSalaryInput=({currentTarget:x1},x2,x3)=>{
      let b1=[...incomeEdit]
      let b2=incomeEdit[0].detail[0].salary[x2].items[x3]
      b1[0].detail[0].salary[x2].items[x3]={...b2, [x1.name]:x1.value}
      incomeList3(b1)
  }
  const onChange2IncomeBonusInput=({currentTarget:x1},x2,x3)=>{
      let b1=[...incomeEdit]
      let b2=incomeEdit[0].detail[0].bonus[x2].items[x3]
      b1[0].detail[0].bonus[x2].items[x3]={...b2, [x1.name]:x1.value}
      incomeList3(b1)
  }
  const onChange2ExpenseMemoInput=({currentTarget:x1})=>{
      let b1=[...expenseEdit]
      let b2=expenseEdit[0]
      b1[0]={...b2, [x1.name]:x1.value}
      expenseList3(b1)
  }
  const onChange2ExpenseInput=({currentTarget:x1}, x2,x3,x4)=>{
      let b1=[...expenseEdit]
      let b2=expenseEdit[0].detail[x2].detail[x3].items[x4]
      b1[0].detail[x2].detail[x3].items[x4]={...b2, [x1.name]:x1.value}
      expenseList3(b1)
  }
  const onClick2AddItem=(x1,x2)=>{
    let b1=[...expenseEdit]
    let b2=expenseEdit[0].detail[x1].detail[x2].items
    b2.push({name: "book", amount: 1, price: 0})
    b1[0].detail[x1].detail[x2].items=b2
    expenseList3(b1)
  }
  const onClick2ExpenseRemove=(x1,x2,x3)=>{
    let b1=[...expenseEdit]
    let b2=expenseEdit[0].detail[x1].detail[x2].items.filter((x4,i4)=>i4!==x3)
    b1[0].detail[x1].detail[x2].items=b2
    expenseList3(b1)
  }
  const assetList3=(x)=>{setAssetEdit(x)}
  const incomeList3=(x)=>{setIncomeEdit(x)}
  const expenseList3=(x)=>{setExpenseEdit(x)}
  const onClick2AssetCurr=(x)=>{
    let b1=[...assetEdit]
    b1[0].currency=x.name
    assetList3(b1)
    setAssetEditMenu2(false)
  }
  const onClick2IncomeCurr=(x)=>{
    let b1=[...incomeEdit]
    b1[0].currency=x.name
    incomeList3(b1)
    setIncomeEditMenu2(false)
  }
  const onClick2ExpenceCurr=(x)=>{
    let b1=[...expenseEdit]
    b1[0].currency=x.name
    expenseList3(b1)
    setExpenseEditMenu2(false)
  }
  const onClick2IncomePageContent=(x)=>{
    setIncomeSelectedItem(Number(x))
    //     setTimeout(() => {
    //         onClick2ExpenseLoadPdf()
    //   },90)
  }
  const onClick2ExpensePageContent=(x)=>{
    setExpenseSelectedItem(Number(x))
    //     setTimeout(() => {
    //         onClick2ExpenseLoadPdf()
    //   },90)
  }
  function toBase64(x1) {
  return new Promise((x2,x3) => {
    const x4=new FileReader()
    x4.onload=()=>x2(x4.result)
    x4.onerror=x3
    x4.readAsDataURL(x1)
  })
  }
  function toAssetUrl(x1){
    const url1=`data:application/pdf;base64,${x1}`
    const url2=document.createElement("a")
    url2.href=url1
    url2.download=`asset_${userFinance[0].asset[0].date.slice(8,10)}${userFinance[0].asset[0].date.slice(5,7)}${userFinance[0].asset[0].date.slice(0,4)}.pdf`
    url2.click()
  }
  function toIncomeUrl(x1){
    const url1=`data:application/pdf;base64,${x1}`
    const url2=document.createElement("a")
    url2.href=url1
    url2.download=`income_${userFinance[0].income[incomeSelectedItem].date.slice(0,4)}.pdf`
    url2.click()
  }
  function toIncomeUrlAll(x1){
    const url1=`data:application/pdf;base64,${x1}`
    const url2=document.createElement("a")
    url2.href=url1
    url2.download=`income_${userFinance[0].income[0].date.slice(0,4)}-${userFinance[0].income[userFinance[0].income.length-1].date.slice(0,4)}.pdf`
    url2.click()
  }
  function toExpenseUrl(x1){
    const url1=`data:application/pdf;base64,${x1}`
    const url2=document.createElement("a")
    url2.href=url1
    url2.download=`expense_${userFinance[0].expense[expenseSelectedItem].date.slice(5,7)}${userFinance[0].expense[expenseSelectedItem].date.slice(0,4)}.pdf`
    url2.click()
  }
  function toExpenseUrlAll(x1){
    const url1=`data:application/pdf;base64,${x1}`
    const url2=document.createElement("a")
    url2.href=url1
    url2.download=`expense_${userFinance[0].expense[0].date.slice(0,4)}-expense_${userFinance[0].expense[userFinance[0].expense.length-1].date.slice(0,4)}.pdf`
    url2.click()
  }
  const onClick2Json=async()=>{
     if(userInfo.membership!=''){
         const {data:res}=await axios.post(`${APIURL}/asset/json`, {token:window.localStorage.getItem('token')})
         const x1={}
         x1['notification']=res.json.notification
         x1['investment']=res.json.investment
         x1['income']=res.json.income
         x1['expense']=res.json.expense
         const x2=new Blob([JSON.stringify(x1,null,2)],{type:'text/json'})
         const x3=document.createElement('a')
         x3.download=`finance_${res.date}.json`
         x3.href=window.URL.createObjectURL(x2)
         const x4=new MouseEvent('click',{
             view:window,
             bubbles:true,
             cancelable:true,
         })
         x3.dispatchEvent(x4)
         x3.remove()
     }else{
        const x1=userFinance[0]
        const x2=new Blob([JSON.stringify(x1,null,2)],{type:'text/json'})
        const x3=document.createElement('a')
        x3.download=`finance_${new Date().getHours().toString().length==2?new Date().getHours():`0${new Date().getHours()}`}${new Date().getMinutes().toString().length==2?new Date().getMinutes():`0${new Date().getMinutes()}`}${new Date().getDate().toString().length==2?new Date().getDate():`0${new Date().getDate()}`}${new Date().getMonth().toString().length==2?new Date().getMonth():`0${new Date().getMonth()}`}${new Date().getFullYear()}.json`
        x3.href=window.URL.createObjectURL(x2)
        const x4=new MouseEvent('click',{
            view:window,
            bubbles:true,
            cancelable:true,
        })
        x3.dispatchEvent(x4)
        x3.remove()
     }
  }  
  const curr=[{'name':'USD','symbol':'$'},{'name':'JPY','symbol':'¥'},{'name':'UK','symbol':'£'},{'name':'EUR','symbol':'€'}]
  function sym(){
    if(userFinance[0].expense.length!=0){
        for(let x2 of curr){
            if(x2.name==userFinance[0].expense[expenseSelectedItem].currency){
                return x2.symbol
              }
          }
    }
  }
  function turncated(x1){if(x1.length>30){return `${x1.slice(0,30)}...`}else{return x1}}
  const onClick2AssetLoadPdf=async()=>{
    if(assetPdfType!='asset_ddmmyyyy.pdf'){
        setAssetPrintLoading(true)
        setTimeout(async() => {
            setAssetPrintLoading(false)
          },1000)
    }
    setAssetPdfType(`asset_${String(new Date().getDate()).padStart(2,'0')}${String(new Date().getMonth()+1).padStart(2,'0')}${new Date().getFullYear()}.pdf`)    
    var tmp4=document.getElementById('tmp4')
    tmp4.height=793.92*4
    tmp4.width=1122.24*4
    var ctx1=tmp4.getContext('2d')
    ctx1.scale(4, 4)
    ctx1.setTransform(4,0,0,4,0,0)
    ctx1.fillStyle='black'
    ctx1.font = 'bold 24px Bitter'
    //section1 header
    //bold texts w h
    ctx1.fillText('Dev Cookbooks',70,124)
    ctx1.font='bold 18px Bitter'
    ctx1.fillText(`${userInfo.membership!=''?<>`${userInfo.firstname} ${userInfo.lastname}`</>:'Guest User'}`,540,120)
    ctx1.fillText('Ashley Lee(AI Agent)',766,120)
    //tiny texts
    ctx1.font='normal 12px Bitter'
    ctx1.fillText('prepared for:',540,90)
    ctx1.fillText('Asset Overview:',540,140)
    ctx1.fillText(stringDate(userFinance[0].asset[0].date),540,166)
    ctx1.fillText('prepared by:',766,90)
    ctx1.fillText('Investment Advisor',766,140)
    ctx1.fillText('Wealth Management',766,156)

    //section1 items
    //bold texts w h
    ctx1.font='normal 20px Bitter'
    ctx1.fillText('Earnings & Savings',70,240)
    ctx1.fillText('Investment Results',70,634)
    ctx1.fillText('Yearly Returns & Savings',540,440)
    //tiny texts
    ctx1.font='normal 9px sans-serif'
    //ttl
    ctx1.fillText('Year',70,280)
    ctx1.fillText('Revenue',110,280)
    ctx1.fillText('Avr',190,280)
    ctx1.fillText('Expense',240,280)
    ctx1.fillText('Avr',310,280)
    ctx1.fillText('Yearly Saving',360,280)
    ctx1.fillText('Total Saving',436,280)
    ctx1.font='normal 9px sans-serif'
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70, 286)
    ctx1.lineTo(500, 286)
    ctx1.stroke()
    //items
    let ttl_svg=0
    for(let i1=0;i1<userFinance[0].income.length;i1++){    
        ctx1.fillText(userFinance[0].income[i1].date.slice(0,4),70,306+(20*i1))
        ctx1.fillText(add1M1KSprt(userFinance[0].income[i1].total),160-(6*(userFinance[0].income[i1].total.toString().length)),306+(20*i1))
        ctx1.fillText(add1M1KSprt(Math.floor(userFinance[0].income[i1].total/12)),208-(4.6*(add1M1KSprt(Math.floor(userFinance[0].income[i1].total/12)).toString().length-3)),306+(20*i1))
        if (exp_yrs_list.includes(userFinance[0].income[i1].date.slice(0,4))){              
            ctx1.fillText(add1M1KSprt(yr_exp(userFinance[0].income[i1].date.slice(0,4))),280-(4*(add1M1KSprt(yr_exp(userFinance[0].income[i1].date.slice(0,4)))).toString().length-1),306+(20*i1))
            ctx1.fillText(add1M1KSprt(Math.floor(yr_exp(userFinance[0].income[i1].date.slice(0,4))/12)),340-(4.6*(add1M1KSprt(Math.floor(yr_exp(userFinance[0].income[i1].date.slice(0,4))/12))).toString().length-1),306+(20*i1))
            ttl_svg+=Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))
        }else{
            ttl_svg+=Number(userFinance[0].income[i1].total)
        }
        ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))),420-(4.6*add1M1KSprt(Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))).toString().length),306+(20*i1))
        ctx1.fillText(add1M1KSprt(ttl_svg),490-(4.6*(add1M1KSprt(ttl_svg).toString().length)),306+(20*i1))
        ctx1.beginPath()
        ctx1.lineWidth=1
        ctx1.moveTo(70,310+(20*i1))
        ctx1.lineTo(500,310+(20*i1))
        ctx1.stroke()
    }
    ctx1.fillText(`${sym()}${add1M1KSprt(ttl_svg)}`,490-(4.6*(`${sym()}${add1M1KSprt(ttl_svg)}`.toString().length)),306+(20*userFinance[0].income.length))
    //investment Results
    //ttl
    ctx1.fillText('Categories',70,672)
    ctx1.fillText('Purchased Price',180,672)
    ctx1.fillText('Sold Price',284,672)
    ctx1.fillText('Return Rate',360,672)
    ctx1.fillText('Total Return',440,672)  
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70,680)
    ctx1.lineTo(500,680)
    ctx1.stroke()
    let i2=0
    for(let i1=0;i1<userFinance[0].asset[0].detail.length;i1++){
        if(userFinance[0].asset[0].detail[i1].category!='Fixed Income'){
            ctx1.fillText(userFinance[0].asset[0].detail[i1].category,70,696+(20*i2))
            ctx1.fillText(add1M1KSprt(userFinance[0].asset[0].detail[i1].purchased_price),234-(5.8*(userFinance[0].asset[0].detail[i1].purchased_price.toString().length)),696+(20*i2))
            ctx1.fillText(add1M1KSprt(userFinance[0].asset[0].detail[i1].sold_price),314-(4.4*(add1M1KSprt(userFinance[0].asset[0].detail[i1].sold_price).toString().length)),696+(20*i2))
            ctx1.fillText(add1M1KSprt(userFinance[0].asset[0].detail[i1].return_rate),400-(3.2*(add1M1KSprt(userFinance[0].asset[0].detail[i1].return_rate).toString().length)),696+(20*i2))
            ctx1.fillText(add1M1KSprt(userFinance[0].asset[0].detail[i1].total_return),480-(4.2*(add1M1KSprt(userFinance[0].asset[0].detail[i1].total_return).toString().length)),696+(20*i2))
            if(i1==userFinance[0].asset[0].detail.length-2){
                ctx1.beginPath()
                ctx1.lineWidth=2
                ctx1.moveTo(70,700+(20*i2))
                ctx1.lineTo(500,700+(20*i2))
                ctx1.stroke()
                ctx1.fillText(`${sym()}${add1M1KSprt(Number(userFinance[0].asset[0].total)-Number(userFinance[0].asset[0].detail[3].total_return))}`,480-(4.2*(`${sym()}${add1M1KSprt(Number(userFinance[0].asset[0].total)-Number(userFinance[0].asset[0].detail[3].total_return))}`.toString().length)),696+(20*(i2+1)))
            }else{
                ctx1.beginPath()
                ctx1.lineWidth=1
                ctx1.moveTo(70,700+(20*i2))
                ctx1.lineTo(500,700+(20*i2))
                ctx1.stroke()
            }
            i2++
        }
    }
    ctx1.font='normal 9px sans-serif'
    //section3 pie
    ctx1.beginPath()
    ctx1.fillStyle='#1C2041'
    ctx1.fillRect(852,266,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#606278'
    ctx1.fillRect(852,290,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#76788A'
    ctx1.fillRect(852,316,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#D9D9D9'
    ctx1.fillRect(852,340,10,10)
    ctx1.stroke()
    const data=[{label:pie_item1.sort((x1,x2)=>x2.ttl-x1.ttl)[0].category,value:Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl1)*100),color:'#0F1336'},{label:pie_item1.sort((x1,x2)=>x2.ttl-x1.ttl)[1].category,value:Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl1)*100),color:'#606278'},{label:pie_item1.sort((x1,x2)=>x2.ttl-x1.ttl)[2].category,value:Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl-x1.ttl)[2].ttl)/pie_ttl1)*100),color:'#76788A'},{label:'Other',value:Math.floor((pie_others1/pie_ttl1)*100),color:'#D9D9D9'}]
    const total=data.reduce((x,i)=>x+i.value,0)||1
    const cx=720
    const cy=300
    const r=Math.min(180,180)/2*0.9
    let st=-Math.PI/2
    data.forEach((x) => {
      const end=st+((x.value/total)*Math.PI*2)
      ctx1.beginPath()
      ctx1.moveTo(cx,cy)
      ctx1.arc(cx,cy,r,st,end);
      ctx1.closePath();
      ctx1.fillStyle = x.color||'#999'
      ctx1.fill()
      st=end
    })
    ctx1.beginPath()
    ctx1.fillStyle='black'
    ctx1.font = 'normal 11px Bitter'
    ctx1.fillText(`${(pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[0].category).toUpperCase()} ${Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl2)*100)}%`,870,276)
    ctx1.fillText(`${(pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[1].category).toUpperCase()} ${Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl2)*100)}%`,870,300)
    ctx1.fillText(`${(pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[2].category).toUpperCase()} ${Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[2].ttl)/pie_ttl2)*100)}%`,870,326)
    ctx1.fillText(`${(pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[3].category).toUpperCase()} ${Math.floor(((pie_item1.sort((x1,x2)=>x2.ttl - x1.ttl)[3].ttl)/pie_ttl2)*100)}%`,870,350)
    //section4 graph 
    ctx1.font = 'normal 9px Bitter'
    ctx1.fillText(`Total Savings (${curr.filter(x=>x.symbol=='¥')[0].name})`,726,722)
    //bar label x
    if(userFinance[0].income.length>12){
        for(let i1=0;i1<userFinance[0].income.length;i1++){
            ctx1.fillText(userFinance[0].income[i1].date.slice(2,4),622+(i1*(360/userFinance[0].income.length)),700)
        }
    }else{
        for(let i1=0;i1<userFinance[0].income.length;i1++){
            ctx1.fillText(userFinance[0].income[i1].date.slice(0,4),622+(i1*(360/userFinance[0].income.length)),700)
        }

    }
    //bar label y
    //exp_yrs_list - expense included yrs
    //ttl_svg - yearly saving max 
    let ttl_svgs1=0
    let ttl_svgs2=[]
    for(let i1=0;i1<userFinance[0].income.length;i1++){
        ttl_svgs1+=Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))
        ttl_svgs2.push(ttl_svgs1)
    }
    if(Math.max(...ttl_svgs2).toString().length>5){
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...ttl_svgs2))/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor((Math.max(...ttl_svgs2))/10000)+1)*10000)}`.length-2)*4.2),511)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...ttl_svgs2)/5)*4)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...ttl_svgs2)/5)*4)/10000)+1)*10000)}`.length-2)*4.2),546)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...ttl_svgs2)/5)*3)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...ttl_svgs2)/5)*3)/10000)+1)*10000)}`.length-2)*4.2),583)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...ttl_svgs2)/5)*2)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...ttl_svgs2)/5)*2)/10000)+1)*10000)}`.length-2)*4.2),619)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...ttl_svgs2)/5)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor((Math.max(...ttl_svgs2)/5)/10000)+1)*10000)}`.length-2)*4.2),655)
        ctx1.fillText(`${sym()}0`,600,684)
    }else{
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(ttl_svg))}`,600-((`${sym()}${add1M1KSprt(Math.floor(ttl_svg))}`.length-2)*4.2),511)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((ttl_svg/5)*4)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((ttl_svg/5)*4)*100)/100)}`.length-2)*4.2),546)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((ttl_svg/5)*3)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((ttl_svg/5)*3)*100)/100)}`.length-2)*4.2),583)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((ttl_svg/5)*2)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((ttl_svg/5)*2)*100)/100)}`.length-2)*4.2),619)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor((ttl_svg/5)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor((ttl_svg/5)*100)/100)}`.length-2)*4.2),655)
        ctx1.fillText(`${sym()}0`,600,684)
    }
    //graph bar x y w h 
    // y=0%:682 50% 100%506 
    // h=0%:1 50%: 100%:178
    function bar(){
        let ttl_svg2=0
        for(let i1=0;i1<userFinance[0].income.length;i1++){
            if(Math.max(...ttl_svgs2)>10000){
                //display saving
                ttl_svg2+=Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))
                //line 1
                ctx1.fillStyle='#1414143d'
                ctx1.fillRect(Math.floor(626+((360/userFinance[0].income.length)*i1)),508+(176-(ttl_svg2/((Math.floor(Math.max(...ttl_svgs2)/10000)+1)*10000)*176)),4,(ttl_svg2/((Math.floor((Math.max(...ttl_svgs2))/10000)+1)*10000))*176)
                ///line 2
                ctx1.fillStyle='#141414b8'
                ctx1.fillRect(Math.floor(626+((360/userFinance[0].income.length)*i1)),508+(176-((Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4))))/((Math.floor(Math.max(...ttl_svgs2)/10000)+1)*10000)*176)),4,((Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4))))/((Math.floor((Math.max(...ttl_svgs2))/10000)+1)*10000))*176)
            }else{
                //display saving
                ttl_svg2+=Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4)))
                //line 1
                ctx1.fillStyle='#1414143d'
                ctx1.fillRect(Math.floor(626+((360/userFinance[0].income.length)*i1)),508+(176-(ttl_svg2/(Math.max(...ttl_svgs2))*176)),4,(ttl_svg2/((Math.floor((Math.max(...ttl_svgs2))/10000)+1)*10000))*176)
                ///line 2
                ctx1.fillStyle='#141414b8'
                ctx1.fillRect(Math.floor(626+((360/userFinance[0].income.length)*i1)),508+(176-((Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4))))/(Math.max(...ttl_svgs2))*176)),4,((Number(userFinance[0].income[i1].total)-Number(yr_exp(userFinance[0].income[i1].date.slice(0,4))))/((Math.floor((Math.max(...ttl_svgs2))/10000)+1)*10000))*176)
            }
        } 
    }
    //graph lines
    ctx1.strokeStyle='#D9D9D9'
    ctx1.lineWidth=1
    ctx1.beginPath()
    ctx1.moveTo(620,508)
    ctx1.lineTo(980,508)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,544)
    ctx1.lineTo(980,544)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,580)
    ctx1.lineTo(980,580)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,616)
    ctx1.lineTo(980,616)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,652)
    ctx1.lineTo(980,652)
    ctx1.stroke()
    ctx1.strokeStyle='black'
    ctx1.lineWidth=1
    ctx1.beginPath()
    ctx1.moveTo(620,684)
    ctx1.lineTo(980,684)
    ctx1.stroke()
    bar()
    ctx1.strokeStyle='black'
    ctx1.lineWidth=1
    ctx1.beginPath()
    ctx1.moveTo(70, 198)
    ctx1.lineTo(980, 198)
    ctx1.stroke()
    //monthly expense
    ctx1.beginPath()
    ctx1.strokeStyle='black'
    ctx1.lineWidth=1
    ctx1.moveTo(540,412)
    ctx1.lineTo(980,412)
    ctx1.stroke()
  }
  const onClick2AssetPrint=()=>{
    const tmp1_1=document.getElementById('tmp1')
    const tmp2_1=document.getElementById('tmp2')
    const tmp3_1=document.getElementById('tmp3')
    const tmp4_1=document.getElementById('tmp4')
    const tmp1_2=document.createElement('canvas')
    const tmp2_2=document.createElement('canvas')
    const tmp3_2=document.createElement('canvas')
    const tmp4_2=document.createElement('canvas')
    // tmp1_2.height=396.96
    // tmp1_2.width=561.12
    // tmp2_2.height=396.96
    // tmp2_2.width=561.12
    tmp1_2.height=793.92
    tmp1_2.width=1122.24
    tmp2_2.height=793.92
    tmp2_2.width=1122.24
    tmp3_2.height=793.92
    tmp3_2.width=1122.24
    tmp4_2.height=793.92
    tmp4_2.width=1122.24
    var ctx1=tmp4_2.getContext('2d') 
    ctx1.canvas.width=1122.24*2
    ctx1.canvas.height=793.92*2
    ctx1.setTransform(.5, 0, 0, .5, 0, 0)
    ctx1.drawImage(tmp4_1,0,0,1122.24*4,793.92*4)
    tmp4_2.toBlob(async(x1) =>{
        let x2=await toBase64(x1)
        x2=x2.split(',')[1]
        try{
            const { data: res } = await axios.post(`${APIURL}/asset/pdf`,{'png1':x2.toString(),'png2':''})
            toAssetUrl(res.pdf)
        }catch(err){
            console.log(err)
        }
    }, 'image/png')
  }
  const onClick2IncomeLoadPdf=async()=>{
    if(incomePdfType!='income_yyyy.pdf'){
        setIncomePrintLoading(true)
        setTimeout(async() => {
            setIncomePrintLoading(false)
          },1000)
    }
    setIncomePdfType(`income_${userFinance[0].income[incomeSelectedItem].date.slice(0,4)}.pdf`)    
    var tmp3=document.getElementById('tmp3')
    tmp3.height=793.92*4
    tmp3.width=1122.24*4
    var ctx1=tmp3.getContext('2d')
    ctx1.scale(4, 4)
    ctx1.setTransform(4,0,0,4,0,0)
    ctx1.fillStyle='black'
    ctx1.font = 'bold 24px Bitter'
    //section1 header
    //bold texts w h
    ctx1.fillText('Dev Cookbooks',70,124)
    ctx1.font='bold 18px Bitter'
    ctx1.fillText(`${userInfo.firstname} ${userInfo.lastname}`,540,120)
    ctx1.fillText('Ashley Lee(AI Agent)',766,120)
    //tiny texts
    ctx1.font='normal 12px Bitter'
    ctx1.fillText('prepared for:',540,90)
    ctx1.fillText('Yearly Income Overview:',540,140)
    ctx1.fillText(stringDate(userFinance[0].income[incomeSelectedItem].date),540,166)
    ctx1.fillText('prepared by:',766,90)
    ctx1.fillText('Investment Advisor',766,140)
    ctx1.fillText('Wealth Management',766,156)
    //section2 items
    //bold texts w h
    ctx1.font='normal 20px Bitter'
    ctx1.fillText('Salary',70,240)
    ctx1.fillText('Over working Hours',70,634)
    ctx1.fillText('Monthly Income',540,440)
    //tiny texts
    ctx1.font='normal 9px sans-serif'
    //ttl
    ctx1.fillText('Month',70,280)
    ctx1.fillText('Base',150,280)
    ctx1.fillText('Overwork',224,272)
    ctx1.fillText('Hours',224,280)
    ctx1.fillText('Over Work',280,280)
    ctx1.fillText('Deduction',346,280)
    ctx1.fillText('Total Earning',416,280)
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70, 286)
    ctx1.lineTo(500, 286)
    ctx1.stroke()
    //items
    for(let x1=0;x1<12;x1++){    
        ctx1.fillText(stringDate(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].date).slice(0,3),70,306+(20*x1))
        ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[0].value),190-(6*(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[0].value.toString().length)),306+(20*x1))
        ctx1.fillText(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[1].hours,234-(6*(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[1].hours.toString().length-3)),306+(20*x1))
        ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[1].value),320-(4*(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[1].value).toString().length-1)),306+(20*x1))
        ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[3].value)+Number(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[4].value)),386-(6*((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[3].value)+Number(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].items[4].value)).toString().length)),306+(20*x1))
        ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].total),476-(6*(userFinance[0].income[incomeSelectedItem].detail[0].salary[x1].total.toString().length)),306+(20*x1))
        if(x1==11&&Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total)!=0){
            ctx1.beginPath()
            ctx1.lineWidth=1
            ctx1.moveTo(70,310+(20*x1))
            ctx1.lineTo(500,310+(20*x1))
            ctx1.stroke()
            ctx1.fillText('Bonus 1',70,306+(20*(x1+1)))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].items[0].value),190-(6*userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].items[0].value.toString().length),306+(20*(x1+1)))
            ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].items[1].value)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].items[2].value)),386-(6*((Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].items[1].value)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].items[2].value)).toString().length)),306+(20*(x1+1)))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total),476-(6*(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total.toString().length)),306+(20*(x1+1)))
            ctx1.beginPath()
            ctx1.lineWidth=1
            ctx1.moveTo(70,310+(20*(x1+1)))
            ctx1.lineTo(500,310+(20*(x1+1)))
            ctx1.stroke()
            ctx1.fillText('Bonus 2',70,306+(20*(x1+2)))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].items[0].value),190-(6*userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].items[0].value.toString().length),306+(20*(x1+2)))
            ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].items[1].value)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].items[2].value)),386-(6*((Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].items[1].value)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].items[2].value)).toString().length)),306+(20*(x1+2)))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].total),476-(6*(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].total.toString().length)),306+(20*(x1+2)))
            ctx1.beginPath()
            ctx1.lineWidth=2
            ctx1.moveTo(70,310+(20*(x1+2)))
            ctx1.lineTo(500,310+(20*(x1+2)))
            ctx1.stroke()
            ctx1.fillText(`${sym()}${add1M1KSprt(userFinance[0].income[incomeSelectedItem].total)}`,486-(6*(`${sym()}${add1M1KSprt(userFinance[0].income[incomeSelectedItem].total)}`).length),324+(20*(x1+2)))
        }else if(x1==11&&Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total)==0){
            ctx1.beginPath()
            ctx1.lineWidth=2
            ctx1.moveTo(70,310+(20*x1))
            ctx1.lineTo(500,310+(20*x1))
            ctx1.stroke()
            ctx1.fillText(`${sym()}${add1M1KSprt(userFinance[0].income[incomeSelectedItem].total)}`,476-(6*(`${sym()}${add1M1KSprt(userFinance[0].income[incomeSelectedItem].total)}`).length),324+(20*x1))
        }else{
            ctx1.beginPath()
            ctx1.lineWidth=1
            ctx1.moveTo(70,310+(20*x1))
            ctx1.lineTo(500,310+(20*x1))
            ctx1.stroke()
        }
    }
    //ttl
    ctx1.font='9px bold'
    const m_list=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    for(let x1=0;x1<12;x1++){    
        ctx1.fillText(m_list[x1],112+(33*x1),672)
    }
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70,678)
    ctx1.lineTo(500,678)
    ctx1.stroke()
    //item 1
    ctx1.font='normal 9px sans-serif'
    if(incomeSelectedItem>1){
        for(let x1=0;x1<3;x1++){
            ctx1.fillText(userFinance[0].income[(incomeSelectedItem-2)+x1].date.slice(0,4),74,696+(20*x1))
                for(let x3=0;x3<12;x3++){    
                   ctx1.fillText(userFinance[0].income[(incomeSelectedItem-2)+x1].detail[0].salary[x3].items[1].hours,112+(33*x3)-(2*(userFinance[0].income[(incomeSelectedItem-2)+x1].detail[0].salary[x3].items[1].hours.toString().length-4)),696+(20*x1))
               }
               if (x1==2){
                ctx1.beginPath()
                ctx1.lineWidth=2
                ctx1.moveTo(70,700+(20*x1))
                ctx1.lineTo(500,700+(20*x1))
                ctx1.stroke()
               }else{
                ctx1.beginPath()
                ctx1.lineWidth=1
                ctx1.moveTo(70,700+(20*x1))
                ctx1.lineTo(500,700+(20*x1))
                ctx1.stroke()
               }
        }
    }else if(incomeSelectedItem==1){
        for(let x1=0;x1<2;x1++){
            ctx1.fillText(userFinance[0].income[(incomeSelectedItem-1)+x1].date.slice(0,4),74,696+(20*x1))
                for(let x3=0;x3<12;x3++){    
                   ctx1.fillText(userFinance[0].income[(incomeSelectedItem-1)+x1].detail[0].salary[x3].items[1].hours,112+(33*x3),696+(20*x1))
               }
               if (x1==2){
                ctx1.beginPath()
                ctx1.lineWidth=2
                ctx1.moveTo(70,700+(20*x1))
                ctx1.lineTo(500,700+(20*x1))
                ctx1.stroke()
               }else{
                ctx1.beginPath()
                ctx1.lineWidth=1
                ctx1.moveTo(70,700+(20*x1))
                ctx1.lineTo(500,700+(20*x1))
                ctx1.stroke()
               }
        }

    }else if(incomeSelectedItem==0){
        ctx1.fillText(userFinance[0].income[incomeSelectedItem].date.slice(0,4),74,696)
        for(let x3=0;x3<12;x3++){    
            ctx1.fillText(userFinance[0].income[incomeSelectedItem].detail[0].salary[x3].items[1].hours,112+(33*x3),696)
       }
        ctx1.beginPath()
        ctx1.lineWidth=1
        ctx1.moveTo(70,700)
        ctx1.lineTo(500,700)
        ctx1.stroke()
    }
    //section3 pie
    ctx1.beginPath()
    ctx1.fillStyle='#1C2041'
    ctx1.fillRect(852,266,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#606278'
    ctx1.fillRect(852,290,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#76788A'
    ctx1.fillRect(852,316,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#D9D9D9'
    ctx1.fillRect(852,340,10,10)
    ctx1.stroke()
    const data=[{label:pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[0].category,value:Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl2)*100),color:'#0F1336'},{label:pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[1].category,value:Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl2)*100),color:'#606278'},{label:pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[2].category,value:Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[2].ttl)/pie_ttl2)*100),color:'#76788A'},{label:'Other',value:Math.floor((pie_others2/pie_ttl2)*100),color:'#D9D9D9'}]
    const total=data.reduce((x,i)=>x+i.value,0)||1
    const cx=720
    const cy=300
    const r=Math.min(180,180)/2*0.9
    let st=-Math.PI/2
    data.forEach((x) => {
      const end=st+((x.value/total)*Math.PI*2)
      ctx1.beginPath()
      ctx1.moveTo(cx,cy)
      ctx1.arc(cx,cy,r,st,end);
      ctx1.closePath();
      ctx1.fillStyle = x.color||'#999'
      ctx1.fill()
      st=end
    })
    ctx1.beginPath()
    ctx1.fillStyle='black'
    ctx1.font = 'normal 11px Bitter'
    ctx1.fillText(`${(pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[0].category).toUpperCase()} ${Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl2)*100)}%`,870,276)
    ctx1.fillText(`${(pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[1].category).toUpperCase()} ${Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl2)*100)}%`,870,300)
    ctx1.fillText(`${(pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[2].category).toUpperCase()} ${Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[2].ttl)/pie_ttl2)*100)}%`,870,326)
    ctx1.fillText(`OTHERS ${Math.floor((pie_others2/pie_ttl2)*100)}%`,870,350)
    //section4 graph 
    ctx1.font = 'normal 9px Bitter'
    ctx1.fillText('Total Income(JPY)',726,722)
    ctx1.fillText('Jan',622,700)
    ctx1.fillText('Feb',652,700)
    ctx1.fillText('Mar',682,700)
    ctx1.fillText('Apr',712,700)
    ctx1.fillText('May',742,700)
    ctx1.fillText('Jun',772,700)
    ctx1.fillText('Jul',802,700)
    ctx1.fillText('Aug',832,700)
    ctx1.fillText('Sep',862,700)
    ctx1.fillText('Oct',892,700)
    ctx1.fillText('Nov',922,700)
    ctx1.fillText('Dec',956,700)
    //max should be 2yrs
    let a1=[]
    for (let i1=0;i1<incomeSelectedItem+1;i1++){
        let a2=[]
        a2=userFinance[0].income[i1].detail[0].salary.map(x1=>Number(x1.total))
        a2[5]+=userFinance[0].income[i1].detail[0].bonus.map(x1=>Number(x1.total))[0]
        a2[11]+=userFinance[0].income[i1].detail[0].bonus.map(x1=>Number(x1.total))[1]
        a1=a1.concat(a2)
    }
    if(Math.max(...a1).toString().length>5){
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1))/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1))/10000)+1)*10000)}`.length-2)*4.2),511)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*4)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*4)/10000)+1)*10000)}`.length-2)*4.2),546)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*3)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*3)/10000)+1)*10000)}`.length-2)*4.2),583)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*2)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*2)/10000)+1)*10000)}`.length-2)*4.2),619)
        ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1)/5)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1)/5)/10000)+1)*10000)}`.length-2)*4.2),655)
        ctx1.fillText(`${sym()}0`,600,684)
    }else{
        //when a1 == 1-5 digit
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(Math.max(...a1)))}`,600-((`${sym()}${add1M1KSprt(Math.floor(Math.max(...a1)))}`.length-2)*4.2),511)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*4)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*4)*100)/100)}`.length-2)*4.2),546)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*3)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*3)*100)/100)}`.length-2)*4.2),583)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*2)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*2)*100)/100)}`.length-2)*4.2),619)
        ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor((Math.max(...a1)/5)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor((Math.max(...a1)/5)*100)/100)}`.length-2)*4.2),655)
        ctx1.fillText(`${sym()}0`,600,684)
    }
    //graph bar x y w h 
    // y=0%:682 50% 100%506 
    // h=0%:1 50%: 100%:178
    function bar(x1,x2,x3){
        if(a1>10000){
            if(x2=='06'){
                ctx1.fillStyle='#1414143a'
                ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176),16,((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176)
            }else if(x2=='12'){
                ctx1.fillStyle='#1414143a'
                ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176),16,((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176)
            }else{
                ctx1.fillStyle='#1414143a'
                ctx1.fillRect(x1,508+(176-(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176),16,(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176)
            }
        }else{
            if(x2=='06'){
                ctx1.fillStyle='#1414143a'
                ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total))/Math.floor((Math.max(...a1))))*176),16,((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[0].total))/Math.floor((Math.max(...a1))))*176)
            }else if(x2=='12'){
                ctx1.fillStyle='#1414143a'
                ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].total))/Math.floor((Math.max(...a1))))*176),16,((Number(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[incomeSelectedItem].detail[0].bonus[1].total))/Math.floor((Math.max(...a1))))*176)
            }else{
                ctx1.fillStyle='#1414143a'
                ctx1.fillRect(x1,508+(176-(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176),16,(userFinance[0].income[incomeSelectedItem].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176)
            }
            ctx1.fillStyle='#1C2041'
            ctx1.fillRect(852,266,10,10)
            ctx1.stroke()
            ctx1.beginPath()
            ctx1.fillStyle='#606278'
            ctx1.fillRect(852,290,10,10)
            ctx1.stroke()
            ctx1.beginPath()
            ctx1.fillStyle='#76788A'
            ctx1.fillRect(852,316,10,10)
            ctx1.stroke()
            ctx1.beginPath()
            for (let i1=0;i1<incomeSelectedItem;i1++){
                if(x2!='12'){
                    ctx1.beginPath()
                    ctx1.strokeStyle='#606278'
                    ctx1.lineWidth=.6
                    ctx1.moveTo(x1+6,500+(184-(userFinance[0].income[i1].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176))
                    ctx1.lineTo(x1+6+30,500+(184-(userFinance[0].income[i1].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x3)[0].total/Math.floor((Math.max(...a1))))*176))
                    ctx1.stroke()
                }
                ctx1.fillStyle='#606278'
                ctx1.fillRect(x1+4,508+(174-(userFinance[0].income[i1].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176),4,4)
                ctx1.fill()
            }
        }
    }
    //graph lines
    ctx1.strokeStyle='#D9D9D9'
    ctx1.lineWidth=1
    ctx1.beginPath()
    ctx1.moveTo(620,508)
    ctx1.lineTo(980,508)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,544)
    ctx1.lineTo(980,544)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,580)
    ctx1.lineTo(980,580)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,616)
    ctx1.lineTo(980,616)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,652)
    ctx1.lineTo(980,652)
    ctx1.stroke()
    ctx1.strokeStyle='black'
    ctx1.lineWidth=1
    ctx1.beginPath()
    ctx1.moveTo(620,684)
    ctx1.lineTo(980,684)
    ctx1.stroke()
    //1
    ctx1.beginPath()
    bar(626,'01','02')
    ctx1.stroke()
    //2 0% y:506+178 h:1
    ctx1.beginPath()
    bar(656,'02','03')
    ctx1.stroke()
    //3 10% y:506+89 h:89
    ctx1.beginPath()
    bar(686,'03','04')
    ctx1.stroke()
    //4 20%
    ctx1.beginPath()
    bar(716,'04','05')
    ctx1.stroke()
    //5 30% y:506+89 h:89
    ctx1.beginPath()
    bar(746,'05','06')
    ctx1.stroke()
    //6 40%
    ctx1.beginPath()
    bar(776,'06','07')
    ctx1.stroke()
    //7 50% y:506+89 h:89
    ctx1.beginPath()
    bar(808,'07','08')
    ctx1.stroke()
    //8 60%
    ctx1.beginPath()
    bar(838,'08','09')
    ctx1.stroke()
    //9 70%
    ctx1.beginPath()
    bar(866,'09','10')
    ctx1.stroke()
    //10 80%
    ctx1.beginPath()
    bar(896,'10','11')
    ctx1.stroke()
    //11 90%
    ctx1.beginPath()
    bar(926,'11','12')
    ctx1.stroke()
    //12 100%
    ctx1.beginPath()
    bar(958,'12','01')
    ctx1.stroke()
    
    //bold texts
    //tiny texts
    //lines
    ctx1.strokeStyle='black'
    ctx1.lineWidth=1
    ctx1.beginPath()
    ctx1.moveTo(70, 198)
    ctx1.lineTo(980, 198)
    ctx1.stroke()
    //monthly expense
    ctx1.beginPath()
    ctx1.strokeStyle='black'
    ctx1.lineWidth=1
    ctx1.moveTo(540,412)
    ctx1.lineTo(980,412)
    ctx1.stroke()
  }
  const onClick2IncomePrint=()=>{
    const tmp3_1=document.getElementById('tmp3')
    const tmp1_2=document.createElement('canvas')
    const tmp2_2=document.createElement('canvas')
    const tmp3_2=document.createElement('canvas')
    tmp1_2.height=793.92
    tmp1_2.width=1122.24
    tmp2_2.height=793.92
    tmp2_2.width=1122.24
    tmp3_2.height=793.92
    tmp3_2.width=1122.24
    var ctx1=tmp3_2.getContext('2d') 
    ctx1.canvas.width=1122.24*2
    ctx1.canvas.height=793.92*2
    ctx1.setTransform(.5, 0, 0, .5, 0, 0)
    ctx1.drawImage(tmp3_1,0,0,1122.24*4,793.92*4)
    tmp3_2.toBlob(async(x1) =>{
        let x2=await toBase64(x1)
        x2=x2.split(',')[1]
        try{
            const { data: res } = await axios.post(`${APIURL}/asset/pdf`,{'png1':x2.toString(),'png2':''})
            toIncomeUrl(res.pdf)
        }catch(err){
            console.log(err)
        }
    }, 'image/png')
  }
  const onClick2IncomePrintAll=async()=>{
    setIncomePrintLoading(true)
    let pngall={'png1':'','png2':''}
    for(let i=0;i<userFinance[0].income.length;i++){
        var tmp3_1=document.getElementById('tmp3')
        tmp3_1.height=793.92*4
        tmp3_1.width=1122.24*4
        var ctx1=tmp3_1.getContext('2d')
        ctx1.scale(4, 4)
        ctx1.setTransform(4,0,0,4,0,0)
        ctx1.fillStyle='black'
        ctx1.font = 'bold 24px Bitter'
        //section1 header
        //bold texts w h
        ctx1.fillText('Dev Cookbooks',70,124)
        ctx1.font='bold 18px Bitter'
        ctx1.fillText(`${userInfo.firstname} ${userInfo.lastname}`,540,120)
        ctx1.fillText('Ashley Lee(AI Agent)',766,120)
        //tiny texts
        ctx1.font='normal 12px Bitter'
        ctx1.fillText('prepared for:',540,90)
        ctx1.fillText('Yearly Income Overview:',540,140)
        ctx1.fillText(stringDate(userFinance[0].income[i].date),540,166)
        ctx1.fillText('prepared by:',766,90)
        ctx1.fillText('Investment Advisor',766,140)
        ctx1.fillText('Wealth Management',766,156)
        //section2 items
        //bold texts w h
        ctx1.font='normal 20px Bitter'
        ctx1.fillText('Salary',70,240)
        ctx1.fillText('Over working Hours',70,634)
        ctx1.fillText('Monthly Income',540,440)
        //tiny texts
        ctx1.font='normal 9px sans-serif'
        //ttl
        ctx1.fillText('Month',70,280)
        ctx1.fillText('Base',150,280)
        ctx1.fillText('Overwork',224,272)
        ctx1.fillText('Hours',224,280)
        ctx1.fillText('Over Work',280,280)
        ctx1.fillText('Deduction',346,280)
        ctx1.fillText('Total Earning',416,280)
        ctx1.beginPath()
        ctx1.lineWidth=2
        ctx1.moveTo(70, 286)
        ctx1.lineTo(500, 286)
        ctx1.stroke()
        //items
        for(let x1=0;x1<12;x1++){    
            ctx1.fillText(stringDate(userFinance[0].income[i].detail[0].salary[x1].date).slice(0,3),70,306+(20*x1))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].salary[x1].items[0].value),190-(6*(userFinance[0].income[i].detail[0].salary[x1].items[0].value.toString().length)),306+(20*x1))
            ctx1.fillText(userFinance[0].income[i].detail[0].salary[x1].items[1].hours,234-(6*(userFinance[0].income[i].detail[0].salary[x1].items[1].hours.toString().length-3)),306+(20*x1))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].salary[x1].items[1].value),320-(4*(add1M1KSprt(userFinance[0].income[i].detail[0].salary[x1].items[1].value).toString().length-1)),306+(20*x1))
            ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[i].detail[0].salary[x1].items[3].value)+Number(userFinance[0].income[i].detail[0].salary[x1].items[4].value)),386-(6*((Number(userFinance[0].income[i].detail[0].salary[x1].items[3].value)+Number(userFinance[0].income[i].detail[0].salary[x1].items[4].value)).toString().length)),306+(20*x1))
            ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].salary[x1].total),476-(6*(userFinance[0].income[i].detail[0].salary[x1].total.toString().length)),306+(20*x1))
            if(x1==11&&Number(userFinance[0].income[i].detail[0].bonus[0].total)!=0){
                ctx1.beginPath()
                ctx1.lineWidth=1
                ctx1.moveTo(70,310+(20*x1))
                ctx1.lineTo(500,310+(20*x1))
                ctx1.stroke()
                ctx1.fillText('Bonus 1',70,306+(20*(x1+1)))
                ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].bonus[0].items[0].value),190-(6*userFinance[0].income[i].detail[0].bonus[0].items[0].value.toString().length),306+(20*(x1+1)))
                ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[i].detail[0].bonus[0].items[1].value)+Number(userFinance[0].income[i].detail[0].bonus[0].items[2].value)),386-(6*((Number(userFinance[0].income[i].detail[0].bonus[0].items[1].value)+Number(userFinance[0].income[i].detail[0].bonus[0].items[2].value)).toString().length)),306+(20*(x1+1)))
                ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].bonus[0].total),476-(6*(userFinance[0].income[i].detail[0].bonus[0].total.toString().length)),306+(20*(x1+1)))
                ctx1.beginPath()
                ctx1.lineWidth=1
                ctx1.moveTo(70,310+(20*(x1+1)))
                ctx1.lineTo(500,310+(20*(x1+1)))
                ctx1.stroke()
                ctx1.fillText('Bonus 2',70,306+(20*(x1+2)))
                ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].bonus[1].items[0].value),190-(6*userFinance[0].income[i].detail[0].bonus[1].items[0].value.toString().length),306+(20*(x1+2)))
                ctx1.fillText(add1M1KSprt(Number(userFinance[0].income[i].detail[0].bonus[1].items[1].value)+Number(userFinance[0].income[i].detail[0].bonus[1].items[2].value)),386-(6*((Number(userFinance[0].income[i].detail[0].bonus[1].items[1].value)+Number(userFinance[0].income[i].detail[0].bonus[1].items[2].value)).toString().length)),306+(20*(x1+2)))
                ctx1.fillText(add1M1KSprt(userFinance[0].income[i].detail[0].bonus[1].total),476-(6*(userFinance[0].income[i].detail[0].bonus[1].total.toString().length)),306+(20*(x1+2)))
                ctx1.beginPath()
                ctx1.lineWidth=2
                ctx1.moveTo(70,310+(20*(x1+2)))
                ctx1.lineTo(500,310+(20*(x1+2)))
                ctx1.stroke()
                ctx1.fillText(`${sym()}${add1M1KSprt(userFinance[0].income[i].total)}`,486-(6*(`${sym()}${add1M1KSprt(userFinance[0].income[i].total)}`).length),324+(20*(x1+2)))
            }else if(x1==11&&Number(userFinance[0].income[i].detail[0].bonus[0].total)==0){
                ctx1.beginPath()
                ctx1.lineWidth=2
                ctx1.moveTo(70,310+(20*x1))
                ctx1.lineTo(500,310+(20*x1))
                ctx1.stroke()
                ctx1.fillText(`${sym()}${add1M1KSprt(userFinance[0].income[i].total)}`,476-(6*(`${sym()}${add1M1KSprt(userFinance[0].income[i].total)}`).length),324+(20*x1))
            }else{
                ctx1.beginPath()
                ctx1.lineWidth=1
                ctx1.moveTo(70,310+(20*x1))
                ctx1.lineTo(500,310+(20*x1))
                ctx1.stroke()
            }
        }
        //ttl
        ctx1.font='9px bold'
        const m_list=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
        for(let x1=0;x1<12;x1++){    
            ctx1.fillText(m_list[x1],112+(33*x1),672)
        }
        ctx1.beginPath()
        ctx1.lineWidth=2
        ctx1.moveTo(70,678)
        ctx1.lineTo(500,678)
        ctx1.stroke()
        //item 1
        ctx1.font='normal 9px sans-serif'
        if(i>1){
            for(let x1=0;x1<3;x1++){
                ctx1.fillText(userFinance[0].income[(i-2)+x1].date.slice(0,4),74,696+(20*x1))
                    for(let x3=0;x3<12;x3++){
                    ctx1.fillText(userFinance[0].income[(i-2)+x1].detail[0].salary[x3].items[1].hours,112+(33*x3)-(2*(userFinance[0].income[(i-2)+x1].detail[0].salary[x3].items[1].hours.toString().length-4)),696+(20*x1))
                }
                if (x1==2){
                    ctx1.beginPath()
                    ctx1.lineWidth=2
                    ctx1.moveTo(70,700+(20*x1))
                    ctx1.lineTo(500,700+(20*x1))
                    ctx1.stroke()
                }else{
                    ctx1.beginPath()
                    ctx1.lineWidth=1
                    ctx1.moveTo(70,700+(20*x1))
                    ctx1.lineTo(500,700+(20*x1))
                    ctx1.stroke()
                }
            }
        }else if(i==1){
            for(let x1=0;x1<2;x1++){
                ctx1.fillText(userFinance[0].income[(i-1)+x1].date.slice(0,4),74,696+(20*x1))
                    for(let x3=0;x3<12;x3++){    
                    ctx1.fillText(userFinance[0].income[(i-1)+x1].detail[0].salary[x3].items[1].hours,112+(33*x3),696+(20*x1))
                }
                if (x1==2){
                    ctx1.beginPath()
                    ctx1.lineWidth=2
                    ctx1.moveTo(70,700+(20*x1))
                    ctx1.lineTo(500,700+(20*x1))
                    ctx1.stroke()
                }else{
                    ctx1.beginPath()
                    ctx1.lineWidth=1
                    ctx1.moveTo(70,700+(20*x1))
                    ctx1.lineTo(500,700+(20*x1))
                    ctx1.stroke()
                }
            }
        }else if(i==0){
            ctx1.fillText(userFinance[0].income[i].date.slice(0,4),74,696)
            for(let x3=0;x3<12;x3++){    
                ctx1.fillText(userFinance[0].income[i].detail[0].salary[x3].items[1].hours,112+(33*x3),696)
        }
            ctx1.beginPath()
            ctx1.lineWidth=1
            ctx1.moveTo(70,700)
            ctx1.lineTo(500,700)
            ctx1.stroke()
        }
        //section3 pie
        ctx1.beginPath()
        ctx1.fillStyle='#1C2041'
        ctx1.fillRect(852,266,10,10)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.fillStyle='#606278'
        ctx1.fillRect(852,290,10,10)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.fillStyle='#76788A'
        ctx1.fillRect(852,316,10,10)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.fillStyle='#D9D9D9'
        ctx1.fillRect(852,340,10,10)
        ctx1.stroke()
        const data=[{label:pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[0].category,value:Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl2)*100),color:'#0F1336'},{label:pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[1].category,value:Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl2)*100),color:'#606278'},{label:pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[2].category,value:Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl-x1.ttl)[2].ttl)/pie_ttl2)*100),color:'#76788A'},{label:'Other',value:Math.floor((pie_others2/pie_ttl2)*100),color:'#D9D9D9'}]
        const total=data.reduce((x,i)=>x+i.value,0)||1
        const cx=720
        const cy=300
        const r=Math.min(180,180)/2*0.9
        let st=-Math.PI/2
        data.forEach((x) => {
        const end=st+((x.value/total)*Math.PI*2)
        ctx1.beginPath()
        ctx1.moveTo(cx,cy)
        ctx1.arc(cx,cy,r,st,end);
        ctx1.closePath();
        ctx1.fillStyle = x.color||'#999'
        ctx1.fill()
        st=end
        })
        ctx1.beginPath()
        ctx1.fillStyle='black'
        ctx1.font = 'normal 11px Bitter'
        ctx1.fillText(`${(pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[0].category).toUpperCase()} ${Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl2)*100)}%`,870,276)
        ctx1.fillText(`${(pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[1].category).toUpperCase()} ${Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl2)*100)}%`,870,300)
        ctx1.fillText(`${(pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[2].category).toUpperCase()} ${Math.floor(((pie_item2.sort((x1,x2)=>x2.ttl - x1.ttl)[2].ttl)/pie_ttl2)*100)}%`,870,326)
        ctx1.fillText(`OTHERS ${Math.floor((pie_others2/pie_ttl2)*100)}%`,870,350)
        //section4 graph 
        ctx1.font = 'normal 9px Bitter'
        ctx1.fillText('Total Income(JPY)',726,722)
        ctx1.fillText('Jan',622,700)
        ctx1.fillText('Feb',652,700)
        ctx1.fillText('Mar',682,700)
        ctx1.fillText('Apr',712,700)
        ctx1.fillText('May',742,700)
        ctx1.fillText('Jun',772,700)
        ctx1.fillText('Jul',802,700)
        ctx1.fillText('Aug',832,700)
        ctx1.fillText('Sep',862,700)
        ctx1.fillText('Oct',892,700)
        ctx1.fillText('Nov',922,700)
        ctx1.fillText('Dec',956,700)
        //max should be 2yrs
        let a1=[]
        for (let i1=0;i1<i+1;i1++){
            let a2=[]
            a2=userFinance[0].income[i1].detail[0].salary.map(x1=>Number(x1.total))
            a2[5]+=userFinance[0].income[i1].detail[0].bonus.map(x1=>Number(x1.total))[0]
            a2[11]+=userFinance[0].income[i1].detail[0].bonus.map(x1=>Number(x1.total))[1]
            a1=a1.concat(a2)
        }
        if(Math.max(...a1).toString().length>5){
            ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1))/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1))/10000)+1)*10000)}`.length-2)*4.2),511)
            ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*4)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*4)/10000)+1)*10000)}`.length-2)*4.2),546)
            ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*3)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*3)/10000)+1)*10000)}`.length-2)*4.2),583)
            ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*2)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor(((Math.max(...a1)/5)*2)/10000)+1)*10000)}`.length-2)*4.2),619)
            ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1)/5)/10000)+1)*10000)}`,600-((`${sym()}${add1M1KSprt((Math.floor((Math.max(...a1)/5)/10000)+1)*10000)}`.length-2)*4.2),655)
            ctx1.fillText(`${sym()}0`,600,684)
        }else{
            //when a1 == 1-5 digit
            ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(Math.max(...a1)))}`,600-((`${sym()}${add1M1KSprt(Math.floor(Math.max(...a1)))}`.length-2)*4.2),511)
            ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*4)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*4)*100)/100)}`.length-2)*4.2),546)
            ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*3)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*3)*100)/100)}`.length-2)*4.2),583)
            ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*2)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor(((Math.max(...a1)/5)*2)*100)/100)}`.length-2)*4.2),619)
            ctx1.fillText(`${sym()}${add1M1KSprt(Math.floor((Math.max(...a1)/5)*100)/100)}`,600-((`${sym()}${add1M1KSprt(Math.floor((Math.max(...a1)/5)*100)/100)}`.length-2)*4.2),655)
            ctx1.fillText(`${sym()}0`,600,684)
        }
        //graph bar x y w h 
        // y=0%:682 50% 100%506 
        // h=0%:1 50%: 100%:178
        function bar(x1,x2,x3){
            if(a1>10000){
                if(x2=='06'){
                    ctx1.fillStyle='#1414143a'
                    ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[0].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176),16,((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[0].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176)
                }else if(x2=='12'){
                    ctx1.fillStyle='#1414143a'
                    ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[1].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176),16,((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[1].total))/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176)
                }else{
                    ctx1.fillStyle='#1414143a'
                    ctx1.fillRect(x1,508+(176-(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176),16,(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...a1))/10000)+1)*10000))*176)
                }
            }else{
                if(x2=='06'){
                    ctx1.fillStyle='#1414143a'
                    ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[0].total))/Math.floor((Math.max(...a1))))*176),16,((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[0].total))/Math.floor((Math.max(...a1))))*176)
                }else if(x2=='12'){
                    ctx1.fillStyle='#1414143a'
                    ctx1.fillRect(x1,508+(176-((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[1].total))/Math.floor((Math.max(...a1))))*176),16,((Number(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total)+Number(userFinance[0].income[i].detail[0].bonus[1].total))/Math.floor((Math.max(...a1))))*176)
                }else{
                    ctx1.fillStyle='#1414143a'
                    ctx1.fillRect(x1,508+(176-(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176),16,(userFinance[0].income[i].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176)
                }
                ctx1.fillStyle='#1C2041'
                ctx1.fillRect(852,266,10,10)
                ctx1.stroke()
                ctx1.beginPath()
                ctx1.fillStyle='#606278'
                ctx1.fillRect(852,290,10,10)
                ctx1.stroke()
                ctx1.beginPath()
                ctx1.fillStyle='#76788A'
                ctx1.fillRect(852,316,10,10)
                ctx1.stroke()
                ctx1.beginPath()
                for (let i1=0;i1<i;i1++){
                    if(x2!='12'){
                        ctx1.beginPath()
                        ctx1.strokeStyle='#606278'
                        ctx1.lineWidth=.6
                        ctx1.moveTo(x1+6,500+(184-(userFinance[0].income[i1].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176))
                        ctx1.lineTo(x1+6+30,500+(184-(userFinance[0].income[i1].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x3)[0].total/Math.floor((Math.max(...a1))))*176))
                        ctx1.stroke()
                    }
                    ctx1.fillStyle='#606278'
                    ctx1.fillRect(x1+4,508+(174-(userFinance[0].income[i1].detail[0].salary.filter(x1=>x1.date.slice(5,7)==x2)[0].total/Math.floor((Math.max(...a1))))*176),4,4)
                    ctx1.fill()
                }
            }
        }
        //graph lines
        ctx1.strokeStyle='#D9D9D9'
        ctx1.lineWidth=1
        ctx1.beginPath()
        ctx1.moveTo(620,508)
        ctx1.lineTo(980,508)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.moveTo(620,544)
        ctx1.lineTo(980,544)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.moveTo(620,580)
        ctx1.lineTo(980,580)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.moveTo(620,616)
        ctx1.lineTo(980,616)
        ctx1.stroke()
        ctx1.beginPath()
        ctx1.moveTo(620,652)
        ctx1.lineTo(980,652)
        ctx1.stroke()
        ctx1.strokeStyle='black'
        ctx1.lineWidth=1
        ctx1.beginPath()
        ctx1.moveTo(620,684)
        ctx1.lineTo(980,684)
        ctx1.stroke()
        //1
        ctx1.beginPath()
        bar(626,'01','02')
        ctx1.stroke()
        //2 0% y:506+178 h:1
        ctx1.beginPath()
        bar(656,'02','03')
        ctx1.stroke()
        //3 10% y:506+89 h:89
        ctx1.beginPath()
        bar(686,'03','04')
        ctx1.stroke()
        //4 20%
        ctx1.beginPath()
        bar(716,'04','05')
        ctx1.stroke()
        //5 30% y:506+89 h:89
        ctx1.beginPath()
        bar(746,'05','06')
        ctx1.stroke()
        //6 40%
        ctx1.beginPath()
        bar(776,'06','07')
        ctx1.stroke()
        //7 50% y:506+89 h:89
        ctx1.beginPath()
        bar(808,'07','08')
        ctx1.stroke()
        //8 60%
        ctx1.beginPath()
        bar(838,'08','09')
        ctx1.stroke()
        //9 70%
        ctx1.beginPath()
        bar(866,'09','10')
        ctx1.stroke()
        //10 80%
        ctx1.beginPath()
        bar(896,'10','11')
        ctx1.stroke()
        //11 90%
        ctx1.beginPath()
        bar(926,'11','12')
        ctx1.stroke()
        //12 100%
        ctx1.beginPath()
        bar(958,'12','01')
        ctx1.stroke()
        
        //bold texts
        //tiny texts
        //lines
        ctx1.strokeStyle='black'
        ctx1.lineWidth=1
        ctx1.beginPath()
        ctx1.moveTo(70, 198)
        ctx1.lineTo(980, 198)
        ctx1.stroke()
        //monthly income
        ctx1.beginPath()
        ctx1.strokeStyle='black'
        ctx1.lineWidth=1
        ctx1.moveTo(540,412)
        ctx1.lineTo(980,412)
        ctx1.stroke()
        const tmp3_2=document.createElement('canvas')
        tmp3_2.height=793.92
        tmp3_2.width=1122.24
        var ctx1=tmp3_2.getContext('2d') 
        ctx1.canvas.width=1122.24*2
        ctx1.canvas.height=793.92*2
        ctx1.setTransform(.5, 0, 0, .5, 0, 0)
        ctx1.drawImage(tmp3_1,0,0,1122.24*4,793.92*4)
        tmp3_2.toBlob(async(x1) =>{
            let x2=await toBase64(x1)
            x2=x2.split(',')[1]
            pngall[`png${i+1}`]=x2
        }, 'image/png')
    }
    setTimeout(async() => {
        try{
            const { data: res } = await axios.post(`${APIURL}/asset/pdfall`,pngall)
            toIncomeUrlAll(res.pdf)
        }catch(err){
            console.log(err)
        }
        setIncomePrintLoading(false)
    },9000)
  }
  const onClick2ExpenseLoadPdf=async()=>{
    if(expensePdfType!='expense_mmyyyy.pdf'){
        setExpensePrintLoading(true)
        setTimeout(async() => {
            setExpensePrintLoading(false)
          },1000)
    }
    setExpensePdfType(`expense_${userFinance[0].expense[expenseSelectedItem].date.slice(5,7)}${userFinance[0].expense[expenseSelectedItem].date.slice(0,4)}.pdf`)    
    var tmp1=document.getElementById('tmp1')
    tmp1.height=793.92*4
    tmp1.width=1122.24*4
    var ctx1=tmp1.getContext('2d')
    ctx1.scale(4, 4)
    ctx1.setTransform(4,0,0,4,0,0)
    ctx1.fillStyle='black'
    ctx1.font = 'bold 24px Bitter'
    //section1 header
    //bold texts w h
    ctx1.fillText('Dev Cookbooks',70,124)
    ctx1.font='bold 18px Bitter'
    ctx1.fillText(`${userInfo.firstname} ${userInfo.lastname}`,540,120)
    ctx1.fillText('Ashley Lee(AI Agent)',766,120)
    //tiny texts
    ctx1.font='normal 12px Bitter'
    ctx1.fillText('prepared for:',540,90)
    ctx1.fillText('Monthly Expense Overview:',540,140)
    ctx1.fillText(stringDate(userFinance[0].expense[expenseSelectedItem].date),540,166)
    ctx1.fillText('prepared by:',766,90)
    ctx1.fillText('Investment Advisor',766,140)
    ctx1.fillText('Wealth Management',766,156)
    //section2 items
    //bold texts w h
    ctx1.font='normal 20px Bitter'
    ctx1.fillText('Food',70,240)
    ctx1.fillText('Other',70,440)
    ctx1.fillText('Credit and Rent',70,656)
    ctx1.fillText('Monthly Expense',540,440)
    //tiny texts
    ctx1.font='normal 9px Bitter'
    ctx1.fillText('Categories',70,280)
    ctx1.fillText('Budget min',200,280)
    ctx1.fillText('Budget max',280,280)
    ctx1.fillText('Value',380,280)
    ctx1.fillText('Result',468,280)
    ctx1.fillText('Categories',70,474)
    ctx1.fillText('Budget min',200,474)
    ctx1.fillText('Budget max',280,474)
    ctx1.fillText('Value',380,474)
    ctx1.fillText('Result',468,474)
    ctx1.fillText('Categories',70,676)
    ctx1.fillText('Budget min',200,676)
    ctx1.fillText('Budget max',280,676)
    ctx1.fillText('Value',380,676)
    ctx1.fillText('Result',468,676)
    ctx1.fillText('Must',70,304)
    ctx1.fillText('For Pantry',70,324)
    ctx1.fillText('Sweets&Snacks',70,346)
    ctx1.fillText('Veggies',70,368)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].category_total),380,304)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].category_total),380,324)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].category_total),380,346)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].category_total),380,368)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].section_total),380,390)
    ctx1.fillText('Work',70,498)
    ctx1.fillText('Hungout',70,518)
    ctx1.fillText('Bettre me',70,540)
    ctx1.fillText('Emergency',70,560)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].category_total),380,498)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].category_total),380,518)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].category_total),380,540)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].category_total),380,560)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].section_total),380,584)
    ctx1.fillText('Credit',70,702)
    ctx1.fillText('Result',70,724)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].category_total),380,702)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].category_total),380,724)
    ctx1.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].section_total),380,748)
    
    //section3 pie
    ctx1.beginPath()
    ctx1.fillStyle='#1C2041'
    ctx1.fillRect(852,266,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#606278'
    ctx1.fillRect(852,290,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#76788A'
    ctx1.fillRect(852,316,10,10)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.fillStyle='#D9D9D9'
    ctx1.fillRect(852,340,10,10)
    ctx1.stroke()
    // ctx1.beginPath()
    // ctx1.fillStyle='#D9D9D9'
    // ctx1.arc(720,300,70,0,2*Math.PI)
    // ctx1.stroke()
    const data=[{label:pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[0].category,value:Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl3)*100),color:'#0F1336'},{label:pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[1].category,value:Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl3)*100),color:'#606278'},{label:pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[2].category,value:Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[2].ttl)/pie_ttl3)*100),color:'#76788A'},{label:'Other',value:Math.floor((pie_others3/pie_ttl3)*100),color:'#D9D9D9'}]
    const total=data.reduce((x,i)=>x+i.value,0)||1
    const cx=720
    const cy=300
    const r=Math.min(180,180)/2*0.9
    let st=-Math.PI/2
    data.forEach((x) => {
      const end=st+((x.value/total)*Math.PI*2)
      ctx1.beginPath()
      ctx1.moveTo(cx,cy)
      ctx1.arc(cx,cy,r,st,end);
      ctx1.closePath();
      ctx1.fillStyle = x.color||'#999'
      ctx1.fill()
      st=end
    })
    ctx1.beginPath()
    ctx1.fillStyle='black'
    ctx1.font = 'normal 11px Bitter'
    ctx1.fillText(`${(pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[0].category).toUpperCase()} ${Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl3)*100)}%`,870,276)
    ctx1.fillText(`${(pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[1].category).toUpperCase()} ${Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl3)*100)}%`,870,300)
    ctx1.fillText(`${(pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[2].category).toUpperCase()} ${Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[2].ttl)/pie_ttl3)*100)}%`,870,326)
    ctx1.fillText(`OTHERS ${Math.floor((pie_others3/pie_ttl3)*100)}%`,870,350)
    //section4 graph 
    ctx1.font = 'normal 9px Bitter'
    ctx1.fillText('Total Expense(JPY)',726,722)
    ctx1.fillText('Jan',622,700)
    ctx1.fillText('Feb',652,700)
    ctx1.fillText('Mar',682,700)
    ctx1.fillText('Apr',712,700)
    ctx1.fillText('May',742,700)
    ctx1.fillText('Jun',772,700)
    ctx1.fillText('Jul',802,700)
    ctx1.fillText('Aug',832,700)
    ctx1.fillText('Sep',862,700)
    ctx1.fillText('Oct',892,700)
    ctx1.fillText('Nov',922,700)
    ctx1.fillText('Dec',956,700)
    ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)}`,600-(((`${sym()}${add1M1KSprt((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)}`).length-2)*4.2),511)
    ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*4)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*4)}`).length-2)*4.2),546)
    ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*3)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*3)}`).length-2)*4.2),583)
    ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*2)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*2)}`).length-2)*4.2),619)
    ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5)}`).length-2)*4.2),655)
    ctx1.fillText(`${sym()}0`,600,684)
    //graph bar x y w h 
    // y=0%:682 50% 100%506 
    // h=0%:1 50%: 100%:178
    function bar(x1,x2){
        if(userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).filter(x4=>x4.date.slice(5,7)==x2)!=''){
            ctx1.fillRect(x1,508+(176-userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).filter(x4=>x4.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x4=>x4.total)))/10000)+1)*10000)*176),16,userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).filter(x4=>x4.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x4=>x4.total)))/10000)+1)*10000)*176)
        }
    }
    //1
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Jan'?'#76788A':'#C7C7C7'}`
    bar(626,'01')
    ctx1.stroke()
    //2 0% y:506+178 h:1
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Feb'?'#76788A':'#C7C7C7'}`
    bar(656,'02')
    ctx1.stroke()
    //3 10% y:506+89 h:89
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Mar'?'#76788A':'#C7C7C7'}`
    bar(686,'03')
    ctx1.stroke()
    //4 20%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Apr'?'#76788A':'#C7C7C7'}`
    bar(716,'04')
    ctx1.stroke()
    //5 30% y:506+89 h:89
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='May'?'#76788A':'#C7C7C7'}`
    bar(746,'05')
    ctx1.stroke()
    //6 40%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Jun'?'#76788A':'#C7C7C7'}`
    bar(776,'06')
    ctx1.stroke()
    //7 50% y:506+89 h:89
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Jul'?'#76788A':'#C7C7C7'}`
    bar(808,'07')
    ctx1.stroke()
    //8 60%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Aug'?'#76788A':'#C7C7C7'}`
    bar(838,'08')
    ctx1.stroke()
    //9 70%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Sep'?'#76788A':'#C7C7C7'}`
    bar(866,'09')
    ctx1.stroke()
    //10 80%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Oct'?'#76788A':'#C7C7C7'}`
    bar(896,'10')
    ctx1.stroke()
    //11 90%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Nov'?'#76788A':'#C7C7C7'}`
    bar(926,'11')
    ctx1.stroke()
    //12 100%
    ctx1.beginPath()
    ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Dec'?'#76788A':'#C7C7C7'}`
    bar(958,'12')
    ctx1.stroke()
    //graph lines
    ctx1.beginPath()
    ctx1.moveTo(620,508)
    ctx1.lineTo(980,508)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,544)
    ctx1.lineTo(980,544)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,580)
    ctx1.lineTo(980,580)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,616)
    ctx1.lineTo(980,616)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,652)
    ctx1.lineTo(980,652)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(620,684)
    ctx1.lineTo(980,684)
    ctx1.stroke()
    //bold texts
    //tiny texts

    //lines
    ctx1.beginPath()
    ctx1.moveTo(70, 198)
    ctx1.lineTo(980, 198)
    ctx1.stroke()
    //1 
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70, 286)
    ctx1.lineTo(500, 286)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.lineWidth=1
    ctx1.moveTo(70,310)
    ctx1.lineTo(500,310)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(70,330)
    ctx1.lineTo(500,330)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(70,354)
    ctx1.lineTo(500,354)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70, 376)
    ctx1.lineTo(500, 376)
    ctx1.stroke()
    //2
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70,480)
    ctx1.lineTo(500,480)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.lineWidth=1
    ctx1.moveTo(70,502)
    ctx1.lineTo(500,502)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(70,524)
    ctx1.lineTo(500,524)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.moveTo(70,546)
    ctx1.lineTo(500,546)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70,568)
    ctx1.lineTo(500,568)
    ctx1.stroke()
    //3
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70,684)
    ctx1.lineTo(500,684)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.lineWidth=1
    ctx1.moveTo(70,710)
    ctx1.lineTo(500,710)
    ctx1.stroke()
    ctx1.beginPath()
    ctx1.lineWidth=2
    ctx1.moveTo(70,730)
    ctx1.lineTo(500,730)
    ctx1.stroke()
    //monthly expense
    ctx1.beginPath()
    ctx1.lineWidth=1
    ctx1.moveTo(540,412)
    ctx1.lineTo(980,412)
    ctx1.stroke()
    var tmp2=document.getElementById('tmp2')
    tmp2.height=793.92*4
    tmp2.width=1122.24*4
    var ctx2=tmp2.getContext('2d')
    ctx2.scale(4, 4)
    ctx2.setTransform(4,0,0,4,0,0)
    ctx2.fillStyle='black'
    ctx2.font='bold 24px Bitter'
    //section1 header
    //bold texts w h
    //tiny texts
    //section2 items
    //bold texts w h
    //ttl
    ctx2.font='bold 10px Bitter'
    ctx2.fillText('Detail: Food',92,142)
    ctx2.fillText('Detail: Other(cash)',92,348)
    ctx2.fillText('Detail: Credit and Rent',92,560)
    ctx2.font = 'normal 9px Bitter'
    //1
    ctx2.fillText('Must',96,174)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(92,184)
    ctx2.lineTo(296,184)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items[i].amount}`,96,202+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].items[i].price),260-extend,202+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(92,210+(26*i))
            ctx2.lineTo(296,210+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].category_total.toString().length
            if (exceeded_digit==4){extend=14
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',96,202+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[0].category_total)}`,260-extend,202+(26*i))
        }
    }
    //2
    ctx2.fillText('For Pantry',318,174)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(314,184)
    ctx2.lineTo(518,184)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items[i].amount}`,318,204+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items[i].price),474-extend,204+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(314,210+(26*i))
            ctx2.lineTo(518,210+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].category_total.toString().length
            if (exceeded_digit==4){extend=14
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',318,204+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[1].category_total)}`,474-extend,204+(26*i))
        }
    }
    // 3
    ctx2.fillText('Sweets',542,174)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(538,184)
    ctx2.lineTo(738,184)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items[i].amount}`,542,204+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items[i].price),704-extend,204+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(538,210+(26*i))
            ctx2.lineTo(738,210+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].category_total.toString().length
            if (exceeded_digit==4){extend=14
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',542,204+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[2].category_total)}`,704-extend,204+(26*i))
        }
    }
    //4
    ctx2.fillText('Veggies',772,174)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(768,184)
    ctx2.lineTo(968,184)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items[i].amount}`,772,204+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items[i].price),924-extend,204+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(768,210+(26*i))
            ctx2.lineTo(968,210+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].category_total.toString().length
            if (exceeded_digit==4){extend=14
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',772,204+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].detail[3].category_total)}`,916-extend,204+(26*i))
        }
    }
    ctx2.fillText('Work',92,382)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(92,392)
    ctx2.lineTo(296,392)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items[i].amount}`,92,408+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items[i].price),260-extend,408+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(92,416+(26*i))
            ctx2.lineTo(296,416+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].category_total.toString().length
            if (exceeded_digit==4){extend=10
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',92,412+(24*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[0].category_total)}`,260-extend,412+(24*i))
        }
    }
    ctx2.fillText('Hangout',314,382)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(314,392)
    ctx2.lineTo(514,392)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items[i].amount}`,314,408+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items[i].price),474-extend,408+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(314,416+(26*i))
            ctx2.lineTo(514,416+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].category_total.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',314,408+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[1].category_total)}`,464-extend,408+(26*i))
        }
    }
    ctx2.fillText('Better me',538,382)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(538,392)
    ctx2.lineTo(738,392)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items[i].price.toString().length
            if (exceeded_digit==4){extend=6
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items[i].amount}`,538,408+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items[i].price),704-extend,408+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(538,416+(26*i))
            ctx2.lineTo(738,416+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].category_total.toString().length
            if (exceeded_digit==4){extend=14
            }else if(exceeded_digit==5){extend=18}
            ctx2.fillText('Total',538,408+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[2].category_total)}`,704-extend,408+(26*i))
        }
    }
    ctx2.fillText('Emergency',768,382)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(768,392)
    ctx2.lineTo(968,392)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated((userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items[i].name))}x${userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items[i].amount}`,768,408+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items[i].price),924-extend,408+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(768,416+(26*i))
            ctx2.lineTo(968,416+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].category_total.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',768,408+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].detail[3].category_total)}`,918-extend,408+(26*i))
        }
        
    }
    // ctx2.fillText('XXX',534,462)
    // for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[2].detail[2].items.length;i++){
    //     let extend=0
    //     const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[2].detail[2].items[i].price.toString().length
    //     if (exceeded_digit==4){extend=4
    //     }else if(exceeded_digit==5){extend=14}
    //     ctx2.fillText(`${userFinance[0].expense[expenseSelectedItem].detail[2].detail[2].items[i].name}x${userFinance[0].expense[expenseSelectedItem].detail[2].detail[2].items[i].amount}`,534,490+(20*i))
    //     ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[2].items[i].price),698-extend,490+(20*i))
    // }
    // ctx2.fillText('Total',534,592)
    // ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[2].category_total)}`,676,592)

    ctx2.fillText('Credit',92,590)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(92,600)
    ctx2.lineTo(296,600)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items[i].amount}`,92,618+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items[i].price),260-extend,618+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(92,628+(26*i))
            ctx2.lineTo(296,628+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].category_total.toString().length
            if (exceeded_digit==4){extend=10
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',92,618+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[0].category_total)}`,260-extend,618+(26*i))
        }
    }
    ctx2.fillText('Rent',314,590)
    ctx2.beginPath() 
    ctx2.lineWidth=2
    ctx2.moveTo(314,600)
    ctx2.lineTo(514,600)
    ctx2.stroke()
    for(let i=0;i<userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items.length+1;i++){
        let extend=0
        if(i!=userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items.length){
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items[i].price.toString().length
            if (exceeded_digit==4){extend=4
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText(`${turncated(userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items[i].name)}x${userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items[i].amount}`,314,618+(26*i))
            ctx2.fillText(add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items[i].price),474-extend,618+(26*i))
            if(i!=userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].items.length-1){
                ctx2.lineWidth=1
            }else{
                ctx2.lineWidth=2
            }
            ctx2.beginPath() 
            ctx2.moveTo(314,628+(26*i))
            ctx2.lineTo(514,628+(26*i))
            ctx2.stroke()
        }else{
            const exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].category_total.toString().length
            if (exceeded_digit==4){extend=14
            }else if(exceeded_digit==5){extend=14}
            ctx2.fillText('Total',314,618+(26*i))
            ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].detail[1].category_total)}`,464-extend,618+(26*i)) //5digit
        }
    }
    //5
    ctx2.fillText('Food',768,590)
    let extend=0
    let exceeded_digit=userFinance[0].expense[expenseSelectedItem].detail[0].section_total.toString().length
    if (exceeded_digit==4){extend=4
    }else if(exceeded_digit==5){extend=6
    }else if(exceeded_digit==6){extend=10 
    }else if(exceeded_digit==7){extend=14}
    ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[0].section_total)}`,918-extend,590)
    ctx2.lineWidth=1
    ctx2.beginPath()
    ctx2.moveTo(764,600)
    ctx2.lineTo(964,600)
    ctx2.stroke()
    ctx2.fillText('Other(cash)',768,590+(26*1))
    extend=0
    exceeded_digit=add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].section_total).toString().length
    if (exceeded_digit==4){extend=4
    }else if(exceeded_digit==5){extend=6
    }else if(exceeded_digit==6){extend=10 
    }else if(exceeded_digit==7){extend=14}
    ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[1].section_total)}`,918-extend,590+(26*1))
    ctx2.beginPath()
    ctx2.moveTo(764,600+(26*1))
    ctx2.lineTo(964,600+(26*1))
    ctx2.stroke()
    ctx2.fillText('Credit and Rent',768,590+(26*2))
    extend=0
    exceeded_digit=add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].section_total).toString().length
    if (exceeded_digit==4){extend=4
    }else if(exceeded_digit==5){extend=6
    }else if(exceeded_digit==6){extend=10 
    }else if(exceeded_digit==7){extend=14}
    ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].section_total)}`,918-extend,590+(26*2))
    ctx2.lineWidth=2
    ctx2.beginPath()
    ctx2.moveTo(764,600+(26*2))
    ctx2.lineTo(964,600+(26*2))
    ctx2.stroke()
    ctx2.fillText('Total',768,590+(26*3))
    ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[expenseSelectedItem].total)}`,918-extend,590+(26*3))
    // ctx2.lineWidth=1
    // ctx2.beginPath()
    // ctx2.moveTo(764,600+(26*3))
    // ctx2.lineTo(964,600+(26*3))
    // ctx2.stroke()
    // ctx2.fillText('Budget Max-line',768,590+(26*4))
    // extend=0
    // exceeded_digit=add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].section_total).toString().length
    // if (exceeded_digit==4){extend=4
    // }else if(exceeded_digit==5){extend=6
    // }else if(exceeded_digit==6){extend=10 
    // }else if(exceeded_digit==7){extend=14}
    // ctx2.fillText('¥50,000',918-extend,590+(26*4))
    // ctx2.moveTo(764,600+(26*4))
    // ctx2.lineTo(964,600+(26*4))
    // ctx2.stroke()
    // ctx2.fillText('Result',768,590+(26*5))
    // extend=0
    // exceeded_digit=add1M1KSprt(userFinance[0].expense[expenseSelectedItem].detail[2].section_total).toString().length
    // if (exceeded_digit==4){extend=4
    // }else if(exceeded_digit==5){extend=6
    // }else if(exceeded_digit==6){extend=10 
    // }else if(exceeded_digit==7){extend=14}
    // ctx2.fillText('-¥20,752',918-extend,590+(26*5))
  }
  const onClick2ExpensePrint=()=>{
    const tmp1_1=document.getElementById('tmp1')
    const tmp2_1=document.getElementById('tmp2')
    const tmp1_2=document.createElement('canvas')
    const tmp2_2=document.createElement('canvas')
    // tmp1_2.height=396.96
    // tmp1_2.width=561.12
    // tmp2_2.height=396.96
    // tmp2_2.width=561.12
    tmp1_2.height=793.92
    tmp1_2.width=1122.24
    tmp2_2.height=793.92
    tmp2_2.width=1122.24
    var ctx1=tmp1_2.getContext('2d') 
    ctx1.canvas.width=1122.24*2
    ctx1.canvas.height=793.92*2
    ctx1.setTransform(.5, 0, 0, .5, 0, 0)
    ctx1.drawImage(tmp1_1,0,0,1122.24*4,793.92*4)
    var ctx2=tmp2_2.getContext('2d') 
    ctx2.canvas.width=1122.24*2
    ctx2.canvas.height=793.92*2
    ctx2.setTransform(.5, 0, 0, .5, 0, 0)
    ctx2.drawImage(tmp2_1,0,0,1122.24*4,793.92*4)
    tmp1_2.toBlob(async(x1) =>{
        let x2=await toBase64(x1)
        x2=x2.split(',')[1]
        tmp2_2.toBlob(async(x4)=>{
            let x5=await toBase64(x4)
            x5=x5.split(',')[1]
            try{
                const { data: res } = await axios.post(`${APIURL}/asset/pdf`,{'png1':x2.toString(),'png2':x5.toString()})
                console.log('get pdf')
                toExpenseUrl(res.pdf)
                }catch(err){
                console.log(err)
                }
        }, 'image/png')
    }, 'image/png')
  }
  const onClick2ExpensePrintAll=async()=>{
    setExpensePrintLoading2(true)
      let pngall={'png1':'','png2':''}
      for(let i=0;i<userFinance[0].expense.length;i++){
          var tmp1_1=document.getElementById('tmp1')
          tmp1_1.height=793.92*4
          tmp1_1.width=1122.24*4
          var ctx1=tmp1_1.getContext('2d')
          ctx1.scale(4, 4)
          ctx1.setTransform(4,0,0,4,0,0)
          ctx1.fillStyle='black'
          ctx1.font = 'bold 24px Bitter'
          // section1 header
          // bold texts w h
          ctx1.fillText('Dev Cookbooks',70,124)
          ctx1.font='bold 18px Bitter'
          ctx1.fillText(`${userInfo.firstname} ${userInfo.lastname}`,540,120)
          ctx1.fillText('Ashley Lee(AI Agent)',766,120)
          //tiny texts
          ctx1.font='normal 12px Bitter'
          ctx1.fillText('prepared for:',540,90)
          ctx1.fillText('Monthly Expense Overview:',540,140)
          ctx1.fillText(stringDate(userFinance[0].expense[i].date),540,166)
          ctx1.fillText('prepared by:',766,90)
          ctx1.fillText('Investment Advisor',766,140)
          ctx1.fillText('Wealth Management',766,156)
          //section2 items
          //bold texts w h
          ctx1.font='normal 20px Bitter'
          ctx1.fillText('Food',70,240)
          ctx1.fillText('Other',70,440)
          ctx1.fillText('Credit and Rent',70,656)
          ctx1.fillText('Monthly Expense',540,440)
          //tiny texts
          ctx1.font='normal 9px Bitter'
          ctx1.fillText('Categories',70,280)
          ctx1.fillText('Budget min',200,280)
          ctx1.fillText('Budget max',280,280)
          ctx1.fillText('Value',380,280)
          ctx1.fillText('Result',468,280)
          ctx1.fillText('Categories',70,474)
          ctx1.fillText('Budget min',200,474)
          ctx1.fillText('Budget max',280,474)
          ctx1.fillText('Value',380,474)
          ctx1.fillText('Result',468,474)
          ctx1.fillText('Categories',70,676)
          ctx1.fillText('Budget min',200,676)
          ctx1.fillText('Budget max',280,676)
          ctx1.fillText('Value',380,676)
          ctx1.fillText('Result',468,676)
          ctx1.fillText('Must',70,304)
          ctx1.fillText('For Pantry',70,324)
          ctx1.fillText('Sweets&Snacks',70,346)
          ctx1.fillText('Veggies',70,368)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[0].category_total),380,304)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[1].category_total),380,324)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[2].category_total),380,346)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[3].category_total),380,368)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].section_total),380,390)
          ctx1.fillText('Work',70,498)
          ctx1.fillText('Hungout',70,518)
          ctx1.fillText('Bettre me',70,540)
          ctx1.fillText('Emergency',70,560)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[0].category_total),380,498)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[1].category_total),380,518)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[2].category_total),380,540)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[3].category_total),380,560)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].section_total),380,584)
          ctx1.fillText('Credit',70,702)
          ctx1.fillText('Result',70,724)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[2].detail[0].category_total),380,702)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[2].detail[1].category_total),380,724)
          ctx1.fillText(add1M1KSprt(userFinance[0].expense[i].detail[2].section_total),380,748)
          //section3 pie
          ctx1.beginPath()
          ctx1.fillStyle='#1C2041'
          ctx1.fillRect(852,266,10,10)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.fillStyle='#606278'
          ctx1.fillRect(852,290,10,10)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.fillStyle='#76788A'
          ctx1.fillRect(852,316,10,10)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.fillStyle='#D9D9D9'
          ctx1.fillRect(852,340,10,10)
          ctx1.stroke()
          // ctx1.beginPath()
          // ctx1.fillStyle='#D9D9D9'
          // ctx1.arc(720,300,70,0,2*Math.PI)
          // ctx1.stroke()
          const data=[{label:pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[0].category,value:Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl3)*100),color:'#0F1336'},{label:pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[1].category,value:Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl3)*100),color:'#606278'},{label:pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[2].category,value:Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl-x1.ttl)[2].ttl)/pie_ttl3)*100),color:'#76788A'},{label:'Other',value:Math.floor((pie_others3/pie_ttl3)*100),color:'#D9D9D9'}]
          const total=data.reduce((x,i)=>x+i.value,0)||1
          const cx=720
          const cy=300
          const r=Math.min(180,180)/2*0.9
          let st=-Math.PI/2
          data.forEach((x) => {
            const end=st+((x.value/total)*Math.PI*2)
            ctx1.beginPath()
            ctx1.moveTo(cx,cy)
            ctx1.arc(cx,cy,r,st,end);
            ctx1.closePath();
            ctx1.fillStyle = x.color||'#999'
            ctx1.fill()
            st=end
          })
          ctx1.beginPath()
          ctx1.fillStyle='black'
          ctx1.font = 'normal 11px Bitter'
          ctx1.fillText(`${(pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[0].category).toUpperCase()} ${Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[0].ttl)/pie_ttl3)*100)}%`,870,276)
          ctx1.fillText(`${(pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[1].category).toUpperCase()} ${Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[1].ttl)/pie_ttl3)*100)}%`,870,300)
          ctx1.fillText(`${(pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[2].category).toUpperCase()} ${Math.floor(((pie_item3.sort((x1,x2)=>x2.ttl - x1.ttl)[2].ttl)/pie_ttl3)*100)}%`,870,326)
          ctx1.fillText(`OTHERS ${Math.floor((pie_others3/pie_ttl3)*100)}%`,870,350)
          //section4 graph 
          ctx1.font = 'normal 9px Bitter'
          ctx1.fillText('Total Expense(JPY)',726,722)
          ctx1.fillText('Jan',622,700)
          ctx1.fillText('Feb',652,700)
          ctx1.fillText('Mar',682,700)
          ctx1.fillText('Apr',712,700)
          ctx1.fillText('May',742,700)
          ctx1.fillText('Jun',772,700)
          ctx1.fillText('Jul',802,700)
          ctx1.fillText('Aug',832,700)
          ctx1.fillText('Sep',862,700)
          ctx1.fillText('Oct',892,700)
          ctx1.fillText('Nov',922,700)
          ctx1.fillText('Dec',956,700)
          ctx1.fillText(`${sym()}${add1M1KSprt((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)}`,600-(((`${sym()}${add1M1KSprt((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)}`).length-2)*4.2),511)
          ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*4)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*4)}`).length-2)*4.2),546)
          ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*3)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*3)}`).length-2)*4.2),583)
          ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*2)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5*2)}`).length-2)*4.2),619)
          ctx1.fillText(`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5)}`,600-(((`${sym()}${add1M1KSprt(((Math.floor((Math.max(...userFinance[0].expense.filter(x1=>x1.date.slice(0,4)==userFinance[0].expense[expenseSelectedItem].date.slice(0,4)).map(x2=>x2.total)))/10000)+1)*10000)/5)}`).length-2)*4.2),655)
          ctx1.fillText(`${sym()}0`,600,684)
          //graph bar x y w h 
          // y=0%:682 50% 100%506 
          // h=0%:1 50%: 100%:178
          function bar(x1,x2){
              if(userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[i].date.slice(0,4)).filter(x4=>x4.date.slice(5,7)==x2)!=''){
                  ctx1.fillRect(x1,508+(176-userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[i].date.slice(0,4)).filter(x4=>x4.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[i].date.slice(0,4)).map(x4=>x4.total)))/10000)+1)*10000)*176),16,userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[i].date.slice(0,4)).filter(x4=>x4.date.slice(5,7)==x2)[0].total/((Math.floor((Math.max(...userFinance[0].expense.filter(x3=>x3.date.slice(0,4)==userFinance[0].expense[i].date.slice(0,4)).map(x4=>x4.total)))/10000)+1)*10000)*176)
              }
          }
          //1
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Jan'?'#76788A':'#C7C7C7'}`
          bar(626,'01')
          ctx1.stroke()
          //2 0% y:506+178 h:1
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Feb'?'#76788A':'#C7C7C7'}`
          bar(656,'02')
          ctx1.stroke()
          //3 10% y:506+89 h:89
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Mar'?'#76788A':'#C7C7C7'}`
          bar(686,'03')
          ctx1.stroke()
          //4 20%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Apr'?'#76788A':'#C7C7C7'}`
          bar(716,'04')
          ctx1.stroke()
          //5 30% y:506+89 h:89
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='May'?'#76788A':'#C7C7C7'}`
          ctx1.fillRect(746,508+(176-36),16,36)//16,100
          bar(808,'05')
          ctx1.stroke()
          //6 40%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Jun'?'#76788A':'#C7C7C7'}`
          ctx1.fillRect(776,508+(176-58),16,58)
          bar(808,'06')
          ctx1.stroke()
          //7 50% y:506+89 h:89
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Jul'?'#76788A':'#C7C7C7'}`
          bar(808,'07')
          ctx1.stroke()
          //8 60%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Aug'?'#76788A':'#C7C7C7'}`
          bar(838,'08')
          ctx1.stroke()
          //9 70%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Sep'?'#76788A':'#C7C7C7'}`
          bar(866,'09')
          ctx1.stroke()
          //10 80%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Oct'?'#76788A':'#C7C7C7'}`
          bar(896,'10')
          ctx1.stroke()
          //11 90%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Nov'?'#76788A':'#C7C7C7'}`
          bar(926,'11')
          ctx1.stroke()
          //12 100%
          ctx1.beginPath()
          ctx1.fillStyle=`${stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)=='Dec'?'#76788A':'#C7C7C7'}`
          bar(958,'12')
          ctx1.stroke()
          //graph lines
          ctx1.beginPath()
          ctx1.moveTo(620,508)
          ctx1.lineTo(980,508)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(620,544)
          ctx1.lineTo(980,544)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(620,580)
          ctx1.lineTo(980,580)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(620,616)
          ctx1.lineTo(980,616)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(620,652)
          ctx1.lineTo(980,652)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(620,684)
          ctx1.lineTo(980,684)
          ctx1.stroke()
          //bold texts
          //tiny texts
          //lines
          ctx1.beginPath()
          ctx1.moveTo(70, 198)
          ctx1.lineTo(980, 198)
          ctx1.stroke()
          //1 
          ctx1.beginPath()
          ctx1.lineWidth=2
          ctx1.moveTo(70, 286)
          ctx1.lineTo(500, 286)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.lineWidth=1
          ctx1.moveTo(70,310)
          ctx1.lineTo(500,310)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(70,330)
          ctx1.lineTo(500,330)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(70,354)
          ctx1.lineTo(500,354)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.lineWidth=2
          ctx1.moveTo(70, 376)
          ctx1.lineTo(500, 376)
          ctx1.stroke()
          //2
          ctx1.beginPath()
          ctx1.lineWidth=2
          ctx1.moveTo(70,480)
          ctx1.lineTo(500,480)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.lineWidth=1
          ctx1.moveTo(70,502)
          ctx1.lineTo(500,502)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(70,524)
          ctx1.lineTo(500,524)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.moveTo(70,546)
          ctx1.lineTo(500,546)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.lineWidth=2
          ctx1.moveTo(70,568)
          ctx1.lineTo(500,568)
          ctx1.stroke()
          //3
          ctx1.beginPath()
          ctx1.lineWidth=2
          ctx1.moveTo(70,684)
          ctx1.lineTo(500,684)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.lineWidth=1
          ctx1.moveTo(70,710)
          ctx1.lineTo(500,710)
          ctx1.stroke()
          ctx1.beginPath()
          ctx1.lineWidth=2
          ctx1.moveTo(70,730)
          ctx1.lineTo(500,730)
          ctx1.stroke()
          //monthly expense
          ctx1.beginPath()
          ctx1.lineWidth=1
          ctx1.moveTo(540,412)
          ctx1.lineTo(980,412)
          ctx1.stroke()
          var tmp2_1=document.getElementById('tmp2')
          tmp2_1.height=793.92*4
          tmp2_1.width=1122.24*4
          var ctx2=tmp2_1.getContext('2d')
          ctx2.scale(4, 4)
          ctx2.setTransform(4,0,0,4,0,0)
          ctx2.fillStyle='black'
          ctx2.font='bold 24px Bitter'
          //section1 header
          //bold texts w h
          //tiny texts
          //section2 items
          //bold texts w h
          //ttl
          ctx2.font='bold 10px Bitter'
          ctx2.fillText('Detail: Food',92,142)
          ctx2.fillText('Detail: Other(cash)',92,348)
          ctx2.fillText('Detail: Credit and Rent',92,560)
          ctx2.font = 'normal 9px Bitter'
          //1
          ctx2.fillText('Must',96,174)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(92,184)
          ctx2.lineTo(296,184)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[0].detail[0].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[0].detail[0].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[0].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[0].detail[0].items[i].name)}x${userFinance[0].expense[i].detail[0].detail[0].items[i].amount}`,96,202+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[0].items[i].price),260-extend,202+(26*i))
                  if(i!=userFinance[0].expense[i].detail[1].detail[0].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(92,210+(26*i))
                  ctx2.lineTo(296,210+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[0].category_total.toString().length
                  if (exceeded_digit==4){extend=14
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',96,202+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[0].detail[0].category_total)}`,260-extend,202+(26*i))
              }
          }
          //2
          ctx2.fillText('For Pantry',318,174)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(314,184)
          ctx2.lineTo(518,184)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[0].detail[1].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[0].detail[1].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[1].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[0].detail[1].items[i].name)}x${userFinance[0].expense[i].detail[0].detail[1].items[i].amount}`,318,204+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[1].items[i].price),474-extend,204+(26*i))
                  if(i!=userFinance[0].expense[i].detail[0].detail[1].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(314,210+(26*i))
                  ctx2.lineTo(518,210+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[1].category_total.toString().length
                  if (exceeded_digit==4){extend=14
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',318,204+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[0].detail[1].category_total)}`,474-extend,204+(26*i))
              }
          }
          // 3
          ctx2.fillText('Sweets',542,174)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(538,184)
          ctx2.lineTo(738,184)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[0].detail[2].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[0].detail[2].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[2].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[0].detail[2].items[i].name)}x${userFinance[0].expense[i].detail[0].detail[2].items[i].amount}`,542,204+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[2].items[i].price),704-extend,204+(26*i))
                  if(i!=userFinance[0].expense[i].detail[0].detail[2].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(538,210+(26*i))
                  ctx2.lineTo(738,210+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[2].category_total.toString().length
                  if (exceeded_digit==4){extend=14
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',542,204+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[0].detail[2].category_total)}`,704-extend,204+(26*i))
              }
          }
          //4
          ctx2.fillText('Veggies',772,174)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(768,184)
          ctx2.lineTo(968,184)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[0].detail[3].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[0].detail[3].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[3].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[0].detail[3].items[i].name)}x${userFinance[0].expense[i].detail[0].detail[3].items[i].amount}`,772,204+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[0].detail[3].items[i].price),924-extend,204+(26*i))
                  if(i!=userFinance[0].expense[i].detail[0].detail[3].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(768,210+(26*i))
                  ctx2.lineTo(968,210+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[0].detail[3].category_total.toString().length
                  if (exceeded_digit==4){extend=14
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',772,204+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[0].detail[3].category_total)}`,916-extend,204+(26*i))
              }
          }
          ctx2.fillText('Work',92,382)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(92,392)
          ctx2.lineTo(296,392)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[1].detail[0].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[1].detail[0].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[0].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[1].detail[0].items[i].name)}x${userFinance[0].expense[i].detail[1].detail[0].items[i].amount}`,92,408+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[0].items[i].price),260-extend,408+(26*i))
                  if(i!=userFinance[0].expense[i].detail[1].detail[0].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(92,416+(26*i))
                  ctx2.lineTo(296,416+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[0].category_total.toString().length
                  if (exceeded_digit==4){extend=10
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',92,412+(24*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[1].detail[0].category_total)}`,260-extend,412+(24*i))
              }
          }
          ctx2.fillText('Hangout',314,382)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(314,392)
          ctx2.lineTo(514,392)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[1].detail[1].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[1].detail[1].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[1].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[1].detail[1].items[i].name)}x${userFinance[0].expense[i].detail[1].detail[1].items[i].amount}`,314,408+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[1].items[i].price),474-extend,408+(26*i))
                  if(i!=userFinance[0].expense[i].detail[1].detail[1].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(314,416+(26*i))
                  ctx2.lineTo(514,416+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[1].category_total.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',314,408+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[1].detail[1].category_total)}`,464-extend,408+(26*i))
              }
          }
          ctx2.fillText('Better me',538,382)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(538,392)
          ctx2.lineTo(738,392)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[1].detail[2].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[1].detail[2].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[2].items[i].price.toString().length
                  if (exceeded_digit==4){extend=6
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[1].detail[2].items[i].name)}x${userFinance[0].expense[i].detail[1].detail[2].items[i].amount}`,538,408+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[2].items[i].price),704-extend,408+(26*i))
                  if(i!=userFinance[0].expense[i].detail[1].detail[2].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(538,416+(26*i))
                  ctx2.lineTo(738,416+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[2].category_total.toString().length
                  if (exceeded_digit==4){extend=14
                  }else if(exceeded_digit==5){extend=18}
                  ctx2.fillText('Total',538,408+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[1].detail[2].category_total)}`,704-extend,408+(26*i))
              }
          }
          ctx2.fillText('Emergency',768,382)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(768,392)
          ctx2.lineTo(968,392)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[1].detail[3].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[1].detail[3].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[3].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[1].detail[3].items[i].name)}x${userFinance[0].expense[i].detail[1].detail[3].items[i].amount}`,768,408+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[1].detail[3].items[i].price),924-extend,408+(26*i))
                  if(i!=userFinance[0].expense[i].detail[1].detail[3].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(768,416+(26*i))
                  ctx2.lineTo(968,416+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[1].detail[3].category_total.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',768,408+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[1].detail[3].category_total)}`,918-extend,408+(26*i))
              }
              
          }
          // ctx2.fillText('XXX',534,462)
          // for(let i=0;i<userFinance[0].expense[i].detail[2].detail[2].items.length;i++){
          //     let extend=0
          //     const exceeded_digit=userFinance[0].expense[i].detail[2].detail[2].items[i].price.toString().length
          //     if (exceeded_digit==4){extend=4
          //     }else if(exceeded_digit==5){extend=14}
          //     ctx2.fillText(`${userFinance[0].expense[i].detail[2].detail[2].items[i].name}x${userFinance[0].expense[i].detail[2].detail[2].items[i].amount}`,534,490+(20*i))
          //     ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[2].detail[2].items[i].price),698-extend,490+(20*i))
          // }
          // ctx2.fillText('Total',534,592)
          // ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[2].detail[2].category_total)}`,676,592)
      
          ctx2.fillText('Credit',92,590)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(92,600)
          ctx2.lineTo(296,600)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[2].detail[0].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[2].detail[0].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[2].detail[0].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[2].detail[0].items[i].name)}x${userFinance[0].expense[i].detail[2].detail[0].items[i].amount}`,92,618+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[2].detail[0].items[i].price),260-extend,618+(26*i))
                  if(i!=userFinance[0].expense[i].detail[2].detail[0].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(92,628+(26*i))
                  ctx2.lineTo(296,628+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[2].detail[0].category_total.toString().length
                  if (exceeded_digit==4){extend=10
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',92,618+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[2].detail[0].category_total)}`,260-extend,618+(26*i))
              }
          }
          ctx2.fillText('Rent',314,590)
          ctx2.beginPath() 
          ctx2.lineWidth=2
          ctx2.moveTo(314,600)
          ctx2.lineTo(514,600)
          ctx2.stroke()
          for(let i=0;i<userFinance[0].expense[i].detail[2].detail[1].items.length+1;i++){
              let extend=0
              if(i!=userFinance[0].expense[i].detail[2].detail[1].items.length){
                  const exceeded_digit=userFinance[0].expense[i].detail[2].detail[1].items[i].price.toString().length
                  if (exceeded_digit==4){extend=4
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText(`${turncated(userFinance[0].expense[i].detail[2].detail[1].items[i].name)}x${userFinance[0].expense[i].detail[2].detail[1].items[i].amount}`,314,618+(26*i))
                  ctx2.fillText(add1M1KSprt(userFinance[0].expense[i].detail[2].detail[1].items[i].price),474-extend,618+(26*i))
                  if(i!=userFinance[0].expense[i].detail[2].detail[1].items.length-1){
                      ctx2.lineWidth=1
                  }else{
                      ctx2.lineWidth=2
                  }
                  ctx2.beginPath() 
                  ctx2.moveTo(314,628+(26*i))
                  ctx2.lineTo(514,628+(26*i))
                  ctx2.stroke()
              }else{
                  const exceeded_digit=userFinance[0].expense[i].detail[2].detail[1].category_total.toString().length
                  if (exceeded_digit==4){extend=14
                  }else if(exceeded_digit==5){extend=14}
                  ctx2.fillText('Total',314,618+(26*i))
                  ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[2].detail[1].category_total)}`,464-extend,618+(26*i)) //5digit
              }
          }
          //5
          ctx2.fillText('Food',768,590)
          let extend=0
          let exceeded_digit=userFinance[0].expense[i].detail[0].section_total.toString().length
          if (exceeded_digit==4){extend=4
          }else if(exceeded_digit==5){extend=6
          }else if(exceeded_digit==6){extend=10 
          }else if(exceeded_digit==7){extend=14}
          ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[0].section_total)}`,918-extend,590)
          ctx2.lineWidth=1
          ctx2.beginPath()
          ctx2.moveTo(764,600)
          ctx2.lineTo(964,600)
          ctx2.stroke()
          ctx2.fillText('Other(cash)',768,590+(26*1))
          extend=0
          exceeded_digit=add1M1KSprt(userFinance[0].expense[i].detail[1].section_total).toString().length
          if (exceeded_digit==4){extend=4
          }else if(exceeded_digit==5){extend=6
          }else if(exceeded_digit==6){extend=10 
          }else if(exceeded_digit==7){extend=14}
          ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[1].section_total)}`,918-extend,590+(26*1))
          ctx2.beginPath()
          ctx2.moveTo(764,600+(26*1))
          ctx2.lineTo(964,600+(26*1))
          ctx2.stroke()
          ctx2.fillText('Credit and Rent',768,590+(26*2))
          extend=0
          exceeded_digit=add1M1KSprt(userFinance[0].expense[i].detail[2].section_total).toString().length
          if (exceeded_digit==4){extend=4
          }else if(exceeded_digit==5){extend=6
          }else if(exceeded_digit==6){extend=10 
          }else if(exceeded_digit==7){extend=14}
          ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].detail[2].section_total)}`,918-extend,590+(26*2))
          ctx2.lineWidth=2
          ctx2.beginPath()
          ctx2.moveTo(764,600+(26*2))
          ctx2.lineTo(964,600+(26*2))
          ctx2.stroke()
          ctx2.fillText('Total',768,590+(26*3))
          ctx2.fillText(`${sym()}${add1M1KSprt(userFinance[0].expense[i].total)}`,918-extend,590+(26*3))
          ctx2.lineWidth=1
          ctx2.beginPath()
          ctx2.moveTo(764,600+(26*3))
          ctx2.lineTo(964,600+(26*3))
          ctx2.stroke()
          ctx2.fillText('Budget Max-line',768,590+(26*4))
          extend=0
          exceeded_digit=add1M1KSprt(userFinance[0].expense[i].detail[2].section_total).toString().length
          if (exceeded_digit==4){extend=4
          }else if(exceeded_digit==5){extend=6
          }else if(exceeded_digit==6){extend=10 
          }else if(exceeded_digit==7){extend=14}
          ctx2.fillText('¥50,000',918-extend,590+(26*4))
          ctx2.moveTo(764,600+(26*4))
          ctx2.lineTo(964,600+(26*4))
          ctx2.stroke()
          ctx2.fillText('Result',768,590+(26*5))
          extend=0
          exceeded_digit=add1M1KSprt(userFinance[0].expense[i].detail[2].section_total).toString().length
          if (exceeded_digit==4){extend=4
          }else if(exceeded_digit==5){extend=6
          }else if(exceeded_digit==6){extend=10 
          }else if(exceeded_digit==7){extend=14}
          ctx2.fillText('-¥20,752',918-extend,590+(26*5))
          const tmp1_2=document.createElement('canvas')
          const tmp2_2=document.createElement('canvas')
          tmp1_2.height=793.92
          tmp1_2.width=1122.24
          tmp2_2.height=793.92
          tmp2_2.width=1122.24
          var ctx1=tmp1_2.getContext('2d') 
          ctx1.canvas.width=1122.24*2
          ctx1.canvas.height=793.92*2
          ctx1.setTransform(.5, 0, 0, .5, 0, 0)
          ctx1.drawImage(tmp1_1,0,0,1122.24*4,793.92*4)
          var ctx2=tmp2_2.getContext('2d') 
          ctx2.canvas.width=1122.24*2
          ctx2.canvas.height=793.92*2
          ctx2.setTransform(.5, 0, 0, .5, 0, 0)
          ctx2.drawImage(tmp2_1,0,0,1122.24*4,793.92*4)
          tmp1_2.toBlob(async(x1) =>{
              let x2=await toBase64(x1)
              x2=x2.split(',')[1]
              tmp2_2.toBlob(async(x4)=>{
                  let x5=await toBase64(x4)
                  x5=x5.split(',')[1]
                  pngall[`png${(2*(i+1))-1}`]=x2
                  pngall[`png${2*(i+1)}`]=x5
              }, 'image/png')
          }, 'image/png')
      }
     setTimeout(async() => {
            try{
                const { data: res } = await axios.post(`${APIURL}/asset/pdfall`,pngall)
                toExpenseUrlAll(res.pdf)
                }catch(err){
                console.log(err)
            }
            setExpensePrintLoading2(false)
      },9000)
  }
  const page_list=[
    {
        ttl:'asset',
        content:<div className='flex justify-between w-full'>
    {userFinance==''?<div className='text-[12px] mt-[24px] bitter ml-[20px]'><p className='flex text-xs'>Please wait for 5seconds<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p></div>:
      <>
      <div className='ml-[16px] w-[90px] mr-[16px]'>
      <b className='bitter'>Backlog:</b>
      <div className='cursor-default hover:font-bold font-bold'>{userFinance[0].income.length==0?<div className='font-normal'>-</div>:<>{userFinance[0].income[0].date.slice(0,4)}-{userFinance[0].income[userFinance[0].income.length-1].date.slice(0,4)}</>}</div>
      </div>
      {userFinance[0].asset.length==0?'':
      <div className='w-full'>
        <div className='w-fit bitter'><div className='text-[9px]'>{userFinance[0].income[0].date.slice(0,4)}-{userFinance[0].income[userFinance[0].income.length-1].date.slice(0,4)}</div><div className='leading-[1] text-[24px] mb-[4px]'>{sym()}{add1M1KSprt(calcAssetTtl(userFinance[0].asset[0].detail.filter(x=>x.category!='Fixed Income').map(x=>x.total_return)))}</div>
        </div>
        <div className='w-fit'>
        <div className='max-w-[640px] flex md:justify-end'>
            {/* mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px] */}
            <div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={()=>setUploadMenu1(!uploadMenu1)}>Upload</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2Json}>Download</div>{assetEditMenu1?<><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2AssetCancel}>Cancel</div><button className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] bg-[#414c74] hover:bg-[#365c88]' onClick={onClick2AssetSave}>Save</button></>:<button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] bg-[#414c74] hover:bg-[#365c88]`} onClick={onClick2AssetEdit}>Edit</button>}<div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] mr-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setAssetDeleteMenu1(!assetDeleteMenu1)}>Reset</div>
        </div>
        <div className='mt-[6px] max-w-[640px] flex justify-end'><div className='mr-[4px] w-fit'>Updated Date:{userFinance[0].asset[0].date}</div><div className='flex w-fit relative'>Currency:{assetEditMenu1?<><div className='w-[26px] border border-gray-800 cursor-default' onClick={()=>setAssetEditMenu2(!assetEditMenu2)}>{userFinance[0].asset[0].currency}</div>{assetEditMenu2?<div className='flex-cols border border-gray-800 absolute bg-white top-[17px] left-[50.4px] w-[26px]'>{curr.map(x=><div onClick={()=>onClick2AssetCurr(x)} className='cursor-default hover:bg-gray-100'>{x.name}</div>)}</div>:''}</>:<>{userFinance[0].asset[0].currency}</>}</div>
        </div>
        <>
            {assetEditMenu1?<>
            <div className='grid grid-cols-3 sm:grid-cols-5 border-b-[1px] border-gray-800 max-w-auto sm:max-w-[460px] mb-[1px]'>
                <div className='w-[120px]'>Category</div>
                <div className='w-[72px] mr-[24px]'>Purchased Price</div>
                <div className='w-[72px] mr-[24px]'>Sold Price</div>
                <div className='w-[52px] mr-[24px]'>Return Rate</div>
                <div className='w-[72px]'>Total Return</div>
            </div>
            <div className='grid grid-cols-3 sm:grid-cols-5 border-gray-800 max-w-[460px] border-gray-800 border-b-[1px] flex justify-between'>
            <div className='w-[120px]'>
                {assetEdit[0].detail.filter(x1=>x1.category!='Fixed Income').map(x2=><div className='leading-[1.8]'>{x2.category}</div>)}
            </div>
            <div className='text-right w-[72px] mr-[24px]'>
                {assetEdit[0].detail.filter(x1=>x1.category!='Fixed Income').map((x2,i2)=><><input onChange={(x)=>onChange2AssetInput(x,i2)} name='purchased_price' value={x2.purchased_price} className='text-right w-[70px] mr-[2px] border-[1px] border-gray-800 mb-[1px]'/></>)}
            </div>
            <div className='text-right w-[72px] mr-[24px]'>
                {assetEdit[0].detail.filter(x1=>x1.category!='Fixed Income').map((x2,i2)=><><input onChange={(x)=>onChange2AssetInput(x, i2)} name='sold_price' value={x2.sold_price} className='text-right w-[70px] mr-[2px] border-[1px] border-gray-800 mb-[1px]'/></>)}
            </div>
            <div className='text-right w-[52px] mr-[24px]'>
                {assetEdit[0].detail.filter(x1=>x1.category!='Fixed Income').map(x2=><div className='leading-[1.8]'>{x2.sold_price!=0?<>{Math.floor((((x2.sold_price-x2.purchased_price)/x2.purchased_price)*10000))/10000}</>:'-'}%</div>)}
            </div>
            <div className='text-right w-[72px]'>
                {assetEdit[0].detail.filter(x1=>x1.category!='Fixed Income').map(x2=><div className='leading-[1.8]'>{x2.sold_price!=0?<>{add1M1KSprt(Number(x2.sold_price)-Number(x2.purchased_price))}</>:'-'}</div>)}
            </div>
            </div>
            <div className='max-w-auto sm:max-w-[460px] flex justify-between'>
            <div>Total Return</div>
            <div className='text-right mr-[2px]'>{sym()}{add1M1KSprt(calcAssetTtl(assetEdit[0].detail.filter(x1=>x1.category!='Fixed Income'&&x1.sold_price!=0).map(x2=>Number(x2.sold_price)-Number(x2.purchased_price))))}</div>
            </div>
            </>:<>
            <div className='border-b-[1px] border-gray-800 max-w-auto sm:max-w-[460px] grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5'>
                <div className='w-[120px]'>Category</div>
                <div className='w-[72px] mr-[24px]'>Purchased Price</div>
                <div className='w-[72px] mr-[24px]'>Sold Price</div>
                <div className='w-[52px] mr-[24px]'>Return Rate</div>
                <div className='w-[72px]'>Total Return</div>
            </div>
            <div className='max-w-auto sm:max-w-[460px] border-gray-800 border-b-[1px] grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5'>
            <div className='w-[120px]'>
                {userFinance[0].asset[0].detail.map(x=><>{x.category=='Fixed Income'?'':<div>{x.category}</div>}</>)}
            </div>
            <div className='text-right w-[72px] mr-[24px]'>
                {userFinance[0].asset[0].detail.map(x=><>{x.category=='Fixed Income'?'':<div>{add1M1KSprt(x.purchased_price)}</div>}</>)}
            </div>
            <div className='text-right w-[72px] mr-[24px]'>
                {userFinance[0].asset[0].detail.map(x=><>{x.category=='Fixed Income'?'':<div>{add1M1KSprt(x.sold_price)}</div>}</>)}
            </div>
            <div className='text-right w-[52px] mr-[24px]'>
               {userFinance[0].asset[0].detail.map(x=><>{x.category=='Fixed Income'?'':<>{x.sold_price!=0?<div>{x.return_rate}%</div>:<div>- %</div>}</>}</>)}
            </div>
            <div className='w-[72px]'>
                {userFinance[0].asset[0].detail.map(x=><>{x.category=='Fixed Income'?'':<>{x.sold_price!=0?<div className='text-right mr-[4px]'>{add1M1KSprt(x.total_return)}</div>:<div className='ml-auto w-[10px]'>-</div>}</>}</>)}
            </div>
            </div>
            <div className='w-auto sm:w-[460px] '>
            <div>Total Return</div>
            <div className='text-right mr-[4px]'>{sym()}{add1M1KSprt(calcAssetTtl(userFinance[0].asset[0].detail.filter(x=>x.category!='Fixed Income').map(x=>x.total_return)))}</div>
            </div>
            </>}
        </>
        </div>
        <br/>
        {exp_yrs_list_calc()}
        {asset_pie_calc()}
        <div className='max-w-auto sm:max-w-[562px] flex flex-col mb-[2px] mt-[20px]'>
        <div className='w-full'>  
        <div className='w-full flex justify-between flex-col sm:flex-row'>
        {assetPdfType!='asset_ddmmyyyy.pdf'?<>
        <div onClick={onClick2AssetLoadPdf} className='cursor-default flex bitter text-[12px] mr-[2px] mt-[3px] font-bold'>Filename: {assetPdfType}<div className='mt-[2px]'><MdAutorenew className={`${assetPrintLoading?'icon-routine-loader':''}`}/></div></div>
        </>:<div className='mt-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mb-[1px]' onClick={onClick2AssetLoadPdf}>Generate PDF</div>}
        </div>
        </div>
        </div> 
        <div className='h-[150px] sm:h-[397.8px] max-w-auto sm:max-w-[562px] relative'>
        <canvas  width='4224' height='3302.4' id='tmp4' className={`w-full h-auto sm:w-[1122.24px] sm:h-[793.92px] absolute top-[-64px] sm:top-[-199px] left-[-103px] sm:left-[-281px] scale-[.5] z-[2] ${assetPdfType!='asset_ddmmyyyy.pdf'?'border border-gray-800':''}`}></canvas>
        </div>
        <div className='w-[195px] sm:w-[562px]'>
        {assetPdfType!='asset_ddmmyyyy.pdf'?<div className='ml-auto w-fit mt-auto'>
        <button onClick={onClick2AssetPrint} className='text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] mb-[2px] mr-[1px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter'>Print</button></div>:''}
        </div><br/><br/>
        </div>
      }
      </>
      }
       </div>
    },
    {
        ttl:'income',
        content:<>
        <div className='flex justify-between w-full'>
        {userFinance==''?<div className='text-[12px] mt-[24px] bitter ml-[20px]'>{msg}Please create your account and subscribe premium or dev premium.</div>:
        <>
        <div className='ml-[16px] w-[90px] mr-[16px]'>
        <b className='bitter'>Backlog:</b>
        <div className='max-h-[200px] overflow-y-scroll'>
        {userFinance[0].income.length==0?<div className='cursor-default'>-</div>:<>{userFinance[0].income.map((x,i)=><div><button className={`cursor-default  ${!incomeEditMenu1?'hover:font-bold':''} ${incomeSelectedItem==i?'font-bold':''}`} onClick={()=>onClick2IncomePageContent(i)} disabled={incomeEditMenu1}>{x.date.slice(0,4)}</button></div>)}</>}
        </div>
        <button onClick={()=>setIncomeAddMenu1(!incomeAddMenu1)} className={`${(userInfo.membership=='free'||userInfo.membership=='')&&userFinance[0].income.length>0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'} ml-[20px] text-[12px] h-[18px] mt-[4px] pl-[6px] pr-[6px] pt-[0px] pb-[8px] flex text-white cursor-default w-fit`} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&userFinance[0].income.length>0}>+</button>
        </div>
        {userFinance[0].income.length==0?'': 
        <div className='w-full'>
        <>{incomeEditMenu1?<>{userFinance[0].income.length==0?'no item':<>
        <div className='w-fit bitter'><div className='text-[9px]'>Jan-Dec {userFinance[0].income[incomeSelectedItem].date.slice(0,4)}</div><div className='leading-[1] text-[24px] mb-[4px]'>{curr.filter(x=>x.name==incomeEdit[0].currency)[0].symbol}{add1M1KSprt(calcIncomeTtl(incomeEdit[0].detail[0].salary.map(x1=>x1.items.map(x2=>x2.value)).flat())+calcIncomeTtl(incomeEdit[0].detail[0].bonus.map(x1=>x1.items.map(x2=>x2.value)).flat()))}</div>
        </div>
        <div className='w-fit'> 
        <div className='flex justify-end'>
        <div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={()=>setUploadMenu1(!uploadMenu1)}>Upload</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2Json}>Download</div>{incomeEditMenu1?<><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2IncomeCancel}>Cancel</div><button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] ${(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2IncomeSave} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0}>Save</button></>:<button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] ${(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2IncomeEdit} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0}>Edit</button>}<div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] mr-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setIncomeDeleteMenu1(!incomeDeleteMenu1)}>Delete</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setIncomeDeleteMenu2(!incomeDeleteMenu2)}>Delete All</div>
        </div>
        <div className='mt-[6px] flex justify-end'><div className='mr-[4px] w-fit'>Publish Date:{userFinance[0].income[incomeSelectedItem].date}</div>
        <div className='flex w-fit relative'>Currency:{incomeEditMenu1?<><div className='w-[26px] border border-gray-800 cursor-default' onClick={()=>setIncomeEditMenu2(!incomeEditMenu2)}>{userFinance[0].income[incomeSelectedItem].currency}</div>{incomeEditMenu2?<div className='flex-cols border border-gray-800 absolute bg-white top-[17px] left-[50.4px] w-[26px]'>{curr.map(x=><div onClick={()=>onClick2IncomeCurr(x)} className='cursor-default hover:bg-gray-100'>{x.name}</div>)}</div>:''}</>:<>{userFinance[0].income[incomeSelectedItem].currency}</>}</div>
        </div>
        <div className='max-w-[940px] grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid gap-[10px] '>
        {userFinance[0].income[incomeSelectedItem].detail[0].salary.map((x1,i1)=>
        <div className='w-[300px]'>
        <div className='font-bold text-[14px] mb-[12px]'>{stringDate(x1.date).slice(0,3)}</div>
        <div className='font-bold border-b-[2px] border-gray-800 flex text-[8px]'>
        <div className='w-[120px] mb-[2px]'>Categories</div>
        <div className='w-[36px]'>Hours</div>
        <div className='w-[30px] pl-[2px]'>Rate</div>
        <div className='w-[60px] pl-[16px]'>Deduction</div>
        <div className='w-[60px] pl-[16px]'>Earning</div>
        </div>
        <>{x1.items.map((x2,i2)=><>
        <div className={`${i2==x1.items.length-1?'border-b-[2px]':'border-b-[1px]'} border-gray-800 flex text-[9px]`}>
        <div className='w-[120px] text-[8px] pt-[4px] pb-[2px]'>{x2.category}</div>
       <>{x2.category=='Overwork'?<><input className='mt-[1px] mb-[1px] mr-[1px] border-[.2px] border-gray-800 w-[30px] text-right text-[8px]' onChange={(x)=>onChange2IncomeSalaryInput(x,i1,i2)} name='hours' value={x2.hours} /></>:<div className='w-[30px]'></div>}</>
       <>{x2.category=='Overwork'?<><input className='mt-[1px] mb-[1px] mr-[1px] border-[.2px] border-gray-800 w-[40px] text-right text-[8px]' onChange={(x)=>onChange2IncomeSalaryInput(x,i1,i2)} name='rate' value={x2.rate} /></>:<div className='w-[30px]'></div>}</>
       <>{x2.category=='Tax Deduction'||x2.category=='Other Deduction'?<><input className='mt-[1px] mb-[1px] ml-[20px] border-[.2px] border-gray-800 w-[50px] text-right text-[8px]' onChange={(x)=>onChange2IncomeSalaryInput(x,i1,i2)} name='value' value={x2.value} /></>:<div className='w-[60px]'></div>}</>
       <>{x2.category!='Tax Deduction'&&x2.category!='Other Deduction'?<><input className='mt-[1px] mb-[1px] ml-auto mr-[4px] border-[.2px] border-gray-800 w-[50px] text-right text-[8px]' onChange={(x)=>onChange2IncomeSalaryInput(x,i1,i2)} name='value' value={x2.value} /></>:<div className='w-[60px]'></div>}</>
        </div>
        </>)}</>
        <div className='text-right text-[12px] pr-[4px]'>
        {curr.filter(x=>x.name==incomeEdit[0].currency)[0].symbol}{add1M1KSprt(calcIncomeTtl(x1.items.map(x2=>x2.value)))}
        </div>
        </div>)}
        {userFinance[0].income[incomeSelectedItem].detail[0].bonus.map((x1,i1)=>
        <div className='w-[300px]'>
        <div className='font-bold text-[14px] mb-[12px]'>Bonus {i1+1}</div>
        <div className='font-bold border-b-[2px] border-gray-800 flex text-[8px]'>
        <div className='w-[120px] mb-[2px]'>Categories</div>
        <div className='w-[36px]'></div>
        <div className='w-[30px] pl-[2px]'></div>
        <div className='w-[60px] pl-[16px]'>Deduction</div>
        <div className='w-[60px] pl-[16px]'>Earning</div>
        </div>
        <>{x1.items.map((x2,i2)=><>
        <div className={`${i2==x1.items.length-1?'border-b-[2px]':'border-b-[1px]'} border-gray-800 flex text-[9px]`}>
        <div className='w-[120px] text-[8px] pt-[4px] pb-[2px]'>{x2.category}</div>
       <>{x2.category=='Overwork'?<><input className='mt-[1px] mb-[1px] mr-[1px] border-[.2px] border-gray-800 w-[30px] text-right text-[8px]' onChange={(x)=>onChange2IncomeBonusInput(x,i1,i2)} name='hours' value={x2.hours} /></>:<div className='w-[30px]'></div>}</>
       <>{x2.category=='Overwork'?<><input className='mt-[1px] mb-[1px] mr-[1px] border-[.2px] border-gray-800 w-[40px] text-right text-[8px]' onChange={(x)=>onChange2IncomeBonusInput(x,i1,i2)} name='rate' value={x2.rate} /></>:<div className='w-[30px]'></div>}</>
       <>{x2.category=='Tax Deduction'||x2.category=='Other Deduction'?<><input className='mt-[1px] mb-[1px] ml-[20px] border-[.2px] border-gray-800 w-[50px] text-right text-[8px]' onChange={(x)=>onChange2IncomeBonusInput(x,i1,i2)} name='value' value={x2.value} /></>:<div className='w-[60px]'></div>}</>
       <>{x2.category!='Tax Deduction'&&x2.category!='Other Deduction'?<><input className='mt-[1px] mb-[1px] ml-auto mr-[4px] border-[.2px] border-gray-800 w-[50px] text-right text-[8px]' onChange={(x)=>onChange2IncomeBonusInput(x,i1,i2)} name='value' value={x2.value} /></>:<div className='w-[60px]'></div>}</>
        </div>
        </>)}</>
        <div className='text-right text-[12px] pr-[4px]'>
        {curr.filter(x=>x.name==incomeEdit[0].currency)[0].symbol}{add1M1KSprt(calcIncomeTtl(x1.items.map(x2=>x2.value)))}
        </div>
        </div>)}
        </div>

        </div>

        <div className='max-w-[940px]'>
        <div className='text-right text-[14px] mr-[10px]'>
        {curr.filter(x=>x.name==incomeEdit[0].currency)[0].symbol}{add1M1KSprt(calcIncomeTtl(incomeEdit[0].detail[0].salary.map(x1=>x1.items.map(x2=>x2.value)).flat())+calcIncomeTtl(incomeEdit[0].detail[0].bonus.map(x1=>x1.items.map(x2=>x2.value)).flat()))}
        </div>
        </div>
        </>}</>:<>

        {userFinance[0].income.length==0?'no item':<>
        <div className='w-fit bitter'><div className='text-[9px]'>Jan-Dec {userFinance[0].income[incomeSelectedItem].date.slice(0,4)}</div><div className='leading-[1] text-[24px] mb-[4px]'>{curr.filter(x=>x.name==userFinance[0].income[incomeSelectedItem].currency)[0].symbol}{add1M1KSprt(userFinance[0].income[incomeSelectedItem].total)}</div>
        </div>
        <div className='w-fit'> 
        <div className='max-w-[940px] flex justify-end'>
        <div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={()=>setUploadMenu1(!uploadMenu1)}>Upload</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2Json}>Download</div>{incomeEditMenu1?<><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2IncomeCancel}>Cancel</div><button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] ${(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2IncomeSave} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0}>Save</button></>:<button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] ${(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2IncomeEdit} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&incomeSelectedItem!=0}>Edit</button>}<div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] mr-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setIncomeDeleteMenu1(!incomeDeleteMenu1)}>Delete</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setIncomeDeleteMenu2(!incomeDeleteMenu2)}>Delete All</div>
        </div>
        <div className='mt-[6px] max-w-[940px] flex justify-end'><div className='mr-[4px] w-fit'>Publish Date:{userFinance[0].income[incomeSelectedItem].date}</div>
        <div className='flex w-fit relative'>Currency:{incomeEditMenu1?<><div className='w-[26px] border border-gray-800 cursor-default' onClick={()=>setIncomeEditMenu2(!incomeEditMenu2)}>{userFinance[0].income[incomeSelectedItem].currency}</div>{incomeEditMenu2?<div className='flex-cols border border-gray-800 absolute bg-white top-[17px] left-[50.4px] w-[26px]'>{curr.map(x=><div onClick={()=>onClick2IncomeCurr(x)} className='cursor-default hover:bg-gray-100'>{x.name}</div>)}</div>:''}</>:<>{userFinance[0].income[incomeSelectedItem].currency}</>}</div>
        </div>
        <div className='grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid gap-x-[10px] flex gap-y-[30px]'>
        {userFinance[0].income[incomeSelectedItem].detail[0].salary.map((x1)=>
        <div className='w-[300px]'>
        <div className='font-bold text-[14px] mb-[12px]'>{stringDate(x1.date).slice(0,3)}</div>
        <div className='font-bold border-b-[2px] border-gray-800 flex text-[8px]'>
        <div className='w-[120px] mb-[2px]'>Categories</div>
        <div className='w-[36px]'>Hours</div>
        <div className='w-[30px] pl-[2px]'>Rate</div>
        <div className='w-[60px] pl-[16px]'>Deduction</div>
        <div className='w-[60px] pl-[16px]'>Earning</div>
        </div>
        <>{x1.items.map((x2,i2)=><>
        <div className={`${i2==x1.items.length-1?'border-b-[2px]':'border-b-[1px]'} border-gray-800 flex text-[9px]`}>
        <div className='w-[120px] text-[8px] pt-[4px] pb-[2px]'>{x2.category}</div>
        <div className='w-[36px] text-right text-[8px] pr-[14px]'>{x2.category=='Overwork'?<>{x2.hours}</>:''}</div>
        <div className='w-[30px] text-right text-[8px]'>{x2.category=='Overwork'?<>{add1M1KSprt(x2.rate)}</>:''}</div>
        <div className='w-[60px] text-right text-[8px]'>{x2.category=='Tax Deduction'||x2.category=='Other Deduction'?<>{add1M1KSprt(x2.value)}</>:''}</div>
        <div className='w-[60px] text-right text-[8px] pr-[4px]'>{x2.category!='Tax Deduction'&&x2.category!='Other Deduction'?<>{add1M1KSprt(x2.value)}</>:''}</div>
        </div>
        </>)}</>
        <div className='text-right font-bold text-[8px] pr-[4px]'>{curr.filter(x=>x.name==userFinance[0].income[incomeSelectedItem].currency)[0].symbol}{add1M1KSprt(x1.total)}
        </div>
        </div>)}
        {userFinance[0].income[incomeSelectedItem].detail[0].bonus.map((x1,i1)=>
        <div className='w-[300px]'>
        <div className='font-bold text-[14px] mb-[12px]'>Bonus {i1+1}</div>
        <div className='font-bold border-b-[2px] border-gray-800 flex text-[8px]'>
        <div className='w-[120px] mb-[2px]'>Categories</div>
        <div className='w-[36px]'></div>
        <div className='w-[30px] pl-[2px]'></div>
        <div className='w-[60px] pl-[16px]'>Deduction</div>
        <div className='w-[60px] pl-[16px]'>Earning</div>
        </div>
        <>{x1.items.map((x2,i2)=><>
        <div className={`${i2==x1.items.length-1?'border-b-[2px]':'border-b-[1px]'} border-gray-800 flex text-[9px]`}>
        <div className='w-[120px] text-[8px] pt-[4px] pb-[2px]'>{x2.category}</div>
        <div className='w-[36px] text-right text-[8px] pr-[14px]'></div>
        <div className='w-[30px] text-right text-[8px]'></div>
        <div className='w-[60px] text-right text-[8px]'>{x2.category=='Tax Deduction'||x2.category=='Other Deduction'?<>{add1M1KSprt(x2.value)}</>:''}</div>
        <div className='w-[60px] text-right text-[8px] pr-[4px]'>{x2.category!='Tax Deduction'&&x2.category!='Other Deduction'?<>{add1M1KSprt(x2.value)}</>:''}</div>
        </div>
        </>)}</>
        <div className='text-right font-bold text-[8px] pr-[4px]'>{curr.filter(x=>x.name==userFinance[0].income[incomeSelectedItem].currency)[0].symbol}{add1M1KSprt(x1.total)}
        </div>
        </div>)}
        </div>
        </div>
        </>}
        </>}
        {income_pie_calc()}
        <div className='max-w-auto sm:max-w-[562px] flex flex-col mb-[2px] mt-[20px]'>
        <div className='w-full'>  
        <div className='w-full flex justify-between flex-col sm:flex-row'>
        {incomePdfType!='income_yyyy.pdf'?<>
        <div onClick={onClick2IncomeLoadPdf} className='cursor-default flex bitter text-[12px] mr-[2px] mt-[3px] font-bold'>Filename: {incomePdfType}<div className='mt-[2px]'><MdAutorenew className={`${incomePrintLoading?'icon-routine-loader':''}`}/></div></div>
        </>:<div className='mt-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mb-[1px]' onClick={onClick2IncomeLoadPdf}>Generate PDF</div>}
        </div>
        </div>
        <div className='h-[200px] sm:h-[397.8px] max-w-auto sm:max-w-[562px] relative'>
        <canvas  width='4224' height='3302.4' id='tmp3' className={`w-full h-auto sm:w-[1122.24px] sm:h-[793.92px] absolute top-[-64px] sm:top-[-199px] left-[-103px] sm:left-[-281px] scale-[.5] z-[2] ${incomePdfType!='income_yyyy.pdf'?'border border-gray-800':''}`}></canvas></div>
        </div> 
        <div className='w-[260px] sm:w-[562px]'>
        {incomePdfType!='income_yyyy.pdf'?<div className='flex ml-auto w-fit mt-auto'>
        <button onClick={onClick2IncomePrint} className='mt-auto ml-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] mr-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter'>Print {userFinance[0].income[incomeSelectedItem].date.slice(0,4)}</button><button onClick={onClick2IncomePrintAll} className='mr-[2px] mt-auto ml-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter'>{incomePrintLoading?<div className='secondary-loader2 mt-[2px]'></div>:<>Print {userFinance[0].income[0].date.slice(0,4)}-{userFinance[0].income[userFinance[0].income.length-1].date.slice(0,4)}</>}</button></div>:''}
        </div>
        </></div>}</>}
        </div><br/><br/></>
    },
    {
        ttl:'expense',
        content:<>
        <div className='flex justify-between w-full'>
        {userFinance==''?<div className='text-[12px] mt-[24px] bitter ml-[20px]'>{msg}Please create your account and subscribe premium or dev premium.</div>:
        <>
        <div className='ml-[16px] w-[90px] mr-[16px]'>
        <b className='bitter'>Backlog:</b>
        <div className='max-h-[200px] overflow-y-scroll'>
        {userFinance[0].expense.length==0?<div className='cursor-default'>-</div>:<>{userFinance[0].expense.map((x,i)=><div><button className={`cursor-default  ${!expenseEditMenu1?'hover:font-bold':''} ${expenseSelectedItem==i?'font-bold':''}`} onClick={()=>onClick2ExpensePageContent(i)} disabled={expenseEditMenu1}>{x.date.slice(5,7)}{x.date.slice(0,4)}</button></div>)}</>}
        </div>
        <button onClick={()=>setExpenseAddMenu1(!expenseAddMenu1)} className={`${(userInfo.membership=='free'||userInfo.membership=='')&&userFinance[0].expense.length>0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'} ml-[20px] text-[12px] h-[18px] mt-[4px] pl-[6px] pr-[6px] pt-[0px] pb-[8px] flex text-white cursor-default w-fit`} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&userFinance[0].expense.length>0}>+</button>
        </div>
        {userFinance[0].expense.length==0?'no expense items':
        <div className='w-full'>
        <>{expenseEditMenu1?<>
        <div className='flex justify-between max-w-[640px]'>
            <div className='w-fit bitter'>
            <div className='text-[9px]'>{stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)} {userFinance[0].expense[expenseSelectedItem].date.slice(0,4)}</div><div className='text-[24px] mb-[4px] leading-[1]'>{curr.filter(x=>x.name==userFinance[0].expense[expenseSelectedItem].currency)[0].symbol}{add1M1KSprt(calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail.map(x2=>x2.detail.map(x3=>x3.items.map(x4=>x4.price))).flat().flat()))}</div>
            </div>
            <div className='mt-auto'>
                <button className='mt-auto mb-[1px] text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] text-white bg-[#414c74] hover:bg-[#365c88] cursor-default bitter mr-[2px]' onClick={()=>setUploadMenu1(!uploadMenu1)}>Upload</button>
                <button className='mt-auto mb-[1px] text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] text-white bg-[#414c74] hover:bg-[#365c88] cursor-default bitter mr-[2px]' onClick={onClick2Json}>Download</button>
                {expenseEditMenu1?<><button className='mt-auto mb-[1px] text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] text-white bg-[#414c74] hover:bg-[#365c88] cursor-default bitter mr-[2px]' onClick={onClick2ExpenseCancel}>Cancel</button>
                <button className={`inline w-[60px] mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] text-white cursor-default bitter mr-[2px] ${(userInfo.membership=='free'||userInfo.membership=='')&&expenseSelectedItem!=0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2ExpenseSave} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&expenseSelectedItem!=0}>Save</button></>:<button className={`inline w-[60px] mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] text-white cursor-default bitter mr-[2px] ${(userInfo.membership=='free'&&expenseSelectedItem!=0)||(userInfo.membership==''&&expenseSelectedItem!=0)?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2ExpenseEdit} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&expenseSelectedItem!=0}>Edit</button>}
                <button className='mt-auto mb-[1px] text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] mr-[2px] text-white bg-[#414c74] hover:bg-[#365c88] cursor-default bitter' onClick={()=>setExpenseDeleteMenu1(!expenseDeleteMenu1)}>Delete</button>
                <button className='mt-auto mb-[1px] text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] text-white bg-[#414c74] hover:bg-[#365c88] cursor-default bitter' onClick={()=>setExpenseDeleteMenu2(!expenseDeleteMenu2)}>Delete All</button>
            </div>
        </div>
        <div className='mt-[6px] max-w-[640px] flex justify-end'><div className='mr-[4px] w-fit'>Publish Date:{userFinance[0].expense[expenseSelectedItem].date}</div><div className='flex w-fit relative'>Currency:{expenseEditMenu1?<><div className='w-[26px] border border-gray-800 cursor-default' onClick={()=>setExpenseEditMenu2(!expenseEditMenu2)}>{userFinance[0].expense[expenseSelectedItem].currency}</div>{expenseEditMenu2?<div className='flex-cols border border-gray-800 absolute bg-white top-[17px] left-[50.4px] w-[26px]'>{curr.map(x=><div onClick={()=>onClick2ExpenceCurr(x)} className='cursor-default hover:bg-gray-100'>{x.name}</div>)}</div>:''}</>:<>{userFinance[0].expense[expenseSelectedItem].currency}</>}</div></div>
        {expenseEdit[0].detail.map((x1,i1)=><>
        <div className='mr-[8px]'>
        
        <div className='w-full flex justify-between'><div className='flex'>{i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?<div className='w-fit mt-auto mb-auto cursor-default pr-[4px]' onClick={()=>onClick2View(i1+1)}>-</div>:<div className='w-fit mt-auto mb-auto cursor-default pr-[4px]' onClick={()=>onClick2View(i1+1)}>+</div>}<div className='w-fit font-bold'>{x1.section}</div></div>{i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?'':<div className='mr-[42px] ml-auto text-right w-[40px]'>{add1M1KSprt(x1.section_total)}</div>}</div></div>
        <div className={`z-[${i1}] bg-white grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-[0px] ${expenseEditMenu1?'max-w-[320px] sm:max-w-[480px] md:max-w-[480px] lg:max-w-[660px]':'max-w-[626px]'} ${i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?'content-down-y':'content-up-y'}`}>
        {x1.detail.map((x2,i2)=><>
        <div className='w-fit'>
        <div><b>{x2.category}</b></div>
        <div className='w-fit mr-[8px]'>      
        <div>{x2.items.map((x3,i3)=><><div className='flex'><div><div className='leading-[1.2em] text-[6px]'>product name</div><input name='name' value={x3.name} onChange={(x)=>onChange2ExpenseInput(x,i1,i2,i3)} className='w-[80px] mr-[2px] border-[1px] border-gray-800'/></div><div><div className='leading-[1.2em] text-[6px]'>unit</div><input name='amount' value={x3.amount} onChange={(x)=>onChange2ExpenseInput(x,i1,i2,i3)} className='w-[20px] mr-[2px] border-[1px] border-gray-800 text-right'/></div><div><div className='leading-[1.2em] text-right text-[6px]'>total price</div><input name='price' value={x3.price} onChange={(x)=>onChange2ExpenseInput(x,i1,i2,i3)} className='text-right w-[44px] border-[1px] border-gray-800'/></div>{x2.items.length==1?'':<IoMdClose className='ml-[2px] text-[7px] mt-[12px]' onClick={()=>onClick2ExpenseRemove(i1,i2,i3)}/>}</div></>)}</div>
        {x2.items.length<5?<div className='h-[18px] cursor-default ml-auto w-fit mt-[6px] mr-[8px] text-gray-600 text-[8px]' onClick={()=>onClick2AddItem(i1,i2)}>+</div>:<div className='mb-[2px]'></div>}
        </div>
        <div className='w-[148px]'>
        <div className='border-t-[.2px] border-gray-800 flex justify-between'><div className='w-[80px]'></div><div className='w-[20px]'></div><div className='w-[50px] text-right'>{add1M1KSprt(calcExpenseTtl(x2.items.map(x3=>x3.price)))}</div></div></div>
        </div>
        </>)}
        </div>
        <div className={`${expenseEditMenu1?'max-w-[308px] sm:max-w-[468px] md:max-w-[468px] lg:max-w-[643px]':'max-w-[626px]'} border-t-[.2px] border-gray-800`}>
        <div className='ml-auto w-fit'>{i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?<>{add1M1KSprt(calcExpenseTtl(x1.detail.map(x2=>x2.items.map(x3=>x3.price)).flat().flat()))}</>:''}</div>
        </div>
        
        </>)}
        <div className={`${expenseEditMenu1?'max-w-[308px] sm:max-w-[468px] md:max-w-[468px] lg:max-w-[643px]':'max-w-[626px]'} mb-[12px]`}>
        <div className={`${expenseViewMenu3?'border-t-[.2px]':''} border-gray-800 ml-auto flex`}><div>Total:</div><div className='ml-auto'>{curr.filter(x=>x.name==expenseEdit[0].currency)[0].symbol}{add1M1KSprt(calcExpenseTtl(expenseEdit[0].detail.map(x2=>x2.detail.map(x3=>x3.items.map(x4=>x4.price))).flat().flat()))}</div></div></div>Memo<br/>
        <input name='memo' value={expenseEdit[0].memo} row='2' onChange={(x)=>onChange2ExpenseMemoInput(x)} className='pl-[2px] md:h-[20px] w-[440px] border-[1px] border-gray-800'/>
        </>
        :
        <>
        {/* <img src={PngImg1} className='w-[300px]'/> */}
        {userFinance[0].expense.length==0?'':<>
        <div className='w-fit bitter'><div className='text-[9px]'>{stringDate(userFinance[0].expense[expenseSelectedItem].date).slice(0,3)} {userFinance[0].expense[expenseSelectedItem].date.slice(0,4)}</div><div className='leading-[1] text-[24px] mb-[4px]'>{curr.filter(x=>x.name==userFinance[0].expense[expenseSelectedItem].currency)[0].symbol}{add1M1KSprt(calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail.map(x2=>x2.detail.map(x3=>x3.items.map(x4=>x4.price))).flat().flat()))}</div>
        </div>
        <div className='w-fit'>
        <div className='max-w-[640px] flex justify-end'>
            <div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={()=>setUploadMenu1(!uploadMenu1)}>Upload</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2Json}>Download</div>{expenseEditMenu1?<><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mr-[2px]' onClick={onClick2ExpenseCancel}>Cancel</div><button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] ${(userInfo.membership=='free'||userInfo.membership=='')&&expenseSelectedItem!=0?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2ExpenseSave} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&expenseSelectedItem!=0}>Save</button></>:<button className={`mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit bitter mr-[2px] ${(userInfo.membership=='free'&&expenseSelectedItem!=0)||(userInfo.membership==''&&expenseSelectedItem!=0)?'bg-gray-300':'bg-[#414c74] hover:bg-[#365c88]'}`} onClick={onClick2ExpenseEdit} disabled={(userInfo.membership=='free'||userInfo.membership=='')&&expenseSelectedItem!=0}>Edit</button>}<div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] mr-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setExpenseDeleteMenu1(!expenseDeleteMenu1)}>Delete</div><div className='mt-auto text-[11px] h-[20px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter' onClick={()=>setExpenseDeleteMenu2(!expenseDeleteMenu2)}>Delete All</div>
        </div> 
        <div className='mt-[6px] max-w-[640px] flex justify-end'><div className='mr-[4px] w-fit'>Publish Date:{userFinance[0].expense[expenseSelectedItem].date}</div><div className='flex w-fit relative'>Currency:{expenseEditMenu1?<><div className='w-[26px] border border-gray-800 cursor-default' onClick={()=>setExpenseEditMenu2(!expenseEditMenu2)}>{userFinance[0].expense[expenseSelectedItem].currency}</div>{expenseEditMenu2?<div className='flex-cols border border-gray-800 absolute bg-white top-[17px] left-[50.4px] w-[26px]'>{curr.map(x=><div onClick={()=>onClick2ExpenceCurr(x)} className='cursor-default hover:bg-gray-100'>{x.name}</div>)}</div>:''}</>:<>{userFinance[0].expense[expenseSelectedItem].currency}</>}</div>
        </div>  
        <div className='max-w-[644px] border-b-[1px] border-gray-800 flex justify-between'>
        <div className='text-[9px]'>Categories </div>
        <div>Budget min</div>
        <div>Budget max</div>
        <div>Value</div>
        <div>Result</div>
        </div>
        {userFinance[0].expense[expenseSelectedItem].detail.map((x1,i1)=><>
        <div>
        <div className='flex justify-between max-w-[200px] sm:max-w-[300px] md:max-w-[500px] lg:max-w-[643px] border-b-[.2px] border-gray-800'>
        <div className='flex '><div className='w-fit font-bold'>{x1.section}</div>{i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?<div className='w-fit mt-auto mb-auto cursor-default pr-[4px]' onClick={()=>onClick2View(i1+1)}><MdKeyboardArrowDown/></div>:<div className='w-fit mt-auto mb-auto cursor-default pr-[4px]' onClick={()=>onClick2View(i1+1)}><MdKeyboardArrowRight/></div>}</div>{i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?'':<div>{add1M1KSprt(calcExpenseTtl(x1.detail.map(x2=>x2.items.map(x3=>x3.price)).flat()))}</div>}</div>
        </div>
        <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[0px] max-w-[320px] sm:max-w-[300px] md:max-w-[500px] lg:max-w-[660px] ${x1.detail.map(x2=>x2.items).length==4?'justify-between':''} max-w-[640px] flex z-[${i1}] bg-white ${i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?'content-down-y':'content-up-y'}`}>
        {/* <div className={`z-[${i1}] bg-white grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-[0px] ${expenseEditMenu1?'max-w-[320px] sm:max-w-[480px] md:max-w-[480px] lg:max-w-[660px]':'max-w-[626px]'} ${i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?'content-down-y':'content-up-y'}`}> */}
        {x1.detail.map((x2,i2)=>
        <div className={`w-fit ${x1.detail.length-1!=i2?'mr-[8px]':''}`}><b>{x2.category}</b>
        <div>{x2.items.map(x3=><div className='flex border-b-[.2px] border-gray-800 justify-between'><div style={{overflowWrap:'break-word'}} className='w-[80px] wrap-break-word'>{x3.name}</div><div className='w-[20px] text-right'>{x3.amount}</div><div className='w-[50px] text-right'>{add1M1KSprt(x3.price)}</div></div>)}
        <div className='border-t-[.2px] border-gray-800 flex justify-between'><div className='w-[80px]'></div><div className='w-[20px]'></div><div className='w-[50px] text-right'>{add1M1KSprt(calcExpenseTtl(x2.items.map(x3=>x3.price)))}</div></div>
        </div>
        {x2.section_res}<br/>
        </div>)}

        </div>
        <div className='max-w-[200px] sm:max-w-[300px] md:max-w-[500px] lg:max-w-[643px] border-t-[.2px] border-gray-800 flex justify-end'>
        <div>{i1+1==1&&expenseViewMenu1||i1+1==2&&expenseViewMenu2||i1+1==3&&expenseViewMenu3?<>{add1M1KSprt(calcExpenseTtl(x1.detail.map(x2=>x2.items.map(x3=>x3.price)).flat().flat()))}</>:''}</div>
        </div>
        {/* <div className='mt-[16px] ml-auto w-fit'>
        <div className='font-bold'>Budget</div>
        <div className='flex justfy-between'><div className='w-[60px]'>min:</div><div className='text-right w-[40px]'>{x1.section_budget_min}</div></div>
        <div className='flex justfy-between'><div className='w-[60px]'>result:</div><div className='text-right w-[40px]'>{x1.section_res}</div></div></div>
        'max-w-[200px] sm:max-w-[300px] md:max-w-[500px] lg:max-w-[643px] border-t-[.2px] border-gray-800 flex justify-end
        */}
        </>)}
        <div className={`max-w-[200px] sm:max-w-[300px] md:max-w-[500px] lg:max-w-[643px] justify-between mb-[12px] ${expenseViewMenu3?'border-t-[.2px]':''} border-gray-800 flex`}><div>Total:</div><div>{curr.filter(x=>x.name==userFinance[0].expense[expenseSelectedItem].currency)[0].symbol}{add1M1KSprt(calcExpenseTtl(userFinance[0].expense[expenseSelectedItem].detail.map(x2=>x2.detail.map(x3=>x3.items.map(x4=>x4.price))).flat().flat()))}</div></div>
        Memo<br/>
        <div className='max-w-[560px]'>{userFinance[0].expense[expenseSelectedItem].memo}</div>
        </div>
        </>}
        </>
        
        }</>

        <div className='flex w-fit ml-auto'>
        {/* <button className='mr-[2px] hover:bg-gray-100 border border-gray-800 text-[12px] pl-[2px] pr-[2px]' onClick={()=>onClick2EncryptFile2()}>encrypt file</button> */}
        </div>
        {expense_pie_calc()}

        <div className='max-w-auto sm:max-w-[562px] flex flex-col mb-[2px] mt-[20px]'>
        <div className='w-full'>  
        <div className='w-full flex justify-between flex-col sm:flex-row'>
        {expensePdfType!='expense_mmyyyy.pdf'?<>
        <div onClick={onClick2ExpenseLoadPdf} className='cursor-default flex bitter text-[12px] mr-[2px] mt-[3px] font-bold'>Filename: {expensePdfType}<div className='mt-[2px]'><MdAutorenew className={`${expensePrintLoading?'icon-routine-loader':''}`}/></div></div>
        </>:<div className='mt-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter mb-[1px]' onClick={onClick2ExpenseLoadPdf}>Generate PDF</div>}
        </div>
        </div>
        <div className='h-[120px] sm:h-[397.8px] w-full sm:w-[562px] relative'>
        <canvas  width='4224' height='3302.4' id='tmp1' className={`w-full h-auto sm:w-[1122.24px] sm:h-[793.92px] absolute top-[-42px] sm:top-[-199px] left-[-80px] sm:left-[-281px] scale-[.5] z-[2] ${expensePdfType!='expense_mmyyyy.pdf'?'border border-gray-800':''}`}></canvas></div>
        <div className='h-[130px] sm:h-[397.8px] w-full sm:w-[562px] relative'>
        <canvas  width='4224' height='3302.4' id='tmp2' className={`w-full h-auto sm:w-[1122.24px] sm:h-[793.92px] absolute top-[-42px] sm:top-[-199px] left-[-80px] sm:left-[-281px] scale-[.5] z-[2] ${expensePdfType!='expense_mmyyyy.pdf'?'border border-gray-800':''}`}></canvas></div>
        {expensePdfType!='expense_mmyyyy.pdf'?<div className='sm:ml-auto w-fit mt-auto flex'>
        <button onClick={onClick2ExpensePrint} className='mt-auto ml-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] mr-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter'>{expensePrintLoading2?<div className='secondary-loader2 mt-[2px]'></div>:<>Print {userFinance[0].expense[expenseSelectedItem].date.slice(5,7)}{userFinance[0].expense[expenseSelectedItem].date.slice(0,4)}</>}</button><button onClick={onClick2ExpensePrintAll} className='mt-auto ml-auto text-[11px] h-[20px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#414c74] hover:bg-[#365c88] cursor-default w-fit bitter'>Print {userFinance[0].expense[0].date.slice(0,4)}-{userFinance[0].expense[userFinance[0].expense.length-1].date.slice(0,4)}</button></div>:''}
        {/* </div> */}
        </div> 
        </div>
        }
        </>
        }
        </div><br/><br/></>
    }
  ]
  return(
    <div className='text-[9px] w-full relative'>
    {/* popup general */}
    {uploadMenu1?<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'>
      <IoMdClose className='ml-auto mb-[4px]' onClick={()=>setUploadMenu1(!uploadMenu1)}/>
      <p className='raleway text-[8px] font-bold leading-[1.1em] mb-[2px]'>Please upload your devcookbooks finance json file.</p>
      <div className='relative'>
      {/* <div className='flex'>Date:<div className='cursor-default flex border-[.1px] border-gray-800 w-[58px] justify-between ml-[2px] pl-[4px]' onClick={()=>setUploadMenu2(!uploadMenu2)}>{expenseAdd.date==''?'Select':<>{expenseAdd.date.slice(0,4)} {expenseAdd.date.slice(5,7)}</>}<MdKeyboardArrowDown className='mt-auto mb-auto'/></div>
      </div> */}
      {/* {!expenseAddMenu2?'':<div className='absolute border-[.1px] border-gray-800 border-t-[0px] left-[25px] w-[58px] bg-white h-[90px] overflow-y-scroll'>{expenseAddOption.map((x)=><div value={x} className='cursor-default hover:bg-gray-200 pl-[4px]' onClick={()=>onClick2ExpenseSelect('date',x)}>{x.date.slice(0,4)} {x.date.slice(5,7)}</div>)}</div>} */}
    </div>
    <div className='border-dotted border-[1px] border-gray-800 w-[150px] bg-gray-100 hover:bg-blue-100' onDrop={onDrop2Upload} onDragOver={(e)=>e.preventDefault()}>
    <label htmlFor='upload'>
    <RiFileUploadLine className='mt-[8px] text-[#606278] text-[18px] m-auto'/>
    <div className='m-auto w-fit text-[6px] text-[#606278] font-bold '>Drag & drop file</div>
    <div className='border-[.1px] border-gray-800 mt-[16px] ml-auto mr-auto text-[9px] mt-[2px] pl-[4px] pr-[4px] pt-[0px] pb-[0px] flex bg-white hover:bg-gray-100 cursor-default w-fit mb-[4px]'><div></div>Select file</div><input id='upload' type='file' accept='.json' onChange={(e)=>onChange2Upload(e)} hidden multiple/>
    </label>
    </div>
    <p className='text-right text-red-800 raleway text-[6px] font-bold leading-[1.1em] mt-[2px]'>*Recommended: download and get backup first.</p>
    {uploadFile1.map((x,i)=>(<>{
        <div className='mb-1 flex w-full justify-between text-[9px]' key={i}><div>{x.filename}</div><div className='flex mt-auto mb-auto'><IoMdClose onClick={()=>onClick2UploadDel1(x.id)}/></div></div>}
    </>))}
    <button onClick={onClick2Upload} className={`mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default w-fit ${uploadFile1.length==0?'bg-gray-200':'bg-[#606278] hover:bg-[#6d6e7a]'}`} disabled={uploadFile1.length==0}>Apply</button>
    </div></>:''}
    {/* popup asset */}
    {assetDeleteMenu1?<>{userFinance[0].asset.length==0?'':<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'>
    <IoMdClose className='ml-auto mb-[4px]' onClick={()=>setAssetDeleteMenu1(!assetDeleteMenu1)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Are you sure to delete asset item {userFinance[0].income.length==0?<div className='font-normal'>-</div>:<>{userFinance[0].income[0].date.slice(0,4)}-{userFinance[0].income[userFinance[0].income.length-1].date.slice(0,4)}</>}?</p><br/><button onClick={onClick2AssetReset} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Reset</button></div></>}</>:''}
    {/* popup income */}
    {incomeAddMenu1?<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'><IoMdClose className='ml-auto mb-[4px]' onClick={()=>setIncomeAddMenu1(!incomeAddMenu1)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Please select a year to create data.</p><br/><div className='relative'><div className='flex'>Date:<div className='cursor-default flex border-[.1px] border-gray-800 w-[63px] justify-between ml-[2px] pl-[4px]' onClick={()=>setIncomeAddMenu2(!incomeAddMenu2)}>{incomeAdd.date==''?'Select':<>{incomeAdd.date.slice(0,4)}</>}<MdKeyboardArrowDown className='mt-auto mb-auto'/></div></div>{!incomeAddMenu2?'':<div className='absolute border-[.1px] border-gray-800 border-t-[0px] left-[25px] w-[63px] bg-white h-[90px] overflow-y-scroll'>{incomeAddOption.map((x)=><div value={x} className='cursor-default hover:bg-gray-200 pl-[4px]' onClick={()=>onClick2IncomeSelect('date',x)}>{x.date.slice(0,4)}</div>)}</div>}</div><button onClick={onClick2IncomeCreate} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Create</button></div></>:''}
   {incomeDeleteMenu1?<>{userFinance[0].income.length==0?'':<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'>
    <IoMdClose className='ml-auto mb-[4px]' onClick={()=>setIncomeDeleteMenu1(!incomeDeleteMenu1)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Are you sure to delete income({userFinance[0].income[incomeSelectedItem].date.slice(0,4)}) item?</p><br/><button onClick={onClick2IncomeDelete} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Delete</button></div></>}</>:''}
   {incomeDeleteMenu2?<>{userFinance[0].income.length==0?'':<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'>
    <IoMdClose className='ml-auto mb-[4px]' onClick={()=>setIncomeDeleteMenu2(!incomeDeleteMenu2)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Are you sure to delete all income items?</p><br/><button onClick={onClick2IncomeDeleteAll} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Delete All</button></div></>}</>:''}
    {/* popup expense */}
    {expenseAddMenu1?<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'><IoMdClose className='ml-auto mb-[4px]' onClick={()=>setExpenseAddMenu1(!expenseAddMenu1)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Please select year and month to create data.</p><br/><div className='relative'><div className='flex'>Date:<div className='cursor-default flex border-[.1px] border-gray-800 w-[64px] justify-between ml-[2px] pl-[4px]' onClick={()=>setExpenseAddMenu2(!expenseAddMenu2)}>{expenseAdd.date==''?'Select':<>{expenseAdd.date.slice(0,4)} {expenseAdd.date.slice(5,7)}</>}<MdKeyboardArrowDown className='mt-auto mb-auto'/></div></div>{!expenseAddMenu2?'':<div className='absolute border-[.1px] border-gray-800 border-t-[0px] left-[29.4px] w-[64px] bg-white h-[90px] overflow-y-scroll'>{expenseAddOption.map((x)=><div value={x} className='cursor-default hover:bg-gray-200 pl-[4px]' onClick={()=>onClick2ExpenseSelect('date',x)}>{x.date.slice(0,4)} {x.date.slice(5,7)}</div>)}</div>}</div><button onClick={onClick2ExpenseCreate} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Create</button></div></>:''}
   {expenseDeleteMenu1?<>{userFinance[0].expense.length==0?'':<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'>
    <IoMdClose className='ml-auto mb-[4px]' onClick={()=>setExpenseDeleteMenu1(!expenseDeleteMenu1)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Are you sure to delete expense({userFinance[0].expense[expenseSelectedItem].date.slice(0,7)}) item?</p><br/><button onClick={onClick2ExpenseDelete} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Delete</button></div></>}</>:''}
   {expenseDeleteMenu2?<>{userFinance[0].expense.length==0?'':<><div className='absolute z-[2] w-full h-[100vh] bg-gray-800 opacity-[.2]'></div><div className='left-[35%] top-[25vh] z-[3] absolute border-[.2px] border-gray-800 w-[180px] bg-white p-[12px]'>
    <IoMdClose className='ml-auto mb-[4px]' onClick={()=>setExpenseDeleteMenu2(!expenseDeleteMenu2)}/><p className='raleway text-[8px] font-bold leading-[1.1em]'>Are you sure to delete all expense items?</p><br/><button onClick={onClick2ExpenseDeleteAll} className='mt-[16px] ml-auto mr-auto text-[9px] h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white bg-[#606278] hover:bg-[#6d6e7a] cursor-default w-fit'>Delete All</button></div></>}</>:''}
    {/* popup asset */}
    <div className='border-b-[1px] border-gray-800'>
    <div className='text-[12px] flex'>
    
    {userInfo.membership!=''?<>{userInfo.membership!='free'?<span className={`ml-[4px] text-[9px] ${userInfo.membership=='premium'?'text-[#C2B067]':'text-[25deg,red_5%,yellow_60%,lime_90%,teal]'}`}>Your membership: {userInfo.membership}</span>:<div className='mt-[4px] ml-[4px] text-[12px]'>
    {/* <div>Your membership: free</div> */}
    <div className='bitter'>Your current membership: Premium</div>
    {/* text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-green-500 to-indigo-400 */}
    {/* <div className='cursor-default bitter border-[.2px] border-gray-800 hover:bg-gray-200 w-fit pt-[3px] pb-[2px] pr-[12px] pl-[4px] flex'><span className='hover:translate-x-1 flex'><MdKeyboardArrowRight className='m-auto'/>Membership Price List</span></div> */}
    <RouterLink className='cursor-default text-[12px] underline flex bitter w-fit hover:font-bold' to='/membership-price-list'>Membership Price List<MdKeyboardArrowRight className='ml-[-2px] mt-[4px]'/></RouterLink>
    <div className='bitter text-[9px] leading-[1.2] mb-[2px]'>You are accessing as a guest.<br/> To keep your data, please create your account. To create more than 1 item, please subscribe premium account.</div>
    </div>}</>:
    <div className='mt-[4px] ml-[4px] text-[12px]'>
    <div>Your membership: guest</div>
    {/* <div className='cursor-default bitter border-[.2px] border-gray-800 hover:bg-gray-200 w-fit pt-[3px] pb-[2px] pr-[12px] pl-[4px] mb-[4px] flex'><span className='hover:translate-x-1 flex'><MdKeyboardArrowRight className='m-auto'/>Create account</span></div>
    <div className='cursor-default bitter border-[.2px] border-gray-800 hover:bg-gray-200 w-fit pt-[3px] pb-[2px] pr-[12px] pl-[4px] flex'><span className='hover:translate-x-1 flex'><MdKeyboardArrowRight className='m-auto'/>Membership Price List</span></div> */}
    <RouterLink className='cursor-default text-[12px] underline flex bitter w-fit hover:font-bold' to='/signup'>Create account<MdKeyboardArrowRight className='ml-[-2px] mt-[4px]'/></RouterLink>
    <RouterLink className='cursor-default text-[12px] underline flex bitter w-fit hover:font-bold' to='/membership-price-list'>Membership Price List<MdKeyboardArrowRight className='ml-[-2px] mt-[4px]'/></RouterLink>
    <div className='bitter text-[9px] leading-[1.2] mb-[2px]'>You are accessing as a guest.<br/> To keep your data, please create your account. To create more than 1 item, please subscribe premium account.</div>
    </div>}
    </div>
    <div className='w-fit'>
    <h2 className='ml-[4px] text-lg structure__main__subttl'>{page}</h2>
    <div className='ml-[4px] flex w-fit justify-end'>
    {page_list.map((x,i1)=><div className={`cursor-default ${x.ttl==page?'font-bold':''} bitter text-[11px] ${i1!=page_list.length-1?'mr-[1em]':''}`} onClick={()=>setPage(x.ttl)}>{x.ttl}</div>)}
    </div> 
    </div>
    </div>
    <div className='sample-contents-container md:m-auto'>
    <div className='mt-[16px] sample-title-container'>
    {page_list.filter(x=>x.ttl==page)[0].content}
    </div>
    </div>
    </div>
  )
}